/* eslint-disable jsx-a11y/no-redundant-roles */
import React, { useEffect, useState, useMemo, useRef } from "react";
import { Link } from 'react-router-dom';
import { toPng } from 'html-to-image';
import { getAllCities } from "../../commons/activity-filters/Helpers";
import "./OrderPlan.css";
import Select from "../../components/Select/Select";
import html2canvas from 'html2canvas'
import { Modal, Alert, Toast, ToastContainer } from 'react-bootstrap'
import LoadingOverlay from "react-loading-overlay";
import dayjs from 'dayjs';
import 'dayjs/locale/nb'; // Import Norwegian locale file // Import dayjs


import {
    getFilters,
    getMinMax,
    getMinMax2,
    getBudget,
    getBudget2,
    getNumberOfPeopleOptions,
    getFilteredActivities,
    getLabelByValue,
    getValidActivities,
    getDescriptionByValue
} from "../../commons/activity-filters/Helpers";
import FetchService from "../../api/FetchService";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import ReactGA from "react-ga4";
import OrderPlanSearchResultCard from "../SearchResultCard/OrderPlanSearchResultCard ";
import OrderPlanSearchResultCardRemove from "../SearchResultCard/OrderPlanSearchResultCardRemove";
import CalenderComponent from "../CalenderComponent/CalenderComponent";
import TimeRangeSelector from "../TimeRangeSelector/TimeRangeSelector";
import CreateActivityModal from "./CreateActivityModal";

let filterModel = {
    category: "all",
    type: "all",
    city: "all",
    peopleNumber: "all",
    budget: "all",
};
function OrderPlan({ searchQuery, setSearchQuery, action, onChangeUpdate = null, isEditMode = null, onConfirm=null, onCancel=null, onSave = null, bookingName = null, triggerRequestBooking = null, onBookingUpdate = null, onBookingClose = null, EditData=null, ...props }) {
    const { action: routeAction } = useParams();
     action = action || routeAction; // ✅ prefer prop, fallback to route


    
    dayjs.locale('nb'); // Set the locale to Norwegian Bokmål

    let filter = JSON.parse(sessionStorage.getItem("filter"));

    let state = useLocation().state;
    const searchFilter = state ? state : filter;
    const [selectedDate, setSelectedDate] = useState(searchFilter?.selectedDate);
    const [selectedDateVELG, setSelectedDateVELG] = useState(null);

    const navigate = useNavigate();
    const locat = useLocation()
    const filters = getFilters();

    const [modalpart, setModalPart] = useState(true);
    const [bodypart, setBodyPart] = useState(true);
    const [bookingComplete, setBookingComplete] = useState(false);


    const [city, setCity] = useState(searchFilter?.city2);
    const [queryData, setQueryData] = useState([]);
    const [type, setType] = useState(searchFilter?.type);
    const [one, setOne] = useState(true);
    const [two, setTwo] = useState(false);
    const [four, setFour] = useState(false);
    const [six, setSix] = useState(false);
    const [twelve, setTwelve] = useState(false);
    const [gettedFromSession, setGettedFromSession] = useState(false)
    const [activityHover, setActivityHover] = useState();
    let categoryLabel =
        getLabelByValue(filters.categories, searchFilter?.category != "" && searchFilter?.category != undefined && searchFilter?.category != null ? searchFilter?.category : "gratis") ?? "";

    let categoryDescription = getDescriptionByValue(filters.categories, searchFilter?.category != "" ? searchFilter?.category : "gratis") ?? "";

    const category = searchFilter?.category ?? "";
    const [peopleNumber, setPeopleNumber] = useState(searchFilter?.peopleNumber);
    const [budget, setBudget] = useState(searchFilter?.budget);
    const [isScrolled, setIsScrolled] = useState(false);
    const [showCalender, setShowCalender] = useState(false);
    const [showCalenderVELG, setShowCalenderVELG] = useState(false);

    const [fromTime, setFromTime] = useState(null);
    const [toTime, setToTime] = useState(null);




    const [showModalVELG, setShowModalVELG] = useState(false);
    const [showModalRmv, setShowModalRmv] = useState(-1);

    const [openCircle, setOpenCircle] = useState(1);
    const [activities, setActivities] = useState([]);
    const [filteredActivities, setFilteredActivities] = useState([]);
    const [updateState, setUpdateState] = useState(-1);

    const [visible, setVisible] = useState(8);

    const [isLoading, setIsLoading] = useState(true);

    const [pageNumber, setPageNumber] = useState(1);
    const [activitiesCount, setActivitiesCount] = useState(0);

    const [totalPages, setTotalPages] = useState(0);

    const [isHovered, setIsHovered] = useState();

    const [text, setText] = useState(EditData?.BookingDataParent?.additionalInfo || '');

    // Separate properties for each form field
    const [companyName, setcompanyName] = useState('');
    const [organizationNumber, setorganizationNumber] = useState('');
    const [invoiceAddress, setinvoiceAddress] = useState('');
    const [invoiceSentTo, setinvoiceSentTo] = useState('');
    const [contactPerson, setcontactPerson] = useState('');
    const [invoiceNote, setinvoiceNote] = useState('');
    const [invoiceID, setinvoiceID] = useState('');
    const cities = getAllCities().filter(city => city.value !== "default" && city.value !== "digitalt");
    const [dbpageSize, setDbpageSize] = useState(8);
    const [recommendedAppData, setRecommendedAppData] = useState([]);  // ✅ Store page-wise activities
    const [subCategories, setSubCategories] = useState([]);
    const [selectedSubCategory, setSelectedSubCategory] = useState(null);

    //********************************* - Recommendation 2 System - ********************************************/
    const activityRules = [
        { activityCount: 2, maxCategories: 2 },
        { activityCount: 4, maxCategories: 2 },
        { activityCount: 6, maxCategories: 4 },
        { activityCount: 12, maxCategories: 4 }
    ];
    const [selectedActivityCount, setSelectedActivityCount] = useState(0);
    const [selectedSubCategoryList, setSelectedSubCategoryList] = useState([]);
    const [rmd2ChoicesSubmit, setRmd2ChoicesSubmit] = useState(false);

    const [recommendedAppData2, setRecommendedAppData2] = useState([]);  // ✅ Store page-wise activities
    const [recommendedOpenModals, setRecommendedOpenModals] = useState([]);
    
    const [recommendedOpenModalsPopup, setRecommendedOpenModalsPopup] = useState([]);


    const [recommendedOpenModalsSingleIndex, setRecommendedOpenModalsSingleIndex] = useState(null);

    const [currentModalIndex, setCurrentModalIndex] = useState(null); // Track the currently open modal

    const [prevRecommendation2Ref, setPrevRecommendation2Ref] = useState(null);


    const [recommend2fixedstack, setrecommend2fixedstack] = useState(null);
    const [recommend2fixedstackIndex, setrecommend2fixedstackIndex] = useState([]);
    const [isSessionLock, setIsSessionLock] = useState(false);
    const [mappedBookedActivity,setMappedBookingActivity] = useState([]);
    const [addSingleCustomModal, setAddSingleCustomModal] = useState(false);


    const [comments, setComments] = useState(null);



    // Open modal when parent sets triggerBookingModal = true
    useEffect(() => {
        if (triggerRequestBooking) {
            setShowModalReqBooking(true);
            setBodyPart(false);
        }
    }, [triggerRequestBooking]);




    // useEffect to react to changes in selectedActivityCount
    useEffect(() => {

        if (!isSessionLock) {
            // Create a new array with the specified count
            const newArray = Array.from({ length: selectedActivityCount }, () => ({
                date: '', // Initialize date as empty string
                count: 0, // Initialize count as 0
                index: null
            }));

            // Update the recommend2fixedstack state
            setrecommend2fixedstack(newArray);
            setrecommend2fixedstackIndex(0);
            setTotalPersons(1);
        }
   


    }, [selectedActivityCount]); // Dependency array: useEffect runs when selectedActivityCount changes

    useEffect(() => {
        if (recommendedAppData && recommendedAppData.length > 0) {
            let allPageActivities = [];

            recommendedAppData.forEach((recommendation) => {
                const startIndex = recommendation.startIndex;
                const endIndex = recommendation.endIndex;

                const pageActivities = startIndex < endIndex
                    ? recommendation.activities.slice(startIndex, endIndex)
                    : [
                        ...recommendation.activities.slice(startIndex),
                        ...recommendation.activities.slice(0, endIndex)
                    ];

                allPageActivities = [...allPageActivities, ...pageActivities];
            });

            setRecommendedOpenModals(allPageActivities);
        }
    }, [recommendedAppData]);  // 👈 runs only when data changes



    // Utility: Sort by addDate (ascending)
    const sortByAddDate = (arr) =>
        [...arr].sort((a, b) => new Date(a.addDate) - new Date(b.addDate));

    const handleDateChangeForModal = (activityId, newDate) => {
        // 1. Update the date for the correct activity
        const updatedModals = recommendedOpenModals.map(item =>
            item.id === activityId ? { ...item, addDate: newDate } : item
        );

        // 2. Sort by date
        const sortedArray = sortDataDate(updatedModals);

        // 3. Update recommendedOpenModals state with sorted array
        setRecommendedOpenModals(sortedArray);

        // 4. Update recommend2fixedstack to match the sorted activities
        setrecommend2fixedstack(prevStack => {
            if (!prevStack) return prevStack;
            const newStack = [...prevStack];
            const safeLength = Math.min(sortedArray.length, newStack.length);
            for (let i = 0; i < safeLength; i++) {
                newStack[i] = {
                    ...newStack[i],
                    date: sortedArray[i].addDate,
                    count: (sortedArray[i].totPersons ?? 0) + (sortedArray[i].minPerson ?? 0)
                };
            }
            return newStack;
        });
    };

    const sortDataDate = (data) => {
        const sortedActivities = [...data] // Create a copy to avoid mutating state
            .sort((a, b) => {
                const dateA = new Date(a.addDate);
                const dateB = new Date(b.addDate);

                // Fallback for invalid dates: Move them to the end
                if (isNaN(dateA.getTime())) return 1;
                if (isNaN(dateB.getTime())) return -1;

                return dateA - dateB;
            });

        return sortedActivities;
    };

    useEffect(() => {
        
        let sortedActivities = sortDataDate(recommendedOpenModals);

        // Create a map for quick lookup by id
        const activityMap = new Map(sortedActivities.map(act => [act.id, act]));
        // 1. Update and order widgets that are in sortedActivities
        const updatedAndSorted = sortedActivities.map(act => {
            const widgetObj = widget.find(w => w.id === act.id);
            return widgetObj ? { ...widgetObj, ...act } : null;
        }).filter(x=>x!=null);

        // 2. Add any widgets not in sortedActivities (preserve their order)
        const remainingWidgets = widget.filter(w => !sortedActivities.some(act => act.id === w.id));

        // 3. Combine
        const finalWidget = [...updatedAndSorted, ...remainingWidgets];

        setWidget(finalWidget);

        setRecommendedOpenModalsPopup(sortedActivities);
    }, [recommendedOpenModals]);



    // 2. Fix useEffect condition and dependencies
    useEffect(() => {
        if (!isSessionLock) {
            if (
                recommendedAppData.length === 0 &&
                recommendedOpenModalsPopup.length === 0

            ) {
                return;
            }
            else {
                saveRecommendSession();
            }


        }
    }, [recommendedAppData, recommendedOpenModalsPopup, isSessionLock]); // Include all dependencies




    const updateData = () => {
        
        // ✅ Deep clone (for objects/arrays)
        const updatedData = recommendedAppData.map(item => ({ ...item }));
        setRecommendedAppData(updatedData);


        const updatedData2 = recommendedAppData2.map(item => ({ ...item }));
        setRecommendedAppData2(updatedData2);


        const updatedModals = [...recommendedOpenModals];
        setRecommendedOpenModals(updatedModals); // New reference


        saveRecommendSession();

    };

    useEffect(() => {

        
        if (!isSessionLock) { 
        if (selectedActivityCount > 0 && selectedSubCategoryList.length > 0 && rmd2ChoicesSubmit) {
            
            handleResetRecommendation();
            const distributedActivities = distributeActivities(selectedActivityCount, selectedSubCategoryList.sort());
            setDbpageSize(distributedActivities[0].allocatedActivities); //set page size for each activities

            

            let updatedData = [];
            Promise.all(
                distributedActivities.map(({ categoryId, allocatedActivities }) => {

                    let filter = getRecommendationFilterModel(categoryId, distributedActivities[0].allocatedActivities);
                    filter.rowCountPerPage = allocatedActivities;
                    filter.pageNo = 1;
                   

                    return CallAplicationAPI(filter).then((data) => ({
                        categoryId,
                        pages: data.pages,
                        activities: data.updatedActivities,
                    }));
                })
            ).then((responses) => {
                let index_main = 0;

                let startIndex = 0;
                responses.forEach(({ categoryId, activities, pages }) => {

                    let endIndex = startIndex + activities.length;


                    activities.forEach((objA, index) => {
                        if (recommend2fixedstack[index_main]?.isCustomActivity) {
                            let newObj = {
                                id: Date.now(),
                                name: customActivity_Default.title,
                                price: Number(recommend2fixedstack[index_main].price),
                                minPerson: 1,
                                images: "[{\"imageURL\":\"{baseApiURL}/static/media/booking-confirmation-img.8df3502e7365d6433146.png\"}]",
                                totPersons: recommend2fixedstack[index_main].count - 1,
                                addDate: recommend2fixedstack[index].date,
                                date: recommend2fixedstack[index].date,
                                validPeriodStart: recommend2fixedstack[index].date,
                                validPeriodEnd: recommend2fixedstack[index].date,
                                description:"DENNE AKTIVITETEN OG ALLE DETALJENE RUNDT AKTIVITETEN ER LAGT TIL AV BRUKEREN SELV. DEN ER IKKE PLANLAGT ELLER ANSVARLIGGJORT AV FUNTLERS",
                                isCustomActivity: true,
                                fromTime: recommend2fixedstack[index].fromTime,
                                toTime: recommend2fixedstack[index].toTime
                            };

                            handleCustomActivityEmail(newObj);
                            activities.splice(index, 0, newObj); // <-- FIXED: removed ...newObj
                        }
                        index_main++;
                    });
                 



                    updatedData.push({
                        page: updatedData.length,
                        categoryId,
                        activities,
                        startIndex,
                        endIndex,
                        pageNumber: 1,
                        pageSize: distributedActivities[0].allocatedActivities,
                        totalPages: pages.totalPages,
                        total: pages.total
                    });

                });



                setRecommendedAppData2(updatedData);

                let filteredActivities = updatedData
                    .filter((obj) => obj.activities) // Ensure activities exist
                    .flatMap((obj, index1) =>
                        obj.activities.slice(obj.startIndex, obj.endIndex).map((activity, index2) => ({
                            ...activity, // Copy all activity properties
                            arrayIndex: index1 // Store indexes
                        }))
                    );


                // Create a new array with the specified count
                const newArray = filteredActivities.map((obj, index) => {
                    // Check if filteredActivities[index] exists

                    obj.addDate = recommend2fixedstack[index].date;
                    obj.totPersons = recommend2fixedstack[index].count - obj.minPerson;
                    obj.fromTime = recommend2fixedstack[index].fromTime;
                    obj.toTime = recommend2fixedstack[index].toTime;
                    recommend2fixedstack[index].index = obj.arrayIndex;

                    return obj;
                });


                

                setrecommend2fixedstack(recommend2fixedstack);

                setRecommendedOpenModals(newArray); // Open all modals
                setCurrentModalIndex(0);

            });
        } else {
            setRecommendedAppData2([]);
            setRecommendedOpenModals([]); // Open all modals

            }
        }
    }, [selectedSubCategoryList, selectedActivityCount, rmd2ChoicesSubmit]);

    useEffect(() => {
        if (selectedSubCategory && !isSessionLock) {
            handleResetRecommendation();
            let filter = getRecommendationFilterModel(selectedSubCategory, 4);
            filter.pageNo = 1;
            CallAplicationAPI(filter).then((data) => {
                let updatedActivities = data.updatedActivities;
                let pages = data.pages;
                setRecommendedAppData(prevData => {
                    {
                        // 🔹 First time: Set startIndex = 0 and endIndex = activities.length - 1
                        return [{
                            activities: updatedActivities,
                            startIndex: 0,
                            endIndex: updatedActivities.length,
                            pageSize: 4,
                            pageNumber: 1,
                            totalPages: pages.totalPages,
                            total: pages.total


                        }];
                    }
                });

            });
        }
        else {
            setIsLoading(false);

        }
    
    }, [selectedSubCategory])


    function canProceedCustomActivity({
        showCustomActivity,
        selectedDateVELG,
        recommend2fixedstack,
        recommend2fixedstackIndex,
        customActivity
    }) {
        
        let stackItem = {};
        stackItem.count = totalPersons;
        stackItem.date = selectedDateVELG;

        stackItem.fromTime = fromTime;
        stackItem.toTime = toTime;

        if (!stackItem) return false;

        if (!showCustomActivity && selectedDateVELG && stackItem.date && fromTime && toTime) {
           
            return true;
        } else if (
            showCustomActivity &&
            selectedDateVELG &&
            stackItem.date &&
            customActivity &&
            customActivity.price &&
            customActivity.title &&
            fromTime && toTime
        ) {
         
            return true;
        } else {
            return false;
        }
    }


    function canProceedCustomActivityModel(customActivity) {
         if (
            customActivity &&
            customActivity.date &&
            customActivity.price &&
            customActivity.title &&
             customActivity.antall &&
             fromTime &&
             toTime
        ) {
           
            return true;
        } else {
            return false;
        }
    }


    // Add these states at the top of your component
    const [CustomActivityModal, setCustomActivityModal] = useState();

    const [showCustomActivity, setShowCustomActivity] = useState(false);

    // At the top of your component
    const [customActivityDetails, setCustomActivityDetails] = useState(null);

    // Handler to open the modal
    const handleShowCustomActivityDetails = (activity) => {
        setCustomActivityDetails(activity);
    };

    // Handler to close the modal
    const handleCloseCustomActivityDetails = () => {
        setCustomActivityDetails(null);
    };

    const fallbackImage = "https://funtlers.com/static/media/booking-confirmation-img.8df3502e7365d6433146.png"; // Fallback image
    const  customActivity_Default = {
        title: "Skriv inn ønsket tittel",
        price: "",
        date: "",
        antall: "",
        kategori: "EGEN PLANLAGT AKTIVITET",
        picture: "/static/media/booking-confirmation-img.8df3502e7365d6433146.png" // Use your default image path
    };
    const [customActivity, setCustomActivity] = useState(customActivity_Default);


    // Handler for custom activity  add
    const handleCustomActivityAdd = () => {
        setFromTime(null);
        setToTime(null);
        setCustomActivityModal(customActivity_Default);
    };



    // Handler for custom activity field changes
    const handleCustomActivityChange = (field, value) => {
        setCustomActivity(prev => ({
            ...prev,
            [field]: value
        }));
    };



    // Function to handle saving and closing modals
    const handleSave = (currentObj, actindex, isAllowIncrement = true) => {

        
        currentObj.totPersons = totalPersons;
        currentObj.reason = comments;

        if (
            comments
        ) {
            setComments(null);
        }




        currentObj.addDate = selectedDateVELG;
        currentObj.fromTime = fromTime;
        currentObj.toTime = toTime;
        setTotalPersons(0);

        if (isAllowIncrement) {
            if (actindex == recommendedOpenModalsPopup.length - 1) {

                let liked = recommendedOpenModals.filter(x => x?.isVelgClick);
                let finalModal = [...liked, ...recommendedOpenModalsPopup];
                let updaterecommendedOpenModals = finalModal.sort((a, b) => new Date(a.addDate) - new Date(b.addDate));
                setRecommendedOpenModals(updaterecommendedOpenModals);

                setCurrentModalIndex(recommendedOpenModals.length);
                setRecommendedOpenModalsSingleIndex(null);

            }
            else {

                setCurrentModalIndex(actindex + 1);
                setRecommendedOpenModalsSingleIndex(null);
            }


   
        }
        else {
            setRecommendedOpenModalsSingleIndex(-1);
            setCurrentModalIndex(recommendedOpenModals.length);

            // 1. Sort the recommendedOpenModals array (fix spread operator misuse)
            const sortedArray = sortDataDate(recommendedOpenModals);

            // 2. Update recommendedOpenModals state with sorted array
            setRecommendedOpenModals(sortedArray);

            // 3. Create NEW array for recommend2fixedstack using previous state
            setrecommend2fixedstack(prevStack => {
                // Create a copy of the previous state to avoid mutation
                const newStack = [...prevStack];

                // Only process up to the minimum length of both arrays
                const safeLength = Math.min(sortedArray.length, newStack.length);

                for (let i = 0; i < safeLength; i++) {
                    // Update values from sorted array
                    newStack[i] = {
                        ...newStack[i], // Preserve other properties
                        date: sortedArray[i].addDate,
                        count: sortedArray[i].totPersons + sortedArray[i].minPerson,
                        fromTime: sortedArray[i].fromTime,
                        toTime: sortedArray[i].toTime

                    };
                }




                return newStack;
            });

        }



    };


    const resetToPreviousState = () => {
        if (!prevRecommendation2Ref) return;

        setRecommendedAppData2(JSON.parse(JSON.stringify(prevRecommendation2Ref.recommendedAppData2)));
        setRecommendedOpenModals([...prevRecommendation2Ref.recommendedOpenModals]);
        setRecommendedOpenModalsSingleIndex(prevRecommendation2Ref.recommendedOpenModalsSingleIndex);
        setCurrentModalIndex(prevRecommendation2Ref.currentModalIndex);
    };


    const handleSubCategoryChange = (id) => {
        setSelectedSubCategoryList((prev) => {
            let updatedList;
            const maxCategories = getMaxCategoriesForSelection(selectedActivityCount);

            if (!prev || !Array.isArray(prev)) {
                updatedList = [id]; // Initialize with the first item
            } else if (prev.includes(id)) {
                updatedList = prev.filter(item => item !== id); // Remove if already selected
            } else {
                updatedList = prev.length < maxCategories ? [...prev, id] : prev; // Add only if within limit
            }

            // Clear recommendations when selection changes
            setRecommendedAppData2([]);

            return updatedList.sort();
        });
    };


    const RenderRecommendation2Subox=() => {

        // Calculate the maximum number of categories that can be selected
        const maxCategories = getMaxCategoriesForSelection(selectedActivityCount);

        const isLimitReached = selectedSubCategoryList.length >= maxCategories;

        // Determine if the selection limit has been reached
        const isDisabledMain = selectedSubCategoryList.length > 0;


        
        if (!selectedActivityCount && !(recommend2fixedstackIndex == recommend2fixedstack?.length-1)) { return null }
        else if (recommend2fixedstackIndex>0 && recommend2fixedstackIndex == recommend2fixedstack?.length ) {
        return (
            <div className="mt-1 sub-category-container2">

                <h4 class="text-center admin_heading fw-bold dflex justify-center w-100 text-uppercase"> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-sparkles w-5 h-5 mr-2 text-purple-500"><path d="m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3Z"></path><path d="M5 3v4"></path><path d="M19 17v4"></path><path d="M3 5h4"></path><path d="M17 19h4"></path></svg> VELG OPPTIL {getMaxCategoriesForSelection(selectedActivityCount)} KATEGORIER:</h4>

                <div className="sub-category-container" >
                    {subCategories.map((option) => {
                        // Check if the current option is selected
                        const isSelected = selectedSubCategoryList?.includes(option.id);



                        // Disable the checkbox if the limit is reached and the current option is not selected
                        const isDisabled = isLimitReached && !isSelected;

                        return (
                            <label
                                key={option.id}
                                className={`sub-box btnOrder3 ${isSelected ? 'selected' : ''} ${selectedActivityCount === 0 || isDisabled ? 'disabled-container' : ''
                                    }`}
                            >
                                <input
                                    type="checkbox"
                                    value={option.id}
                                    checked={isSelected}
                                    onChange={() => { handleSubCategoryChange(option.id); setRmd2ChoicesSubmit(false); } }
                                    className="hidden-checkbox"
                                    disabled={isDisabled} // Disable the checkbox based on the condition
                                />
                                <i className={`sub-category-box ${option.icon}`}></i>
                                &nbsp;&nbsp;{option.value}
                            </label>
                        );
                    })}
                </div>
                <button
                    className={`btnOrder4 ${!(selectedActivityCount === 0 || isDisabledMain) ? 'disabled-container' : ''}`}
                    onClick={() => {
                        setRmd2ChoicesSubmit((prev) => {
                            // `prev` is guaranteed to be the latest state
                            return true; // Force to true regardless of previous state
                        });                    }}
                >
                    <i class="ri-lightbulb-flash-line"></i>  VIS FORSLAG
                </button>
            </div>

        ); }
        else {
        return null;
        }

    }


     //Function to Remove Sub Categories List for B2B
    const handleActivityCountChange = (newActivityCount) => {
        
        sessionStorage.removeItem("recommendState");
        setPageNumber(1);
        setActivitiesCount(0);
        setTotalPages(0);
        getPaginatedActivities();
        setWidget([]);
        setActivities([]);

        const maxCategories = getMaxCategoriesForSelection(newActivityCount);
        setSelectedActivityCount(newActivityCount);
        setSelectedSubCategoryList([]); // Remove excess categories on downgrade
        setRmd2ChoicesSubmit(false);

        setrecommend2fixedstackIndex(0);
        setTotalPersons(1);
        // Boolean state
        setRmd2ChoicesSubmit(false);  // Example usage: set to true

        // Array state
        setRecommendedAppData2([]);  // Add new data

        // Array state
        setRecommendedOpenModals([]);  // Example: Open a new modal

        // Array state
        setRecommendedOpenModalsPopup([]);  // Add a popup

        // Single index tracking state
        setRecommendedOpenModalsSingleIndex(-1);  // Example: Set index 2

        // Modal tracking state
        setCurrentModalIndex(0);  // Example: Open first modal

        
        const newArray = Array.from({ length: selectedActivityCount }, () => ({
            date: '', // Initialize date as empty string
            count: 1  // Initialize count as 0
        }));

      

    };


    // Function to get max categories allowed
    const getMaxCategoriesForSelection = (activityCount) => {
        const rule = activityRules.find(rule => rule.activityCount === activityCount);
        return rule ? rule.maxCategories : 1;
    };

   // Function to distribute activities 
    const distributeActivities = (activityCount, selectedCategories) => {
        if (!selectedCategories.length) return []; // If no category selected, return empty

        const maxCategories = getMaxCategoriesForSelection(activityCount); // Get max allowed categories
        const categoryLimit = Math.min(selectedCategories.length, maxCategories); // Limit categories

        const activitiesPerCategory = Math.floor(activityCount / categoryLimit); // Divide equally

        let distributedData = [];

        selectedCategories.slice(0, categoryLimit).forEach(category => {
            distributedData.push({
                categoryId: category,
                allocatedActivities: activitiesPerCategory
            });
        });

        return distributedData;
    };


    

    const isDisableCheckBooking = (e) => {
        return !(companyName && organizationNumber && invoiceAddress && invoiceSentTo && contactPerson && invoiceNote);
    };


    const getPageSize = () => {
        return dbpageSize;
    };



    // Handle changes dynamically
    const handleChange = (e) => {
        const { name, value } = e.target;

        // Dynamically updating the corresponding state using the field's name
        switch (name) {
            case 'text':
                setText(value);
                break;
            case 'companyName':
                setcompanyName(value);
                break;
            case 'organizationNumber':
                setorganizationNumber(value);
                break;
            case 'invoiceAddress':
                setinvoiceAddress(value);
                break;
            case 'invoiceSentTo':
                setinvoiceSentTo(value);
                break;
            case 'contactPerson':
                setcontactPerson(value);
                break;
            case 'invoiceNote':
                setinvoiceNote(value);
                break;
            default:
                break;
        }
    };



    useEffect(() => {
        // Your function here
        widget.filter((x, i) => { tranformWidget(i) });
    }, [one, two, four, six, twelve]); // This effect will re-run whenever one of these states changes




    const handleReset = (event) => {

        clearSession();
        event?.preventDefault();
        setSelectedDate(null);


        setRecommendedAppData([]);
        setType("default");
        setCity("default");
        setBudget("default");
        setPeopleNumber("default");


        /***************************************************/
        setIsScrolled(false);
        setShowCalender(false);
        setOpenCircle(1);
        setActivities([]);
        setFilteredActivities([]);
        setUpdateState(-1);
        /***************************************************/

        setVisible(getPageSize());
        setIsLoading(true);

        setPageNumber(1);
        setActivitiesCount(0);
        setTotalPages(0);



        getPaginatedActivities();
        setWidget([]);
        const updatedActivities = activities?.map((obj) => {
            return { ...obj, isVelgClick: null, isVelgDisable: null };
        });

        setActivities(updatedActivities);


        setIsLoading(true);


        

    };


    const handleResetRecommendation = () => {

        clearSession();
        setSelectedDate(null);
        setRecommendedAppData([]);
        setVisible(getPageSize());
        setIsLoading(true);
        setPageNumber(1);
        setActivitiesCount(0);
        setTotalPages(0);
        setWidget([]);
    }


    const checkIsWheelFilled = () => { return ((one === true && widget.length < 1) || (two === true && widget.length < 2) || (four === true && widget.length < 4) || (six === true && widget.length < 6) || (twelve === true && widget.length < 12)) };

    const checkIsWheelNotEmpty = () => { return widget?.length < 1 };


    const checkIsRemainActivities = () => {
        let count = 0;

        if (one === true ) {
            count += 1;
        }
        if (two === true ) {
            count += 2;
        }
        if (four === true ) {
            count += 4;
        }
        if (six === true) {
            count += 6;
        }
        if (twelve === true && widget.length < 12) {
            count += 12;
        }

        console.log(count - widget.length);
        return count - widget.length;
    };

    const handleActivityEditClick = (activity) => {

        setTotalPersons(activity.minPerson + activity.totPersons);
        setShowModalVELG(activity);
        setFromTime(activity.fromTime);
        setToTime(activity.toTime);
        setSelectedDateVELG(activity.addDate);
        setComments(activity?.reason);
    };
    const handleDltActivityforSingleRecommended = (activity) => {

        const { page, visible } = shuffleItems(false, activity);
        handleDeleteActivityrcmd(activity);
        
    };


    const handleDltActivityforMultipleRecommended = (activity) => {


        activity.isVelgClick = null;
        const { page, visible } = shuffleItems2(false, activity);
        handleDeleteActivityrcmd(activity);

    };


    useEffect(() => {
        
        if (recommendedOpenModals.length > 0 && mappedBookedActivity.length<=0) {
            simulateDislikeCancelledBooking();

        }
    }, [recommendedOpenModals]);





    const getCancelledBooking = () => {

        return EditData?.BookingDataParent?.activities.map((obj) => {
            let dltactivity = recommendedOpenModals.filter(x => x.id === obj.activityId);

            obj.recommendedOpenModals = dltactivity.length > 0 ? dltactivity[0] : null;
            return obj;

        })?.filter(x => x.isCanceled);
    }

    const simulateDislikeCancelledBooking = () => {

        

        let canceledActivities = getCancelledBooking();
        if (recommendedOpenModals.length > 0) {
            setMappedBookingActivity(recommendedOpenModals);

            canceledActivities?.forEach(activity => {
                

                let dltactivity = recommendedOpenModals.filter(x => x.id ===activity.activityId)[0];


                if (action === "rec1") {

                    handleDltActivityforSingleRecommended(dltactivity);
                }
                else {
                    handleDltActivityforMultipleRecommended(dltactivity);
                }

            });
        }

        return canceledActivities;

    }







    //const handleDltActivityforSingleRecommended = (activity) => {

    //    //shuffleItems();
    //    handleDeleteActivity(activity);

    //}


    const handleDeleteActivityrcmd = (activity) => {
        const filtered = widget.filter((val) => val.id !== activity.id);
        handleDeleteActivity(activity.id);
        setWidget(filtered);
        setIsHovered(false);
    }





    const handleDeleteActivity = (activity) => {
        const filtered = widget.filter((val) => val.id !== activity.id);
        activities.map((obj) => {
            if (obj.id == activity.id) {
                obj.isVelgClick = null;
                obj.isVelgDisable = null;
            }
        });
        setActivities(prevActivities => {
            const updatedActivities = [...prevActivities]; // Create a copy of the previous state
            // Perform any updates to the updatedActivities array here
            return updatedActivities; // Return the updated state
        });

        setWidget(filtered);
        setIsHovered(false);
    }


    const handleActivityDelClick = (activityId) => {
        setShowModalRmv(showModalRmv - 1);
        const filtered = widget.filter((val) => val.id !== activityId);
        const updatedActivities = activities.map((obj) => {
            if (obj.id === activityId) {
                return { ...obj, isVelgClick: null, isVelgDisable: null };
            }
            return obj;
        });

        setActivities(updatedActivities);
        setWidget(filtered);
        setIsHovered(false);
    };

    const handleMouseHover = (data) => {
        setIsHovered(true);
        setActivityHover(data);
    };

    const handleMouseLeave = () => {
        setIsHovered(false);
    };
    const [widget, setWidget] = useState([])
    const handleDrag = (e, type) => {

        e.dataTransfer.setData("WidgetType", JSON.stringify(type))


    }
    const handleOnDrop = (e) => {
        //alert("hello");
        if ((one === true && widget.length < 1) || (two === true && widget.length < 2) || (four === true && widget.length < 4) || (six === true && widget.length < 6) || (twelve === true && widget.length < 12)) {
            const type = e.dataTransfer.getData("WidgetType");
            const widgetObject = JSON.parse(type);


            setShowModalVELG(false);
            activities.map((obj) => {
                if (obj.id == widgetObject.id) {
                    obj.isVelgClick = true;
                    obj.totPersons = totalPersons - widgetObject.minPerson;

                    handleVelgClick(e, obj);
                }
            });
            setActivities(prevActivities => {
                const updatedActivities = [...prevActivities]; // Create a copy of the previous state
                // Perform any updates to the updatedActivities array here
                return updatedActivities; // Return the updated state
            });




            //setWidget([...widget, widgetObject])
        }
    }

    const simulateDragging = (type) => {

        
        const isDuplicate = widget.some((item) => item.id === type.id);

        if (!isDuplicate && (
            (one === true && widget.length < 1) ||
            (two === true && widget.length < 2) ||
            (four === true && widget.length < 4) ||
            (six === true && widget.length < 6) ||
            (twelve === true && widget.length < 12)
        )) {
            setWidget([...widget, type]);
        }
    };




    const checkdowngrade = (newvalue) => {
        widget.filter((x, i) => { tranformWidget(i) });


        let value = 0;
        if (one == true) {
            value = 1;
        }
        else if (two == true) {
            value = 2;
        }
        else if (four === true) {
            value = 4;
        }
        else if (six === true) {
            value = 6;
        }
        else {
            value = 12;
        }

        if (value > newvalue) {

            return value - newvalue;
        }


        return 0;




    }


    const handleVelgClick = (e, activity,isPopupsimulate=false) => {
        
        e?.preventDefault();
        // 1. Check if activity exists in widget
        let activityFound = false;

        // Update widget array
        const updatedWidget = widget.filter((obj) => {
            if (obj.id === activity.id) {
                activityFound = true;
                return false; // Remove from widget
            }
            return true;
        });

        // 2. If activity was found and removed:
        if (activityFound) {
            const updatedActivities = activities.map((obj) =>
                obj.id === activity.id
                    ? { ...obj, isVelgClick: false }
                    : obj
            );

            // Update state with both arrays
            setWidget(updatedWidget);
            setActivities(updatedActivities);
        }
        // 3. Else (activity not found in widget)
        else {

            if ((one === true && widget.length < 1) || (two === true && widget.length < 2) || (four === true && widget.length < 4) || (six === true && widget.length < 6) || (twelve === true && widget.length < 12)) {

                setTotalPersons(activity.minPerson);
                isPopupsimulate ? setAddSingleCustomModal(false) : setShowModalVELG(activity);
            }
        }

        //activities.map((obj) => {
        //    if (obj.id == activity.id) {
        //        obj.isVelgClick = true;
        //    }
        //});
        //setActivities(prevActivities => {
        //    const updatedActivities = [...prevActivities]; // Create a copy of the previous state
        //    // Perform any updates to the updatedActivities array here
        //    return updatedActivities; // Return the updated state
        //});

    }

    const handleDragOver = (e) => {
        e.preventDefault()
    }

    const scrollToActivity = () => {
        const element = document.querySelector('.scrollToActivity');
        if (element) {
            element.scrollIntoView({
                behavior: 'smooth',
                block: 'start', // Możesz zmienić na 'end', jeśli chcesz przewinąć do końca elementu
            });
        }
    };

    //useMemo function that will set page number to 1 if any filter is changed.
    // because then we want the activities array to be reset to zero.

    const filterChanged = useMemo(
        () => {

            if ((city != undefined && city != "") || (type != undefined && type != "") || category != "" || (peopleNumber != undefined && peopleNumber != "") || (budget != undefined && budget != "")) {
                const sessionCheck = JSON.parse(sessionStorage.getItem("SearchResult"));
               

                if (sessionCheck?.pages[0].category.category == category || category == "") return;
                clearSession();
                setPageNumber(1);
            }
        },
        [city, type, category, peopleNumber, budget]
    );


    async function getWheelPPT() {
        try {
            setIsLoading(true);
            const element = document.getElementById("pdfDivMain-root");

            if (!element) {
                alert("Element not found!");
                setIsLoading(false);
                return;
            }

            //// 1. Force CORS attributes on all external resources
            //document.querySelectorAll('link[href*="fonts.googleapis.com"], link[href*="cdn.jsdelivr.net"]').forEach(link => {
            //    link.crossOrigin = "anonymous";
            //});

            //// 2. Process images with CORS handling
            //const processImages = async () => {
            //    const images = element.querySelectorAll("img");
            //    const proxyServers = [
            //        "https://api.allorigins.win/raw?url=",
            //        "https://cors-anywhere.herokuapp.com/",
            //        "https://corsproxy.io/?",
            //        "https://thingproxy.freeboard.io/fetch/",
            //        // Add more proxy servers as needed
            //    ];

            //    return Promise.allSettled(
            //        Array.from(images).map(async (img) => {
            //            try {
            //                // Check if the image is already in Base64 format
            //                if (img.src.startsWith("data:image/")) {
            //                    console.log("Image is already in Base64 format:", img.src);
            //                    return; // Skip conversion
            //                }

            //                let lastError = null;

            //                // Try each proxy server until one succeeds
            //                for (const proxy of proxyServers) {
            //                    try {
            //                        const proxyUrl = proxy + encodeURIComponent(img.src);
            //                        const response = await fetch(proxyUrl);

            //                        if (!response.ok) throw new Error("Failed to fetch image");

            //                        // Convert the image to a blob and then to Base64
            //                        const blob = await response.blob();
            //                        const base64 = await new Promise((resolve) => {
            //                            const reader = new FileReader();
            //                            reader.onloadend = () => resolve(reader.result);
            //                            reader.readAsDataURL(blob);
            //                        });

            //                        // Replace the original image source with Base64
            //                        img.src = base64;
            //                        return; // Exit the loop if successful
            //                    } catch (error) {
            //                        lastError = error;
            //                        console.warn(`Proxy ${proxy} failed for image:`, img.src, error);
            //                        // Continue to the next proxy
            //                    }
            //                }

            //                // If all proxies fail, throw the last error
            //                throw lastError || new Error("All proxy servers failed");
            //            } catch (error) {
            //                console.warn("CORS error - removing image:", img.src, error);
            //                img.remove(); // Remove the image if conversion fails
            //            }
            //        })
            //    );
            //};
            // Retryable operation
            const operation = async () => {
                //await processImages();

                // 3. Wait for fonts to load
                await document.fonts.ready;

                //// 4. Capture element with enhanced CORS config
                //const canvas = await toPng(element, {
                //    backgroundColor: null,
                //    pixelRatio: 1,
                //    width: element.offsetWidth,
                //    height: element.offsetHeight,
                //    filter: (node) => node.tagName !== 'I',
                //    useCORS: true,
                //    onclone: (clonedDoc) => {
                //        clonedDoc.querySelectorAll('link, img').forEach(el => {
                //            el.crossOrigin = 'anonymous';
                //        });
                //    }
                //});

                // 5. API call and PDF download (keep your existing code)
                const payload = { widget, imgData: null };
                const response = await FetchService.getWheelPPT(payload);

                if (response?.data) {
                    const blob = new Blob([response.data], { type: "application/pdf" });
                    const filename = response.headers?.['content-disposition']?.split('filename=')[1]?.split(';')[0]?.replace(/['"]/g, '') || 'Sosiale_aktiviteter_Funtlers.pdf';

                    const link = document.createElement('a');
                    link.href = URL.createObjectURL(blob);
                    link.download = filename;
                    document.body.appendChild(link);
                    link.click();
                    setTimeout(() => document.body.removeChild(link), 100);

                    return true;
                }
                throw new Error("Invalid API response");
            };

            const success = await retryOperation(operation, 3, 2000);
            if (!success) alert("Failed after 3 attempts");

        } catch (error) {
            console.error("Error:", error);
            alert(`Failed: ${error.message}`);
        } finally {
            setIsLoading(false);
        }
    }

    // Generic retry operation helper
    async function retryOperation(operation, maxRetries, delay) {
        let attempt = 0;
        while (attempt < maxRetries) {
            try {
                return await operation();
            } catch (error) {
                attempt++;
                if (attempt >= maxRetries) throw error;
                await new Promise(resolve => setTimeout(resolve, delay));
            }
        }
    }
    function getPaginatedActivities() {
        ReactGA.event({
            action: 'Search_action',
            category: 'Search_category',
            label: 'Search_label',
            value: "Click on Search Button"
        })



        let session = getSession()
        if (session && !gettedFromSession) {
            session?.activity?.map((obj) => {
                const matchingWidget = session?.widget?.find((w) => w.id === obj.id);

                if (matchingWidget) {
                    obj.isVelgClick = true;
                    obj.totPersons = totalPersons - matchingWidget.minPerson;
                }
            });
            setGettedFromSession(true)
            session.activity.map((val) => val.totPersons = 0)
            setActivities(session.activity);
            setActivitiesCount(session.pages[0]?.total);
            setTotalPages(session.pages[0]?.totalPages);
            setVisible(session.activity.length + 1);
            setPageNumber(session.pageNo);
            setWidget(session.widget || []);

         



            if (session.button) {
                setOne(session.button.one);
                setTwo(session.button.two);
                setFour(session.button.four);
                setSix(session.button.six);
                setTwelve(session.button.twelve);
            }
           

            setIsLoading(false);
            if (!isScrolled) {
                setIsScrolled(true);
                setTimeout(function () {
                    scrollToActivity();
                }, 500);
            }
        }
        else {
            setIsLoading(true);


            const filter = getFilterRequestModel();
            CallAplicationAPI(filter);


        }
    }



    const CallAplicationAPI = async (filter) => {
        try {
            setIsLoading(true);

            const response = await FetchService.getActivitiesByPagination(filter);
            const data = response?.data;

            if (!data?.pages?.length || !data?.activity) {
                setActivities([]);
                setActivitiesCount(0);
                setTotalPages(0);
                setSession(null);
                setIsLoading(false);
                return []; // Return early with an empty array
            }

            setActivitiesCount(data.pages[0]?.total || 0);
            setTotalPages(data.pages[0]?.totalPages || 0);

            let updatedActivitiesOrig = data.activity.map((val) => ({
                ...val,
                totPersons: 0,
            }));

            let updatedActivities = updatedActivitiesOrig;

            //if (filter.pageNo !== 1) {
            //    updatedActivities = [...activities, ...updatedActivitiesOrig];

            //    // Remove duplicates based on the 'id' property
            //    updatedActivities = updatedActivities.filter(
            //        (activity, index, self) =>
            //            index === self.findIndex((a) => a.id === activity.id)
            //    );
            //}

            
            updatedActivities.map((obj) => {
                const matchingWidget = widget.find((w) => w.id === obj.id);

                if (matchingWidget) {
                    obj.isVelgClick = true;
                    obj.totPersons = totalPersons - matchingWidget.minPerson;
                }
            });

            setActivities(updatedActivities);

            setSession({
                ...data,
                pageNo: filter.pageNo,
                pages: [{ ...data.pages[0], category: filter }],
                widget: widget
            });

            return { updatedActivities: updatedActivitiesOrig, pages: data.pages[0] }; // Return the result

        } catch (error) {
            console.error("Error fetching activities:", error);
            throw error; // Throw error to be handled by the caller
        } finally {
            setIsLoading(false);
        }
    };




    function clearSession() {
        setSession(null);
    }

    function setSession(obj) {
        sessionStorage.setItem("SearchResult", JSON.stringify(obj));
        sessionStorage.setItem("filter", JSON.stringify({ "selectedDate": selectedDate, "city2": city, "category": category, "type": type, "peopleNumber": peopleNumber, "budget": budget }));
    }

    function getSession() {
        let obj = JSON.parse(sessionStorage.getItem("SearchResult"));
  

        if (obj) {
            obj.widget = JSON.parse(sessionStorage.getItem("widget") || "[]");
            obj.button = JSON.parse(sessionStorage.getItem("button"));

        }
        return obj;
    }
    function setFilterModel() {
        filterModel.category = category === "" ? "all" : category;
        filterModel.type = type === "" ? "all" : type;
        filterModel.city2 = city === "" ? "all" : city;
        filterModel.peopleNumber = peopleNumber === "" ? "all" : peopleNumber;
        filterModel.budget = budget === "" ? "all" : budget;
    }



    function getRecommendationFilterModel(subcategoryId, rowCountPerPage) {

        
        let filter = getFilterRequestModel();
        filter.rowCountPerPage = rowCountPerPage;
        filter.category = null;
        filter.subCategoryId = subcategoryId;
        return filter;

    }



    //This method return a filter object that will be needed to be passed to the backend
    //to return paginated data.
    function getFilterRequestModel() {
        //getting updated filtermodel from the respective states
        setFilterModel();
        let filter = null;
         filter = {
                pageNo: 1,
                rowCountPerPage: getPageSize(),
                isValid: true,
                isLive: true,
                city: null,
                type: null,
                category: "teambuilding,afterWork,sommerfest,dagsevent,digitalt,kurs & konferanse",
                minPrice: -1,
                maxPrice: -1,
                minPerson: -1,
                maxPerson: -1,
                checkDate: null,
                isB2B: 1
            };

        //filter.category = filterModel.category;
        filter.checkDate = selectedDate ? dayjs(selectedDate).format('YYYY-MM-DD') : null;
        filter.type = filterModel.type;
        filter.city = filterModel.city2;

        [filter.minPerson, filter.maxPerson] = getMinMax2(filterModel.peopleNumber);
        [filter.minPrice, filter.maxPrice] = getBudget2(filterModel.budget);

        filter.pageNo = pageNumber;
        filter.minPrice = 1;


        return filter;
    }
    useEffect(() => {

        
        if ((action === "rec1")) {
            setIsLoading(true);
            if (pageNumber && pageNumber <= 1 && recommendedAppData.length<1) {
                fetchsubCategory().then(() => {
                    setTimeout(() => {
                        setIsLoading(false);
                    }, 800); // 2000 ms = 2 seconds
                });
                //restoreRecommendSession();

            }

        }

        else if ((action === "rec2")) {
            setIsLoading(true);

           fetchsubCategory().then(() => {
                    //CallAplicationAPI(filter).then((data) => {
                    //    let updatedActivities = data.updatedActivities;

                    //    setRecommendedAppData(prevData => {
                    //        if (prevData.length === 0) {
                    //            // 🔹 First time: Set startIndex = 0 and endIndex = activities.length - 1
                    //            return [{ page: 0, activities: updatedActivities, startIndex: 0, endIndex: updatedActivities.length }];
                    //        } else {
                    //            // 🔹 For next pages, add a new entry while keeping existing data
                    //            return [
                    //                {
                    //                    page: prevData.length,
                    //                    activities: updatedActivities,
                    //                    startIndex: prevData.reduce((acc, curr) => acc + curr.activities.length, 0),
                    //                    endIndex: prevData.reduce((acc, curr) => acc + curr.activities.length, 0) + updatedActivities.length - 1
                    //                }
                    //            ];
                    //        }
                    //    });
                    //});
                });
            //restoreRecommendSession();

            setTimeout(() => {
                setIsLoading(false);
            }, 800); // 2000 ms = 2 seconds


        }

        else {
            getPaginatedActivities("filter");
        }
     

    }, [city, type, category, peopleNumber, budget, pageNumber, selectedDate]);






    useEffect(() => {
        widget.filter((x, i) => { tranformWidget(i) });


        sessionStorage.setItem('widget', JSON.stringify(widget));

    }, [widget]);


    const ChangeSubCategory = () => {

        setActivities([]); // Fix typo from 'etActivities' to 'setActivities'
        setRecommendedAppData([]);

        setPageNumber(null); // This alone should trigger a change

        // If you need to force a re-render by toggling:
        setTimeout(() => setPageNumber(1), 0);
    }


    const handlePrint = () => {
        //var printContents = document.getElementById('pdfDivMain').innerHTML;
        //var originalContent = document.body.innerHTML;
        //document.body.innerHTML = printContents;
        //window.print();
        //document.body.innerHTML = originalContent;
        //window.location.reload();

        getWheelPPT()
    };

    const matchActFilter = (inputDateString) => {
        //const inputs = "2023-11-23T00:00:00";
        const date = new Date(inputDateString);

        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Adding 1 to month since it starts from 0
        const day = String(date.getDate()).padStart(2, '0');
        const formattedDate = `${day}-${month}-${year}`;
        return formattedDate
    }
    const getMonthDate = (val) => {
        const date = new Date(val);
        const month = String(date.getMonth() + 1).padStart(2, '0');
        return month
    }

    const [totalPersons, setTotalPersons]=useState(0)
    const [totalPrice, setTotalPrice]=useState(0)
    const totalGetting = () => {
        widget.map((val) => {
            var a = val.price * (val.minPerson + val.totPersons)
            var b = totalPrice + a
             setTotalPrice((prev)=>prev+a)
        })
    }

    const showLessItems = () => {
        clearSession();
        setPageNumber(pageNumber - 1);
        setVisible((prevValue) => prevValue - getPageSize());
    };

    const showMoreItems = () => {
        clearSession();
        setPageNumber(pageNumber + 1);
        setVisible((prevValue) => prevValue + getPageSize());

    };


    const shuffleItems2 = async (isFullShuffle = false, activity = null) => {

        
        setIsLoading(true);
        console.log("Starting shuffleItems");
        clearSession();

        let allActivities = [];

        let previousState = {

        };

        console.log("Initial recommendedAppData:", JSON.stringify(recommendedAppData2, null, 2));



        for (let i = 0; i < recommendedAppData2.length; i++) {


            const recommendation = recommendedAppData2[i]; 


            let categoryRecommendedArray = recommendedOpenModals.map((obj, index) => {
                obj.sortIndex = index;
                return obj;
            }).filter(x => x.arrayIndex == i).map((obj, index) => ({
                ...obj,          // Clone the object to avoid modifying the original
                sortIndexInternalPage: index

            }));
            let LikedActivityArray = categoryRecommendedArray.filter(x => x.isVelgClick == true);



            recommendation.activities = recommendation.activities.map((obj,index) => {

                obj.IsLikedNewPoup = false;
                obj.arrayIndex = i;
                obj.currentIndex = index;
                return obj;
            });



            let startIndex = recommendation.startIndex;
            let endIndex = recommendation.endIndex;


            let incrementCard = isFullShuffle ? (recommendation.pageSize ) : 0;

            let newPageNumber = recommendation.pageNumber + 1;
            let filter = getRecommendationFilterModel(recommendation.categoryId, recommendation.pageSize);

            console.log(`\n--- Processing recommendation index: ${i} ---`);
            console.log(`Before API Call: startIndex=${startIndex}, endIndex=${endIndex}, pageNumber=${recommendation.pageNumber}`);

            // Check if pageNumber is within valid range and not in cycle mode
            if (recommendation.pageNumber <= recommendation.totalPages && !recommendation.cycleData) {
                console.log(`Fetching data for newPageNumber=${newPageNumber}`);
                filter.pageNo = newPageNumber;
                const data = await CallAplicationAPI(filter);
                console.log("API response data:", JSON.stringify(data, null, 2));

                let updatedActivities = data.updatedActivities.map((act) => ({
                    ...act,
                    arrayIndex: i,// Store indexes
                    isMovedToEnd: false,
                }));

                console.log("Fetched updatedActivities:", updatedActivities);

                // Update activities and pagination info
                recommendation.activities = [...recommendation.activities, ...updatedActivities];
                recommendation.pageNumber = newPageNumber;
                recommendation.totalPages = data.pages.totalPages;
                recommendation.total = data.pages.total;
                //console.log("Updated recommendation state after API call:", {
                //    pageNumber: recommendation.pageNumber,
                //    totalPages: recommendation.totalPages,
                //    total: recommendation.total,
                //});

                // **Only update startIndex and endIndex if activity is NOT passed**
                if (!activity) {
                    recommendation.startIndex = (startIndex + incrementCard) % recommendation.total;
                    recommendation.endIndex = (startIndex + incrementCard + recommendation.pageSize ) % recommendation.total;
                    console.log(`After API Call: New startIndex=${recommendation.startIndex}, New endIndex=${recommendation.endIndex}`);
                }

                // Handle cyclic pagination when reaching the last page
                if (recommendation.pageNumber === recommendation.totalPages) {
                    recommendation.cycleData = true;
                    console.log("Reached last page, setting cycleData to true");
                    if (updatedActivities.length < recommendation.pageSize) {
                        // **Only update startIndex and endIndex if activity is NOT passed**
                        if (!activity && recommendation.endIndex > recommendation.activities.length) {
                            recommendation.endIndex = (0 + incrementCard - updatedActivities.length) % recommendation.total;
                        }

                        console.log(`Adjusted endIndex for last page: ${recommendation.endIndex}`);
                    }
                }
            } else {
                console.log(`Skipping API call for recommendation index ${i} (either cyclic mode or page number exceeded).`);
                if (!activity && recommendation.cycleData) {
                    if (!activity) {
                        recommendation.startIndex = (startIndex + incrementCard) % recommendation.total;
                        recommendation.endIndex = (startIndex + incrementCard + (recommendation.pageSize )) % recommendation.total;
                    }
                    console.log(`Cyclic mode update: New startIndex=${recommendation.startIndex}, New endIndex=${recommendation.endIndex}`);
                }
            }

            // Handle dislike replace and move activity to the end
            if (activity && i == activity.arrayIndex) {
                const actIndex = recommendation.activities.findIndex((act) => act.id === activity.id);
                if (actIndex !== -1 && activity.arrayIndex == i) {
                    const movedActivity = recommendation.activities[actIndex];
                    const movedActivity2Index = (recommendation.endIndex) % recommendation.total;
                    const movedActivity2 = recommendation.activities[movedActivity2Index];


                    movedActivity.isMovedToEnd = true;

                    //movedActivity2.isMovedToEnd = false;

                    //temperary property
                    movedActivity2.IsLikedNewPoup = true;

                    // Swap and move that activity to the next page 
                    recommendation.activities[actIndex] = movedActivity2;
                    recommendation.activities[movedActivity2Index] = movedActivity;


                    // Swap and move that activity to the next page 
                    recommendation.activities[actIndex] = movedActivity2;
                    recommendation.activities[movedActivity2Index] = movedActivity;

                    recommendation.activities[actIndex].isVelgClick = false;
                    recommendation.activities[actIndex].addDate = null;

                    recommendation.activities[movedActivity2Index].isVelgClick = false;
                    recommendation.activities[movedActivity2Index].addDate = null;
                }
            }

            // Order moved and normal activities
            const normalActivities = recommendation.activities.filter(act => !act.isMovedToEnd);
            const movedActivities = recommendation.activities
                .filter(act => act.isMovedToEnd)
                .map(({ isMovedToEnd, ...rest }) => rest); // Removes the property
            let finalActivities = [...normalActivities, ...movedActivities];

            recommendation.activities = finalActivities;

            let fstartIndex = recommendation.startIndex;
            let fendIndex = recommendation.endIndex;

            // Handle cyclic slicing when startIndex > endIndex
            let pageActivities = fstartIndex < fendIndex
                ? recommendation.activities.slice(fstartIndex, fendIndex)
                : [
                    ...recommendation.activities.slice(fstartIndex, recommendation.activities.length),
                    ...recommendation.activities.slice(0, fendIndex)


                
                ];

            pageActivities = pageActivities.map(obj => {
                const likedObj = LikedActivityArray.find(liked => liked.id === obj.id);
                return likedObj ? { ...likedObj } : obj;
            });




            if (LikedActivityArray.length > 0) {
                const pageActivitiesCopy = [...pageActivities];
                const categoryCopy = [...categoryRecommendedArray];

                const finalactivity = categoryCopy.map(obj => {
                    if (obj.isVelgClick) {
                        // Remove matching ID from pageActivities if exists
                        const index = pageActivitiesCopy.findIndex(item => item.id === obj.id);
                        if (index > -1) {
                            pageActivitiesCopy.splice(index, 1);
                        }
                        return obj;
                    } else {
                        // Check if first page activity has same ID as current category item
                        if (pageActivitiesCopy[0]?.id === obj.id) {
                            // Retain original category item
                            return obj;
                        }
                        // Otherwise use page activity if available
                        return pageActivitiesCopy.shift() || obj;
                    }
                });

                // Use finalactivity array
                pageActivities = finalactivity;
            }
            //{
            //    // Ensure pageActivities does not contain duplicates from LikedActivityArray
            //    let filteredPageActivities = pageActivities
            //        .filter(act => !LikedActivityArray.some(liked => liked.id === act.id))
            //        .sort(() => Math.random() - 0.5); // Randomizes order

            //    pageActivities = filteredPageActivities.map((obj, index) => {
            //        let likedObj = LikedActivityArray.find(liked => liked.sortIndex === index);

            //        if (likedObj) {


            //            let movefrom = recommendation.activities.findIndex(x => x.id === likedObj.id);
            //            let moveto = recommendation.activities.findIndex(x => x.id === obj.id);

            //            if (recommendation.activities[movefrom] && recommendation.activities[moveto]) {
            //                recommendation.activities[movefrom] = likedObj;
            //                recommendation.activities[moveto] = obj;
            //            }

            //            return likedObj; // Replace with likedObj if found
            //        }

            //        return obj; // Otherwise, return the original object
            //    });




            //}





            pageActivities.map((obj,index) => {
                obj.sortIndex = categoryRecommendedArray[index].sortIndex;
            })


            allActivities.push(pageActivities);


        }

        
        let filteredActivities = allActivities.flat().sort((a, b) => a.sortIndex - b.sortIndex)  // ✅ Correct


        // Create a new array with the specified count
        const newArray = filteredActivities.map((obj, index) => {
            // Check if filteredActivities[index] exists
            obj.addDate = recommend2fixedstack[index].date;
            obj.totPersons = recommend2fixedstack[index].count - obj.minPerson;
            obj.fromTime = recommend2fixedstack[index].fromTime;
            obj.toTime = recommend2fixedstack[index].toTime;
            return obj;
        });



        setRecommendedOpenModals(filteredActivities); // Open all modals


        //Find the index and open the model for single index
        if (activity) {

            let index = filteredActivities.findIndex(item => item?.IsLikedNewPoup == true);
            // Only proceed if the item was found (index !== -1)
            if (index !== -1) {
                //setRecommendedOpenModalsSingleIndex(index);
                //recommendedOpenModalsPopup([]);
                setCurrentModalIndex(index);
              
            }
           
        }
        else {
            setRecommendedOpenModalsSingleIndex(null);
            setCurrentModalIndex(0);
        }








        // Update state if there are activities
        if (allActivities.length > 0) {
            console.log("Setting activities with allActivities:", filteredActivities);
            setActivities(filteredActivities);
        } else {
            console.log("No new activities fetched.");
        }

        // Update pageNumber and visible count
        setPageNumber((prevPageNumber) => {
            const updatedPageNumber = prevPageNumber + 1 > recommendedAppData2[0]?.totalPages ? 1 : prevPageNumber + 1;
            console.log(`Updating pageNumber from ${prevPageNumber} to ${updatedPageNumber}`);
            return updatedPageNumber;
        });

        setVisible((prevVisible) => {
            let newVisible = prevVisible + getPageSize();
            newVisible = newVisible > recommendedAppData2[0]?.total ? recommendedAppData2[0]?.total : newVisible;
            console.log(`Updating visible count from ${prevVisible} to ${newVisible}`);
            return newVisible;
        });

        // Simulated values for debugging
        const simulatedCurrentPage = recommendedAppData[0]?.pageNumber || 1;
        const simulatedCurrentVisible = recommendedAppData[0]?.visible || getPageSize();
        const returnPage = simulatedCurrentPage + 1;
        const returnVisible = simulatedCurrentVisible + getPageSize();

        console.log(`Final returning values - Page: ${returnPage}, Visible: ${returnVisible}`);



        
        // Create deep copies for non-primitive objects/arrays


     



        // Delay setting isLoading to false after a small interval
        setTimeout(() => {
            setIsLoading(false);
            console.log("setIsLoading(false) after delay");
        }, 500);

        return { page: returnPage, visible: returnVisible };
    };


    const saveRecommendSession = () => {


        
        // Create a clean copy of the state to avoid mutations
        const stateToSave = {

            // #### Recommend - 1 Items ####//
            selectedSubCategory: selectedSubCategory,
            recommendedAppData: JSON.parse(JSON.stringify(recommendedAppData)),

            // #### Recommend - 2 Items #### //
            recommendedAppData2: JSON.parse(JSON.stringify(recommendedAppData2)),
            recommendedOpenModals: [...recommendedOpenModals],
            recommendedOpenModalsSingleIndex: recommendedOpenModalsSingleIndex,
            currentModalIndex: currentModalIndex,
            selectedSubCategoryList: selectedSubCategoryList,
            recommend2fixedstack: recommend2fixedstack,
            recommend2fixedstackIndex: recommend2fixedstackIndex,
            rmd2ChoicesSubmit: rmd2ChoicesSubmit,

            // #### Widget Wheel Items #### //
            selectedActivityCount: selectedActivityCount,
            activities: activities,
            totalPages: totalPages,
            pageNumber: pageNumber,
            widget: widget,

            // #### saving and restoring type Wheel Items #### //
            action: action,
            city: city,

            one: one,
            two: two,
            four: four,
            six: six,
            twelve:twelve
          

        };

        // Save to sessionStorage
        sessionStorage.setItem("recommendState", JSON.stringify(stateToSave));
    };



    const restoreRecommendSession = () => {
        
        const savedState = sessionStorage.getItem("recommendState");

        
        if (!savedState) {
            console.warn("No saved state found.");
            return;
        }

        try {

            
            setIsSessionLock(true);

            const parsedState = JSON.parse(savedState);


           // #### Recommend - 1 Items ####//
            setSelectedSubCategory((prevSubCategory) => {
                return parsedState.selectedSubCategory; // Or any logic combining prevSubCategory
            });
            setRecommendedAppData(parsedState.recommendedAppData);


            setType(parsedState.type);
           // #### Recommend - 2 Items ####//
           setrecommend2fixedstack(parsedState.recommend2fixedstack);
           setrecommend2fixedstackIndex(parsedState.recommend2fixedstackIndex);
           setRecommendedAppData2(parsedState.recommendedAppData2);
           setRecommendedOpenModals(sortDataDate(parsedState.recommendedOpenModals));
           setRecommendedOpenModalsSingleIndex(parsedState.recommendedOpenModalsSingleIndex);
           setCurrentModalIndex(parsedState.currentModalIndex);
           //setRmd2ChoicesSubmit(parsedState.rmd2ChoiceSubmit);
           setSelectedSubCategoryList(parsedState.selectedSubCategoryList);



           // #### Widget Items ####//
            setActivities(parsedState.activities);
            setSelectedActivityCount(parsedState.selectedActivityCount);
            setTotalPages(parsedState.totalPages);
            setPageNumber(parsedState.pageNumber);
            setWidget(parsedState.widget);


            
            setOne(parsedState.one);
            setTwo(parsedState.two);
            setFour(parsedState.four);
            setSix(parsedState.six);
            setTwelve(parsedState.twelve);


            setCity(parsedState.city);
            //setrecommend2fixedstack(parsedState.recommend2fixedstack);
            //setrecommend2fixedstackIndex(recommend2fixedstackIndex);
            //// Restore the state (adjust based on your app's state management)


            //setRecommendedAppData2(parsedState.recommendedAppData2);
            //setRecommendedOpenModals(parsedState.recommendedOpenModals);
            //setRecommendedOpenModalsSingleIndex(parsedState.recommendedOpenModalsSingleIndex);
            //setCurrentModalIndex(parsedState.currentModalIndex);

            //setSelectedSubCategoryList(parsedState.selectedSubCategoryList);

            setTimeout(() => {
                setIsSessionLock(false);


                





            }, 1000);



        } catch (error) {
            console.error("Failed to restore state:", error);
        }
    };


    

    
    const shuffleItems = async (isFullShuffle = false, activity = null) => {
        debugger;
        setIsLoading(true);
        console.log("Starting shuffleItems");
        clearSession();

        let allActivities = [];

        console.log("Initial recommendedAppData:", JSON.stringify(recommendedAppData, null, 2));

        // Loop through each recommendation to handle pagination
        for (let i = 0; i < recommendedAppData.length; i++) {
            const recommendation = recommendedAppData[i];
            recommendation.activities = recommendation.activities.map(obj => {  obj.arrayIndex = i; return obj; }); //reset bit
            let startIndex = recommendation.startIndex;
            let endIndex = recommendation.endIndex;
            let incrementCard = isFullShuffle ? recommendation.pageSize : 0;
            let newPageNumber = recommendation.pageNumber + 1;
            let filter = getRecommendationFilterModel(selectedSubCategory, recommendation.pageSize);

            console.log(`\n--- Processing recommendation index: ${i} ---`);
            console.log(`Before API Call: startIndex=${startIndex}, endIndex=${endIndex}, pageNumber=${recommendation.pageNumber}`);

            // Check if pageNumber is within valid range and not in cycle mode
            if (recommendation.pageNumber <= recommendation.totalPages && !recommendation.cycleData) {
                console.log(`Fetching data for newPageNumber=${newPageNumber}`);
                filter.pageNo = newPageNumber;
                const data = await CallAplicationAPI(filter);
                console.log("API response data:", JSON.stringify(data, null, 2));

                let updatedActivities = data.updatedActivities.map((act) => ({
                    ...act,
                    isMovedToEnd: false,
                }));

                console.log("Fetched updatedActivities:", updatedActivities);

                // Update activities and pagination info
                recommendation.activities = [...recommendation.activities, ...updatedActivities];
                recommendation.pageNumber = newPageNumber;
                recommendation.totalPages = data.pages.totalPages;
                recommendation.total = recommendation.activities.length;
                console.log("Updated recommendation state after API call:", {
                    pageNumber: recommendation.pageNumber,
                    totalPages: recommendation.totalPages,
                    total: recommendation.total,
                });

                // **Only update startIndex and endIndex if activity is NOT passed**
                if (!activity) {
                    const total = recommendation.total || recommendation.activities.length || 1; // guard against zero
                    recommendation.startIndex = (startIndex + incrementCard) % total;
                    recommendation.endIndex = (recommendation.startIndex + recommendation.pageSize) % total;

                    console.log(`After API Call: New startIndex=${recommendation.startIndex}, New endIndex=${recommendation.endIndex}`);
                }

                // Handle cyclic pagination when reaching the last page
                if (recommendation.pageNumber === recommendation.totalPages) {
                    recommendation.cycleData = true;
                    console.log("Reached last page, setting cycleData to true");
                    if (updatedActivities.length < recommendation.pageSize) {
                        // **Only update startIndex and endIndex if activity is NOT passed**
                        if (!activity && recommendation.endIndex > recommendation.activities.length) {
                            recommendation.endIndex = (0 + incrementCard - updatedActivities.length) % recommendation.total;
                        }

                            console.log(`Adjusted endIndex for last page: ${recommendation.endIndex}`);
                    }
                }
            } else {
                console.log(`Skipping API call for recommendation index ${i} (either cyclic mode or page number exceeded).`);
                if (!activity && recommendation.cycleData) {
                    if (!activity) {
                        recommendation.startIndex = (startIndex + incrementCard) % recommendation.total;
                        recommendation.endIndex = (startIndex + incrementCard + recommendation.pageSize) % recommendation.total;
                    }
                    console.log(`Cyclic mode update: New startIndex=${recommendation.startIndex}, New endIndex=${recommendation.endIndex}`);
                }
            }

            // Handle dislike replace and move activity to the end
            if (activity) {
                const actIndex = recommendation.activities.findIndex((act) => act.id === activity.id);
                if (actIndex !== -1) {
                    const movedActivity = recommendation.activities[actIndex];
                    const movedActivity2Index = (recommendation.endIndex) % recommendation.total;
                    const movedActivity2 = recommendation.activities[movedActivity2Index];

                    movedActivity.isMovedToEnd = true;

                    //movedActivity2.isMovedToEnd = false;

                    // Swap and move that activity to the next page 
                    recommendation.activities[actIndex] = movedActivity2;
                    recommendation.activities[movedActivity2Index] = movedActivity;

                    recommendation.activities[actIndex].isVelgClick = false;
                    recommendation.activities[actIndex].addDate = null;

                    recommendation.activities[movedActivity2Index].isVelgClick = false;
                    recommendation.activities[movedActivity2Index].addDate = null;



                }
            }

            // Order moved and normal activities
            const normalActivities = recommendation.activities.filter(act => !act.isMovedToEnd);
            const movedActivities = recommendation.activities
                .filter(act => act.isMovedToEnd)
                .map(({ isMovedToEnd, ...rest }) => rest); // Removes the property
            let finalActivities = [...normalActivities, ...movedActivities];

            recommendation.activities = finalActivities;


            // Handle cyclic slicing when startIndex > endIndex

            let fstartIndex = recommendation.startIndex;
            let fendIndex = recommendation.endIndex;
            let total = recommendation.total || recommendation.activities.length || 1;

            let pageActivities;
            if (fstartIndex < fendIndex) {
                pageActivities = recommendation.activities.slice(fstartIndex, fendIndex);
            } else {
                pageActivities = [
                    ...recommendation.activities.slice(fstartIndex, total),
                    ...recommendation.activities.slice(0, fendIndex)
                ];
            }

            // IMPORTANT: force pageActivities to never exceed pageSize
            if (pageActivities.length > recommendation.pageSize) {
                pageActivities = pageActivities.slice(0, recommendation.pageSize);
            }


            allActivities = pageActivities;
        }

        // Update state if there are activities
        if (allActivities.length > 0) {
            console.log("Setting activities with allActivities:", allActivities);
            setActivities(allActivities);
        } else {
            console.log("No new activities fetched.");
        }

        // Update pageNumber and visible count
        setPageNumber((prevPageNumber) => {
            const updatedPageNumber = prevPageNumber + 1 > recommendedAppData[0]?.totalPages ? 1 : prevPageNumber + 1;
            console.log(`Updating pageNumber from ${prevPageNumber} to ${updatedPageNumber}`);
            return updatedPageNumber;
        });

        setVisible((prevVisible) => {
            let newVisible = prevVisible + getPageSize();
            newVisible = newVisible > recommendedAppData[0]?.total ? recommendedAppData[0]?.total : newVisible;
            console.log(`Updating visible count from ${prevVisible} to ${newVisible}`);
            return newVisible;
        });

        // Simulated values for debugging
        const simulatedCurrentPage = recommendedAppData[0]?.pageNumber || 1;
        const simulatedCurrentVisible = recommendedAppData[0]?.visible || getPageSize();
        const returnPage = simulatedCurrentPage + 1;
        const returnVisible = simulatedCurrentVisible + getPageSize();

        console.log(`Final returning values - Page: ${returnPage}, Visible: ${returnVisible}`);

        // Delay setting isLoading to false after a small interval
        setTimeout(() => {
            setIsLoading(false);
            console.log("setIsLoading(false) after delay");
        }, 500);

        updateData();

        return { page: returnPage, visible: returnVisible };
    };


    const deleteActivity = async (activityId) => {
        setRecommendedAppData((prevData) => {
            return prevData.map((obj) => {
                let updatedObj = { ...obj };

                // Remove activity from both normal and moved lists
                let filteredActivities = updatedObj.activities.filter((act) => act.id !== activityId);
                let normalActivities = filteredActivities.filter((act) => !act.isMovedToEnd);
                let movedActivities = filteredActivities.filter((act) => act.isMovedToEnd);

                updatedObj.activities = [...normalActivities, ...movedActivities];

                // If the page becomes empty, adjust indices to move to a valid page
                if (updatedObj.activities.length === 0 && updatedObj.pageNumber > 1) {
                    updatedObj.pageNumber = Math.max(updatedObj.pageNumber - 1, 1);
                    updatedObj.startIndex = (updatedObj.startIndex - updatedObj.pageSize + updatedObj.total) % updatedObj.total;
                    updatedObj.endIndex = Math.min(updatedObj.startIndex + updatedObj.pageSize, updatedObj.total);
                }

                return updatedObj;
            });
        });

        // Prevent UI inconsistencies by delaying any new fetch
        setIsLoading(true);
        await new Promise((resolve) => setTimeout(resolve, 500)); // Simulate slight delay to sync UI
        setIsLoading(false);
    };



    const pdfRef = useRef()

    const [showModalCircle, setShowModalCircle] = useState(false);
    const [circleType, setCircleType] = useState('single');
    const [circleStatus, setCircleStatus] = useState('single');
    const [circleData, setCircleData] = useState([]);
    const [circleName, setCircleName] = useState("");
    const [reqType, setReqType] = useState("");
    const handleCloseModal = () => {
        setShowModalCircle(false)
        setReqType("")
        setTotalPrice(0)
        setTotalPersons([])
    }


    const tranformWidget = (i) => {

        
        // Assuming widget is an array of DOM elements
        let firstElement = document.getElementsByClassName('hoverid' + widget[0].id);
        let secondElement = document.getElementsByClassName('hoverid' + widget[i].id);

        let finalelemtn = document.getElementsByClassName('hoverid' + widget[i].id +'-header');

        // Check if elements are found
        if (firstElement.length === 0 || secondElement.length === 0) {
            return "translate(0px, 0px)";
        }

        // Get positions of both elements
        let firstRect = firstElement[0].getBoundingClientRect();
        let secondRect = secondElement[0].getBoundingClientRect();

        // Calculate differences in X and Y coordinates
        let diffX = secondRect.left - firstRect.left;
        let diffY = secondRect.top - firstRect.top;

        // Create translation strings
        let translateX = `translateX(${diffX}px)`;
        let translateY = `translateY(${diffY}px)`;

        // If you want to combine both translations into a single string
        let combinedTranslation = `translate(${diffX * 1.357143}px, ${diffY * 1.357143}px)`;

        // Now you can use translateX, translateY, or combinedTranslation wherever needed
        finalelemtn[0].style.transform = combinedTranslation;


    }

    function DateFormat(date) {
        // Parse the input date into a JavaScript Date object
        const parsedDate = new Date(date);

        // Use Intl.DateTimeFormat to format the date in Norwegian
        let formattedDate = new Intl.DateTimeFormat('no-NO', {
            day: '2-digit',
            month: 'long',
            year: 'numeric',
        }).format(parsedDate);

        // Split the formatted date to capitalize only the first letter of the month
        const parts = formattedDate.split(' ');
        const month = parts[1].charAt(0).toUpperCase() + parts[1].slice(1); // Capitalize the first letter of the month
        parts[1] = month; // Replace the month part with the capitalized version

        // Rejoin the parts and return the formatted date
        return parts.join(' ');
    }

    const handleSaveInvoiceInfo = async () => {
        try {
            const userObject = sessionStorage.getItem("userObject");
            if (!userObject) return;

            const parsedUserObject = JSON.parse(userObject);
            const userId = parsedUserObject.user.id; // Get user ID

            const invoiceData = {
                invoiceID: invoiceID === "" ? null : invoiceID,  // Convert "" to null,
                companyName,
                organizationNumber,
                invoiceAddress,
                invoiceSentTo,
                contactPerson,
                invoiceNote
            };

            const response = await FetchService.UpsertInvoiceInfo(userId, invoiceData);

            if (response.ok) {
                console.log("Invoice updated successfully!");
            } else {
                console.error("Failed to update invoice:", await response.text());
            }
        } catch (error) {
            console.error("Error:", error);
        }
    };


    const handlClearRecomendation = () => {

        

        recommendedOpenModals?.map(x => {
            x.isVelgClick = false;
            return x;
        }
        );

        recommendedAppData2?.activities?.map((obj, index) => {
            obj.isVelgClick = false;
            obj.addDate = null;
            return obj

        });

        recommendedAppData?.activities?.map((obj, index) => {
            obj.isVelgClick = false;
            obj.addDate = null;
            return obj

        });

        setRecommendedAppData([...recommendedAppData]);
        setRecommendedAppData2([...recommendedAppData2]);
        setRecommendedOpenModals([...recommendedOpenModals]);
        setWidget([]);

        saveRecommendSession();

    } 

  


    const handleBusinessSavedRequest = () => {

        
        let BookingActivityArray = [];
        //let widgets = recommendedOpenModals;

        widget.map((val, index) => {
            let activity = {
                ActivityId: val.id,
                ActivityName: val.name,
                ActivityDate: val.addDate,
                TimeFrom: val.fromTime || '',
                TimeTo: val.toTime || '',
                PersonCount: val.minPerson + val.totPersons,
                PricePerPerson: val.price,
                Category: val?.isCustomActivity ? "0" : val.subCategoryId,
            };
            BookingActivityArray.push(activity);
        });

        // Build the request body for BusinessSaved
        const bookingData = {
            booking: {
                BookingDate: new Date().toISOString(),   // current date in ISO format
                AdditionalInfo: circleName,
                UserId: users.id,                        // 👈 maps to BusinessSaved.UserId
                InvoiceId: users.id || null,            // pass if you have it
                City: city,
                Activities: BookingActivityArray
            }
        };

        saveRecommendSession();

        // Optionally, capture sessionStorage (browser state)
        bookingData.booking.SessionData = sessionStorage.getItem("recommendState");
        FetchService.SendBusinessSavedRequest(bookingData)
            .then((val) => {

                console.log("Saved Successfully:", val);
                // First: show circle modal (loading)
                setShowModalCircle(false);
                setShowModalDone(false);
                setIsLoading(true);

                // After a few seconds, switch to "Done"
                setTimeout(() => {
                    setIsLoading(false);
                    setShowModalCircle(false);
                    setShowModalDone(true);
                    setShowModalText("Dette har blitt lagret. Finn lagrede aktiviteter på hovedmenyen.");
                }, 500); // 2 sec delay (adjust as needed)

            })
            .catch((e) => console.log(e));
    };


    const handleBookingRequest = () => {

        

        saveRecommendSession();

        let BookingActivityArray = [];
        
        widget.map((val, index) => {

            let activity = {
                ActivityId: val.id,
                ActivityName: val.name,
                ActivityDate: val.addDate,
                TimeFrom: val.fromTime,
                TimeTo: val.toTime,
                PersonCount: val.minPerson + val.totPersons,
                PricePerPerson: val.price,
                Category: val?.isCustomActivity ? "0" : val.subCategoryId,
            };
            BookingActivityArray.push(activity);
        });

        // Sample data
        const bookingData = {
            BookingDate: new Date().toISOString(), // current date in ISO format
            BookingName: bookingName || null || EditData?.BookingDataParent?.bookingName,
            AdditionalInfo: text,
            Status: "PENDING_CONFIRM",
            SessionData: sessionStorage.getItem("recommendState"),
            InvoiceId: users.id,
            Activities: BookingActivityArray,
            City:city
        
        };




        FetchService.SendBusinessBookinglRequest(bookingData).then((val) => {


            handleNotifyAdmin();
            setBookingComplete(true);
            if (onBookingUpdate) {
                onBookingUpdate(true);  // directly trigger
            }
            else {
                setShowModalDone(true);

            }


        }).catch((e) => console.log(e))


    }



    const handleBookingUpdateRequest = (status = "PENDING_CONFIRM") => {

        

        setIsLoading(true);

   

        let BookingActivityArray = [];

        widget.map((val, index) => {

            let activity = {
                ActivityId: val.id,
                ActivityName: val.name,
                ActivityDate: val.addDate,
                TimeFrom: val.fromTime,
                TimeTo: val.toTime,
                PersonCount: val.minPerson + val.totPersons,
                PricePerPerson: val.price,
                Category: val?.isCustomActivity ? "0" : val.subCategoryId,
            };
            BookingActivityArray.push(activity);
        });

        saveRecommendSession();
        // Sample data
        const bookingData = {
            BookingDate: new Date().toISOString(), // current date in ISO format
            BookingName: bookingName || null || EditData?.BookingDataParent?.bookingName,
            AdditionalInfo: text,
            Status: status,
            SessionData: sessionStorage.getItem("recommendState"),
            InvoiceId: users.id,
            Activities: BookingActivityArray,
            City: city,
            BusinessBookingId: EditData?.BookingDataParent?.businessBookingId

        };


        FetchService.UpdateBusinessBookinglRequest(bookingData).then((val) => {
            handleNotifyAdmin();
            setShowModalDone(true);
        }).catch((e) => console.log(e))


    }




    const handleNotifyAdmin = () => {



        handleSaveInvoiceInfo();

        var requestt = {
        name: users.firstName + " " + users.lastName,
        email: "",
        subject: "Ny B2B forespørsel",
            body: `<div style="max-width: 100%; margin: 0 auto; padding: 1%; color: black; font-family: Arial, sans-serif;">
<!-- Header -->
<h3 style="text-align: center; margin: 2% 0; color: black;">Kunde e-post: ${users.email}</h3>

<!-- Activities Grid -->
<div style="display: inline-block; width: 100%;">
${widget.map((val, index) => `
<div style="width: 100%; background: #f9f9f9; border: 1px solid #d78b1c59; border-radius: 0.5em; padding: 2%; margin-bottom: 2%; box-sizing: border-box;">
<div style="display: flex; align-items: flex-start; gap: 2%;">
<!-- Activity Image -->
<div style="width: 30%; height: 122px;padding:0px 2%;">
    <img src="${val.images ? JSON.parse(val.images)[0].imageURL.replace('{baseApiURL}', 'https://funtlers.com/') : val.imageURL.replace('{baseApiURL}', 'https://funtlers.com/')}" 
        alt="Activity" 
        style="width: 100%; height: 100%; border-radius: 8px; object-fit: cover;">
</div>
<!-- Activity Details -->
<div style="flex: 1; ">
    <a href="https://funtlers.com/aktivitet/${val.name.trim().replace(/\s+/g, '-')}?id=${val.id}" 
        style="text-decoration: none; font-weight: bold; color: black; font-size: 1.1em; display: block;">
    ${val.name}
    </a>
    <div >
    <p style="margin: 1% 0;"><b>Dato:</b> ${DateFormat(val.addDate).toUpperCase()}</p>
        <p style="margin: 1% 0;">
          <b>Tid:</b> ${val?.fromTime ? val.fromTime : 'N/A'} - ${val?.toTime ? val.toTime : 'N/A'}
        </p>
    <p style="margin: 1% 0;"><b>Antall personer:</b> ${val.minPerson + val.totPersons}</p>
    <p style="margin: 1% 0;"><b>Pris per person:</b> ${val.price},- inkl mva</p>
    <p style="margin: 1% 0;"><b>Total aktivitetspris:</b> ${val.price * (val.minPerson + val.totPersons)},- inkl mva</p>
    </div>
</div>
</div>
</div>
`).join('')}
</div>

<!-- Total Price -->
<div style="text-align: center; margin: 2% 0;">
<strong style="font-size: 1.2em; color: black;">Total kostnad: ${totalPrice} NOK</strong>
</div>

<!-- Additional Info -->
<hr style="margin: 2% 0; border: 0; border-top: 1px solid #ddd;">
<div style="font-size: 1em; margin-bottom: 2%; color: black;">
<b>Tilleggsinformasjon:</b> ${text ? text : 'N/A'}
</div>

<!-- Invoice Info -->
<div style="border: 1px solid #d78b1c59; border-radius: 0.5em; padding: 2%; background: #f9f9f9;">
<h3 style="text-align: center; margin-bottom: 2%; color: black; font-size: 1.3em;">FAKTURA INFORMASJON</h3>
<table style="width: 100%; font-size: 0.9em; border-collapse: collapse;">
<tbody>
<tr>
    <td style="padding: 1%; border-bottom: 1px solid #ddd;">
    <strong>Bedriftsnavn:</strong> ${companyName}
    </td>
</tr>
<tr>
    <td style="padding: 1%; border-bottom: 1px solid #ddd;">
    <strong>Org nr:</strong> ${organizationNumber}
    </td>
</tr>
<tr>
    <td style="padding: 1%; border-bottom: 1px solid #ddd;">
    <strong>Faktura adresse:</strong> ${invoiceAddress}
    </td>
</tr>
<tr>
    <td style="padding: 1%; border-bottom: 1px solid #ddd;">
    <strong>Faktura sendes til:</strong> ${invoiceSentTo}
    </td>
</tr>
<tr>
    <td style="padding: 1%; border-bottom: 1px solid #ddd;">
    <strong> Kontakt person:</strong> ${contactPerson}
    </td>
</tr>
<tr>
    <td style="padding: 1%;">
    <strong>Merkes med:</strong> ${invoiceNote}
    </td>
</tr>
</tbody>
</table>
</div>
</div>` }
        setText('');



    FetchService.SendEmailRequest(requestt).then((val) => {
    }).catch((e) => console.log(e))
        
    }

    const handleCustomActivityEmail = (obj) => {

        let now = new Date();
        let dateformat = dayjs(now).locale('nb').format('DD.MMM.YYYY HH:mm:ss').toUpperCase();

        var requestt = {
            name: users.firstName + " " + users.lastName,
            email: "",
            subject: "BEDRIFT HAR LAGT TIL NY AKTIVITET",
            body: `<!DOCTYPE html>
                    <html lang="no">
                      <head>
                        <meta charset="UTF-8" />
                        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
                        <title>Booking Bekreftelse</title>
                        <style>
                          body {
                            font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
                            background: #f9f9f9;
                            padding: 20px;
                            margin: 0
                          }

                          .label-title {
                            font-size: 18px;
                            font-weight: bold;
                            margin-bottom: 15px;
                            color: #222
                          }

                          .header {
                            font-size: 16px;
                            margin-bottom: 25px;
                            text-align: center;
                            color: #555
                          }

                          .header span {
                            font-weight: bold;
                            color: #0077cc
                          }

                          .row {
                            display: flex;
                            flex-wrap: wrap;
                            margin-bottom: 12px;
                            border-bottom: 1px solid #eee;
                            padding-bottom: 10px
                          }

                          .cell-label {
                            width: 150px;
                            font-weight: bold;
                            color: #333
                          }

                          .cell-value {
                            flex: 1;
                            color: #555;
                            background-color: #fad8d8;
                            padding: 8px 12px;
                            border-radius: 6px;
                            font-size: 14px
                          }

                          .image-preview {
                            max-width: 90px;
                            border-radius: 6px;
                            box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1)
                          }

                          @media screen and (max-width:600px) {
                            .container {
                              padding: 20px
                            }

                            .row {
                              flex-direction: column
                            }

                            .cell-label {
                              width: 100%;
                              margin-bottom: 4px
                            }
                          }
                        </style>
                      </head>
                      <body>
                        <div class="container">
                          <div class="header">Brukeren <span id="userEmail">${JSON.parse(sessionStorage.getItem('userObject')).user.email}</span> kl. <span id="userTime">${dateformat}</span> legger til følgende egendefinerte aktivitet: </div>
                          <div class="row">
                            <div class="cell-label">Tittel</div>
                            <div class="cell-value">${customActivity_Default.title}</div>
                          </div>
                          <div class="row">
                            <div class="cell-label">Pris</div>
                            <div class="cell-value">${obj.price} NOK</div>
                          </div>
                          <div class="row">
                            <div class="cell-label">Dato</div>
                            <div class="cell-value">${obj.date}</div>
                          </div>
                            <div class="row">
                            <div class="cell-label">TID</div>
                            <div class="cell-value">${obj?.fromTime ? obj?.fromTime : 'N/A'} -  ${obj.toTime ? obj?.toTime : 'N/A'}</div>
                          </div>
                          <div class="row">
                            <div class="cell-label">Antall</div>
                            <div class="cell-value">${obj.totPersons}</div>
                          </div>
                          <div class="row">
                            <div class="cell-label">Totalpris</div>
                            <div class="cell-value">${obj.price * obj.totPersons} NOK</div>
                          </div>
                          <div class="row">
                            <div class="cell-label">Kategori</div>
                            <div class="cell-value">${customActivity_Default.kategori}</div>
                          </div>
                          <div class="row">
                            <div class="cell-label">Bilde</div>
                            <div class="cell-value">
                              <img class="image-preview" src="https://funtlers.com${customActivity_Default.picture}" />
                            </div>
                          </div>
                        </div>
                      </body>
                    </html>` }
                    setText('');
                    FetchService.SendEmailRequest(requestt).then((val) => {
                    }).catch((e) => console.log(e))


    }

    
    const handleCircle = async (status) => {

        
        var CircleDetails = []
        setIsLoading(true)
        widget.map((val) => {
            const { id } = val;
            var circleObj = {
                ActivityId:id
            }

            CircleDetails.push(circleObj)
        })
        var Circle = {
                circleName:circleName,
                circleStatus: status,
                circleType: circleType,
        }
        var obj = {
            Circle: Circle,
            circleDetails: CircleDetails
        }
        setIsLoading(true);
        FetchService.AddCircle(obj).then((val) => {
            handleCloseModal()
            setCircleName("")
            CircleDetails = []
            //setWidget([])
            const updatedActivities = activities.map((obj) => {
                    return { ...obj, isVelgClick: null, isVelgDisable: null };
            });

            setActivities(updatedActivities);


            if (status === "pending") {
                
     
                handleBookingRequest();
                handlClearRecomendation();
            }

            // Example: Add 1.5 second delay before hiding loader
            setTimeout(() => {
                setIsLoading(false);
            }, 1500);
        }).catch((e) => {
            // Example: Add 1.5 second delay before hiding loader
            setTimeout(() => {
                setIsLoading(false);
            }, 1500);
            console.log(e)
        })
    }
    const handleDeleteCircle = async (id) => {
        FetchService.DeleteCircle(id).then((val) => {

            const filteredData = circleData.filter((data) => data.circleId !== id)
            setCircleData(filteredData)
        }).catch((e) => console.log(e))
    }
    const getCircles = async (status) => {
        setCircleData([]); // Clear the existing data before fetching new data

        FetchService.getAllCircles(status, circleType)
            .then((val) => {
                setCircleData(prevData => {
                    // Convert both old and new data into a Set to remove duplicates
                    const uniqueData = [...new Map([...prevData, ...val.data].map(item => [item.id, item])).values()];
                    return uniqueData;
                });
            })
            .catch((e) => console.log(e));
    };

    const getCircleById = async () => {
        setWidget([])
        setIsLoading(true)
        FetchService.GetCircleById('saved', circleType, "id", locat.state['cirId']).then((val) => {
            setWidget(val.data)
            setCircleName(val.data[0]['circleName'])
            //console.log(val.data)
            setIsLoading(false)
            if (val.data.length === 1) {
                setOne(true)
                setTwo(false)
                setFour(false)
                setSix(false)
                setTwelve(false)
            }
            if (val.data.length === 2) {
                setOne(false)
                setTwo(true)
                setFour(false)
                setSix(false)
                setTwelve(false)
            }
            if (val.data.length === 4) {
                setOne(false)
                setTwo(false)
                setFour(true)
                setSix(false)
                setTwelve(false)
            }
            if (val.data.length === 6) {
                setOne(false)
                setTwo(false)
                setFour(false)
                setSix(true)
                setTwelve(false)
            }
            if (val.data.length === 12) {
                setOne(false)
                setTwo(false)
                setFour(false)
                setSix(false)
                setTwelve(true)
            }
        }).catch((e) => {

        setIsLoading(false)
            console.log(e)
        })
    }
    const handleCircleUpdate = async () => {
        let CircleDetails = [];

        widget.forEach((val) => {
            const { id } = val;
            let circleObj = {
                circleId: locat.state['cirId'],
                ActivityId: id
            };

            // Check if the ActivityId already exists in the array
            if (!CircleDetails.some((item) => item.ActivityId === id)) {
                CircleDetails.push(circleObj);
            }
        });

        let Circle = {
            Id: locat.state['cirId'],
            circleName: circleName,
            circleStatus: 'saved',
            circleType: circleType
        };

        let obj = {
            Circle: Circle,
            circleDetails: CircleDetails
        };

        FetchService.UpdateCircle(obj)
            .then((val) => {
                handleCloseModal();
                setCircleName("");
                navigate(-1);
                getCircles("saved");
                setUpdateState(-1);
                setWidget([]);
            })
            .catch((e) => console.log(e));
    };


    useEffect(() => {
        if (action && (action === 'edit2' || action === 'add2')) {
            setCircleType("multiple")

            let button = JSON.parse(sessionStorage.getItem("button"));
            if (button) {

                    setOne(button.one);
                    setTwo(button.two);
                    setFour(button.four);
                    setSix(button.six);
                    setTwelve(button.twelve);


            }
            else {
                setOne(false)
                setTwo(true)
                setFour(false)
                setSix(false)
                setTwelve(false)

            }

          
        }
        if(action==="edit1") {
            setCircleType("single")
        }

    }, [])
    useEffect(() => {
            getCircles("saved")
    }, [circleType,action])
    useEffect(() => {
        if (locat.state !== null) {
            getCircleById()
            setUpdateState(1)
        }
        if (locat.state === null) {
            setUpdateState(-1)
        }
    }, [locat])
    var circlesArr = []
    var circlesArr2 = []
    var circlesIds = []
    var circleIdArr=0
    var count = 0
    const [hoverActivity, setHoverActivity] = useState({})
    const [clickBookingRequest, setClickBookingRequest] = useState(false)

    const [showModalReqBooking, setShowModalReqBooking] = useState(false)
    const [showModalReqBooking2, setShowModalReqBooking2] = useState(false)

    const [showModalDone, setShowModalDone] = useState(false)
    const [showModalText, setShowModalText] = useState("")

    const [users,setUsers]=useState()
    useEffect(() => {
        const userObject = sessionStorage.getItem("userObject");
        const { user } = JSON.parse(userObject);
        setUsers(user)
        const fetchInvoiceInfo = async () => {
            try {
                
                const apires = await FetchService.GetInvoiceInfo(user.id);
                if (apires) {
                    let response = apires.data;
                    setcompanyName(response.companyName || '');
                    setorganizationNumber(response.organizationNumber || '');
                    setinvoiceAddress(response.invoiceAddress || '');
                    setinvoiceSentTo(response.invoiceSentTo || '');
                    setcontactPerson(response.contactPerson || '');
                    setinvoiceNote(response.invoiceNote || '');
                    setinvoiceID(response.invoiceID || '');

                }
            } catch (error) {
                console.error("Error fetching invoice info:", error);
            }
        };

        fetchInvoiceInfo();

    }, [])
    useEffect(() => {
        var dataa = circleData.filter((val) => val.circleName.toLowerCase().includes(searchQuery.toLowerCase()))
        setQueryData(dataa)
    }, [searchQuery])

    // 🔹 Build booking data on every change
    const buildBookingData = () => {
        debugger;

        // Normalize activities into camelCase for consistency
        const bookingActivities = widget.map((val) => ({
            activityId: val.id,
            activityName: val.name,
            activityDate: val.addDate,
            timeFrom: val.fromTime || "",
            timeTo: val.toTime || "",
            personCount: val.minPerson + val.totPersons,
            pricePerPerson: val.price,
            category: val?.isCustomActivity ? "0" : val.subCategoryId,
            reason: recommendedOpenModals.find(x => x.id === val.id && x?.isVelgClick)?.reason || null
        }));

        return {
            booking: {
                bookingDate: new Date().toISOString(), // current date in ISO format
                bookingName:
                    bookingName ||
                    EditData?.BookingDataParent?.bookingName ||
                    null,
                additionalInfo: text,
                status:
                    EditData?.BookingDataParent?.status || "PENDING_CONFIRM",
                sessionData: sessionStorage.getItem("recommendState"),
                invoiceId: EditData?.BookingDataParent?.invoiceId ? EditData?.BookingDataParent?.invoiceId :  users?.id,
                userId: EditData?.BookingDataParent?.invoiceId ? EditData?.BookingDataParent?.invoiceId : users?.id,
                activities: bookingActivities,
                previousActivitiesJson: EditData?.BookingDataParent?.previousActivitiesJson,
                userEmail: EditData?.BookingDataParent?.userEmail,
                city: city,
                businessBookingId:
                    EditData?.BookingDataParent?.businessBookingId,
            },
        };
    };

    // 🔹 Anytime widget/circleName/city changes, notify parent
    useEffect(() => {
        if (onChangeUpdate) {
            onChangeUpdate(buildBookingData());
        }
    }, [widget, circleName, city, users, onChangeUpdate]); // dependencies


    const handleSaveClick = () => {
        if (onSave) {

            

            //if (EditData?.Mode === "isEditSave") {
            //    handleBookingRequest();
            //    setShowModalDone(false);


            //}
            //else if (EditData?.Mode === "isEditAdminRequest") {

            //    handleBookingUpdateRequest("CHANGES_REQUIRED_ADMIN");
            //}

            setIsLoading(true);
            // ✅ set interval for 2 sec, then clear after onSave
            const intervalId = setInterval(async () => {
                setIsLoading(false);

                onSave();

                clearInterval(intervalId); // ✅ stop interval after one run
            }, 400);

        }
    };


    const handleConfirmClick = () => {
        if (onConfirm) {



            //if (EditData?.Mode === "isEditSave") {
            //    handleBookingRequest();
            //    setShowModalDone(false);


            //}
            //else if (EditData?.Mode === "isEditAdminRequest") {

            //    handleBookingUpdateRequest("CHANGES_REQUIRED_ADMIN");
            //}

            setIsLoading(true);
            // ✅ set interval for 2 sec, then clear after onSave
            const intervalId = setInterval(async () => {
                setIsLoading(false);

                onConfirm();

                clearInterval(intervalId); // ✅ stop interval after one run
            }, 400);

        }
    };





    const handleBookingEditSave = (data) => {

        
        if (data.isCustomActivity) {
             let updatedActivity   = {
                id: Date.now(),
                name: data.title,
                price: Number(data.price),
                pricePerPerson: Number(data.price),
                minPerson: 1,
                totPersons: Number(data.totalPersons),
                personCount: Number(data.totalPersons),
                addDate: data.date,
                kategori: data.kategori || "EGEN PLANLAGT AKTIVITET",
                isCustomActivity: true,
                images: "[{\"imageURL\":\"{baseApiURL}/static/media/booking-confirmation-img.8df3502e7365d6433146.png\"}]",
                date: data.date,
                validPeriodStart: data.date,
                validPeriodEnd: data.date,
                description: "DENNE AKTIVITETEN OG ALLE DETALJENE RUNDT AKTIVITETEN ER LAGT TIL AV BRUKEREN SELV. DEN ER IKKE PLANLAGT ELLER ANSVARLIGGJORT AV FUNTLERS",
                fromTime: data.fromTime,
                toTime: data.toTime,
                reason:data?.reason,

            }
            // Find target modal index
            const targetIndex = recommendedOpenModals.findIndex(
                (modal) => modal.isVelgClick === false || modal.isVelgClick == null
            );

            updatedActivity.isVelgClick = true;

            if (targetIndex !== -1) {
                // Update recommendedOpenModals immutably
                setRecommendedOpenModals((prev) => {
                    const arr = [...prev];
                    arr[targetIndex] = updatedActivity;
                    return arr;
                });

                simulateDragging(recommendedOpenModals[targetIndex]);
            }


        }
        else {
            const targetModal = recommendedOpenModals.find(
                (modal) => modal.isVelgClick == false || modal.isVelgClick == null
            );

            //targetModal.price = Number(CustomActivityModal.price);
            targetModal.totPersons = Number(data.totalPersons) - (targetModal.minPerson || 0);
            targetModal.personCount = Number(data.totalPersons) - (targetModal.minPerson || 0);

            targetModal.addDate = data.date;
            targetModal.date = data.date;
            targetModal.fromTime = data.fromTime;
            targetModal.toTime = data.toTime;
            targetModal.reason = data.reason;

            //if (action === "rec1") {
            //    handleVelgClick(null, targetModal, true);
            //    simulateDragging(targetModal);
            //    setTimeout(() => {
            //        setIsLoading(false); // Stop loading after 1 second
            //        const updatedModals = [...recommendedOpenModals];
            //        setRecommendedOpenModals(updatedModals);
            //    }, 1000);

            //} else 
            if (action === "rec2" || action === "rec1") {
                // You might want to pass targetModal to your clickFire logic
                setIsLoading(true); // Start loading

                targetModal.isVelgClick = true;

                simulateDragging(targetModal);

                setTimeout(() => {
                    setIsLoading(false); // Stop loading after 1 second
                    const updatedModals = [...recommendedOpenModals];
                    setRecommendedOpenModals(updatedModals);
                }, 1000);
            }
        }
     
    };



    const handleCancelClick = () => {
        if (onCancel) {
            onCancel(); // parent save trigger
        }
    };

    // 🔹 Anytime widget/circleName/city changes, notify parent
    useEffect(() => {
        
        if (bookingComplete && onBookingUpdate && !showModalDone) {
            onBookingUpdate(true);
        }
    }, [bookingComplete, showModalDone]); // dependencies



    const prevValue = useRef(showModalReqBooking);

    useEffect(() => {
        // keep track of previous value
        debugger;

        if (prevValue.current === true && showModalReqBooking === false && clickBookingRequest==false) {
            if (onBookingClose) {
                onBookingClose(true);
            }
        }

        // update ref for next render
        prevValue.current = showModalReqBooking;
    }, [showModalReqBooking, clickBookingRequest]);




    async function GetAllSubCategories() {
        try {
            const response = await FetchService.GetAllSubCategories();
            return response.data;  // Assuming response.data is an array of subCategory
        } catch (error) {
            console.error("Error fetching subCategory:", error);
            return [];
        }
    }
    const fetchsubCategory = async () => {
        try {

            if (subCategories.length > 0) return; // Skip fetching if subcategories already exist
            restoreRecommendSession();
        


            const data = await GetAllSubCategories();
            const formattedData = data.map(sub => ({
                value: sub.name,
                id: sub.id,
                icon: sub.icon
            }));

            setSubCategories(formattedData);
            //setSelectedSubCategory(null); // Ensure there is a valid first item
            //setselectedSubCategoryList([]);

        } catch (error) {
            console.error("Error fetching subCategory:", error);
        }
    };


    useEffect(() => {
        fetchsubCategory(); // preload once when app starts
    }, []);



       

    const CategoryObjecy = (id) => {
        
        let categoryObject = subCategories.filter(obj => obj.id == id);
        return categoryObject[0];
    }

    // Compute disabled state
    const isDisabledVelg = !(
        (one === true && widget?.length < 1) ||
        (two === true && widget?.length < 2) ||
        (four === true && widget?.length < 4) ||
        (six === true && widget?.length < 6) ||
        (twelve === true && widget?.length < 12)
    );


  



    const mapBookingData = (modal) => {
        
        if (!modal || !Array.isArray(modal)) return [];

        return modal.map((activity) => {
            let updatedActivity = { ...activity };

            if (EditData?.BookingDataParent?.activities?.length) {
                // Find the matching bookingActivity by activityId
                let bookingActivity = EditData.BookingDataParent.activities.find(
                    (x) => x.activityId === activity.id
                );

                if (bookingActivity) {
                    updatedActivity.isCanceled = bookingActivity.isCanceled ?? updatedActivity.isCanceled;
                    updatedActivity.isDeleted = bookingActivity.Deleted ?? updatedActivity.isDeleted;
                    updatedActivity.reason = bookingActivity.reason ?? updatedActivity.reason;


                }
            }

            return updatedActivity;
        });
    };

    // Inside your component
useEffect(() => {
    if (EditData?.BookingDataParent?.activities?.length) {
        const canceledIds = EditData.BookingDataParent.activities
            .filter(x => x.isCanceled)
            .map(x => x.activityId);

        if (canceledIds.length > 0) {
            setWidget(prev =>
                prev.filter(obj => !canceledIds.includes(obj.id))
            );
        }
    }
}, [EditData, setWidget]);


    //const fixBookingEditCardHeight = () => {
        
    //    setTimeout(() => {
    //        const cards = document.querySelectorAll(".booking-card");
    //        let maxHeight = 0;
    //        cards.forEach(c => maxHeight = Math.max(maxHeight, c.offsetHeight));
    //        cards.forEach(c => c.style.height = maxHeight + "px");
    //    }, 100)
    //}



    const renderPage = () => {

    

        return (<>
            {


                EditData?.Mode !== "isEditAdminRequest" && <> {action && (action === "rec1") &&
                    <div className="row row-back">
                        {EditData?.View !== "admin" && <>
                            <div className="sub-category-container-recommend2">
                        <h4 class="text-center fw-bold">VELG BY:</h4>
                        <div className="row d-flex align-items-center justify-content-center">
                            {cities.map((cityl, idx) => (
                                <div className="col-2 uppercase" key={cityl.value}>
                                    <button
                                        onClick={() => {
                                            setCity(cityl.value);
                                            ChangeSubCategory();
                                            setSelectedSubCategory(null);
                                        }}
                                        className={`w-100 my-2 uppercase ${city == cityl.value ? "btnOrder-orange " : "btnOrder3 "}`}
                                    >
                                        {cityl.label}
                                    </button>
                                </div>
                            ))}
                        </div>


                    </div>
                    <div className="sub-category-container sub-category-container2 ">
                        {subCategories.map((option) => (
                            <label key={option.id} className={`sub-box ${selectedSubCategory === option.id ? "selected" : ""} ${!city ? " disabled" : ""}`}>
                                <input
                                    type="radio"
                                    name="subCategory"
                                    value={option.id}
                                    checked={selectedSubCategory === option.id}
                                    onChange={() => { setSelectedSubCategory(option.id); ChangeSubCategory(); }}
                                    className={`hidden-radio ${!city ? " disabled-container" : ""}`}
                                />
                                < i class={`sub-category-box ${option.icon}`}></i>

                                &nbsp;&nbsp;{option.value}
                            </label>
                        ))}
                    </div> </>}



                        {EditData?.View === "admin" && <>
                                <div className="">
                                    <div className="sub-category-container sub-category-container2 ">

                                        <h4 className="text-center fw-bold w-100">REDIGER VALG</h4>

                                        {/* Three Column Layout */}
                                        <div 
                                            className="w-full p-1 dflex">
                                            <div className="w-100 d-flex sub-box-2-top-sec">
                                                {/* Card 1: Location */}
                                                <div style={{ width: "33%", zoom: "0.77" }} className="sub-box-2 w-1/3 border border-orange-200   rounded-xl shadow-sm p-5 text-center hover:shadow-md transition-all duration-200">
                                                    <div className="flex items-center justify-center gap-2 mb-2">
                                                        <i className="ri-map-pin-line text-orange-500 text-xl"></i>
                                                        <h4 className="font-medium uppercase text-gray-800">Lokasjon</h4>
                                                    </div>
                                                    <p className="uppercase text-base font-medium text-gray-700  px-5 py-2 inline-block ">
                                                        {city?.replace("all", "alle") || "Alle"}
                                                    </p>
                                                </div>

                                                {/* Card 2: Activity Count */}
                                                <div style={{ width: "33%", zoom: "0.77" }}
                                                    className="sub-box-2 w-1/3 border border-orange-200  rounded-xl shadow-sm p-5 text-center hover:shadow-md transition-all duration-200">
                                                    <h4 className="  uppercase text-gray-800 mb-2">
                                                        Antall Aktiviteter
                                                    </h4>
                                                <p className="text-2xl font-bold text-orange-600">
                                                        {/*{one && "1"}*/}
                                                        {/*{two && "2"}*/}
                                                        {/*{four && "4"}*/}
                                                        {/*{six && "6"}*/}
                                                        {/*{twelve && "12"}{" "}*/}
                                                         {/*{JSON.parse(sessionStorage?.getItem("widget"))}*/}
                                                        {(() => {
                                                            try {
                                                                const widget = JSON.parse(sessionStorage.getItem("recommendState") || "null");
                                                                return widget?.widget.length || "No widget found";
                                                            } catch {
                                                                return "";
                                                            }
                                                        })()}


                                                    </p>
                                                </div>

                                                {/* Card 3: Categories */}
                                                <div style={{ width: "33%", zoom: "0.77" }}
                                                    className="sub-box-2 w-1/3 border border-orange-200  rounded-xl shadow-sm p-5 text-center hover:shadow-md transition-all duration-200" >
                                                    <h4 className="font-medium uppercase text-gray-800 mb-2">
                                                        Kategorier
                                                    </h4>
                                                    {/*<p className="text-xs text-gray-500 mb-4">Valgt opptil 4 kategorier</p>*/}

                                                    <div className="flex flex-wrap justify-center gap-2">
                                                        {subCategories
                                                        .filter((x) => x.id===selectedSubCategory)
                                                            .map((category) => {
                                                                const Icon = category.icon;
                                                                return (
                                                                    <div
                                                                        key={category.id}
                                                                        className="flex items-center gap-2 rounded-full px-3 py-1 shadow-sm text-sm font-medium bg-orange-500 text-white transition-none"
                                                                    >
                                                                        <i className={`${Icon}`}></i>
                                                                        {category.value}
                                                                        <div className="flex-shrink-0 p-1 bg-white/20 backdrop-blur-sm rounded-full">
                                                                            <i className="ri-checkbox-circle-line"></i>
                                                                        </div>
                                                                    </div>
                                                                );
                                                            })}

                                                       
                                                    </div>
                                                </div>
                                            </div>
                                        </div>



                                    </div>
                                </div>

                            </>}


                    <div className={`sub-category-container sub-category-container2 activityloader2 `}>

                        {recommendedOpenModals && recommendedOpenModals.length > 0 && (
                            <div className="row row_custom">
                                {recommendedOpenModals.map((activity) => (
                                    <OrderPlanSearchResultCard
                                        key={activity.id}
                                        isType="recommend-1"
                                        isEditButton={true}
                                        isVelgDisable={
                                            (one === true && widget.length < 1) ||
                                            (two === true && widget.length < 2) ||
                                            (four === true && widget.length < 4) ||
                                            (six === true && widget.length < 6) ||
                                            (twelve === true && widget.length < 12)
                                        }
                                        clickFire={(e) => handleVelgClick(e, activity)}
                                        handleDrag={(e) => handleDrag(e, activity)}
                                        handleActivityEditClick={() => handleActivityEditClick(activity)}
                                        handleDeleteActivity={() => handleDltActivityforSingleRecommended(activity)}
                                        CardImg={
                                            activity.images
                                                ? JSON.parse(activity.images)?.[0].imageURL
                                                : 'bookingImg'
                                        }
                                        CardRabat={activity.discountPercent}
                                        CardHeading={activity.name}
                                        CardDesc={
                                            activity.price > 0
                                                ? activity.price +
                                                (activity.priceModel === "time"
                                                    ? "kr per time"
                                                    : activity.priceModel === "person"
                                                        ? " NOK"
                                                        : " NOK")
                                                : "Gratis"
                                        }
                                        Data={activity}
                                        source="customer"
                                        peopleNumber={peopleNumber}
                                        city={city}
                                        activityType={type}
                                        price={budget}
                                    />
                                ))}

                                <div className="shuffle-left-section">
                                    <div className="tooltip-wrapper">
                                        <button
                                            className={`shuffle-left ${isDisabledVelg ? 'disabled' : ''}`}
                                            disabled={isDisabledVelg}
                                            tabIndex="-1"
                                            role="button"
                                            aria-label="Next slide"
                                            onClick={() => shuffleItems(true)}
                                        >
                                            <i className="ri-shuffle-line"></i>
                                            <span className="tooltip-text">HENT NYE FORSLAG</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}


                    </div>




                </div>} {action && (action === 'rec2') && <>


                        <div class="row-back">
                            {EditData?.View !== "admin" && <>
                                <div className="sub-category-container-recommend2">
                                    <h4 class="text-center  fw-bold">VELG BY:</h4>
                                    <div className="row d-flex align-items-center justify-content-center">
                                        {cities.map((cityl, idx) => (
                                            <div className="col-2 uppercase" key={cityl.value}>
                                                <button
                                                    onClick={() => {
                                                        setCity(cityl.value);
                                                        setOne(true);
                                                        setTwo(false);
                                                        setFour(false);
                                                        setSix(false);
                                                        setTwelve(false);
                                                        handleActivityCountChange(0);
                                                    }}
                                                    className={`w-100 my-2 uppercase ${city == cityl.value ? "btnOrder-orange" : "btnOrder3"}`}
                                                >
                                                    {cityl.label}
                                                </button>
                                            </div>
                                        ))}
                                    </div>


                                </div>
                                <div className="sub-category-container-recommend2">
                                    <h4 class="text-center admin_heading fw-bold text-uppercase">VELG ØNSKET ANTALL:</h4>
                                    <div className="row d-flex align-items-center justify-content-center text-uppercase">
                                        <div className="col-3">
                                            <button
                                                onClick={() => {
                                                    let chkd = checkdowngrade(2);
                                                    if (chkd && widget.length > 2) {
                                                        setShowModalRmv(widget.length - 2);
                                                    }
                                                    setOne(false);
                                                    setTwo(true);
                                                    setFour(false);
                                                    setSix(false);
                                                    setTwelve(false);
                                                    handleActivityCountChange(2);
                                                }}
                                                className={`w-100 my-2 ${two ? "btnOrder-orange" : "btnOrder3"}  ${!city ? " disabled" : ""}`}
                                            >
                                                2 AKTIVITETER
                                            </button>
                                        </div>
                                        <div className="col-3">
                                            <button
                                                onClick={() => {
                                                    let chkd = checkdowngrade(4);
                                                    if (chkd && widget.length > 4) {
                                                        setShowModalRmv(widget.length - 4);
                                                    }
                                                    setOne(false);
                                                    setTwo(false);
                                                    setFour(true);
                                                    setSix(false);
                                                    setTwelve(false);
                                                    handleActivityCountChange(4);
                                                }}
                                                className={`w-100 my-2 ${four ? "btnOrder-orange" : "btnOrder3"} ${!city ? " disabled" : ""}`}
                                            >
                                                4 AKTIVITETER
                                            </button>
                                        </div>
                                        <div className="col-3">
                                            <button
                                                onClick={() => {
                                                    let chkd = checkdowngrade(6);
                                                    if (chkd && widget.length > 6) {
                                                        setShowModalRmv(widget.length - 6);
                                                    }
                                                    setOne(false);
                                                    setTwo(false);
                                                    setFour(false);
                                                    setSix(true);
                                                    setTwelve(false);
                                                    handleActivityCountChange(6);
                                                }}
                                                className={`w-100 my-2 ${six ? "btnOrder-orange" : "btnOrder3"} ${!city ? " disabled" : ""}`}
                                            >
                                                6 AKTIVITETER
                                            </button>
                                        </div>
                                        <div className="col-3">
                                            <button
                                                onClick={() => {
                                                    let chkd = checkdowngrade(12);
                                                    if (chkd && widget.length > 12) {
                                                        setShowModalRmv(widget.length - 12);
                                                    }
                                                    setOne(false);
                                                    setTwo(false);
                                                    setFour(false);
                                                    setSix(false);
                                                    setTwelve(true);
                                                    handleActivityCountChange(12);

                                                }}
                                                className={`w-100 my-2 ${twelve ? "btnOrder-orange" : "btnOrder3"} ${!city ? " disabled" : ""}`}
                                            >
                                                12 AKTIVITETER
                                            </button>
                                        </div>
                                    </div>


                                </div>
                                {RenderRecommendation2Subox()}

                            </>}
                            {EditData?.View === "admin" && <>
                                <div className="">
                                    <div className="sub-category-container sub-category-container2 ">

                                        <h4 className="text-center fw-bold w-100">REDIGER VALG</h4>

                                        {/* Three Column Layout */}
                                        <div 
                                            className="w-full p-1 dflex">
                                            <div className="w-100 d-flex sub-box-2-top-sec">
                                                {/* Card 1: Location */}
                                                <div style={{ width: "33%", zoom: "0.77" }} className="sub-box-2 w-1/3 border border-orange-200   rounded-xl shadow-sm p-5 text-center hover:shadow-md transition-all duration-200">
                                                    <div className="flex items-center justify-center gap-2 mb-2">
                                                        <i className="ri-map-pin-line text-orange-500 text-xl"></i>
                                                        <h4 className="font-medium uppercase text-gray-800">Lokasjon</h4>
                                                    </div>
                                                    <p className="uppercase text-base font-medium text-gray-700  px-5 py-2 inline-block ">
                                                        {city?.replace("all", "alle") || "Alle"}
                                                    </p>
                                                </div>

                                                {/* Card 2: Activity Count */}
                                                <div style={{ width: "33%", zoom: "0.77" }}
                                                    className="sub-box-2 w-1/3 border border-orange-200  rounded-xl shadow-sm p-5 text-center hover:shadow-md transition-all duration-200">
                                                    <h4 className="  uppercase text-gray-800 mb-2">
                                                        Antall Aktiviteter
                                                    </h4>
                                                    <p className="text-2xl font-bold text-orange-600">
                                                        {/*{one && "1"}*/}
                                                        {/*{two && "2"}*/}
                                                        {/*{four && "4"}*/}
                                                        {/*{six && "6"}*/}
                                                        {/*{twelve && "12"}{" "}*/}
                                                        {/*{JSON.parse(sessionStorage?.getItem("widget"))}*/}
                                                        {(() => {
                                                            try {
                                                                const widget = JSON.parse(sessionStorage.getItem("recommendState") || "null");
                                                                return widget?.widget.length || "No widget found";
                                                            } catch {
                                                                return "";
                                                            }
                                                        })()}
                                                    </p>
                                                </div>

                                                {/* Card 3: Categories */}
                                                <div style={{ width: "33%", zoom: "0.77" }}
                                                    className="sub-box-2 w-1/3 border border-orange-200  rounded-xl shadow-sm p-5 text-center hover:shadow-md transition-all duration-200" >
                                                    <h4 className="font-medium uppercase text-gray-800 mb-2">
                                                        Kategorier
                                                    </h4>
                                                    {/*<p className="text-xs text-gray-500 mb-4">Valgt opptil 4 kategorier</p>*/}

                                                    <div className="flex flex-wrap justify-center gap-2">
                                                        {subCategories
                                                            .filter((x) => selectedSubCategoryList.includes(x.id))
                                                            .map((category) => {
                                                                const Icon = category.icon;
                                                                return (
                                                                    <div
                                                                        key={category.id}
                                                                        className="flex items-center gap-2 rounded-full px-3 py-1 shadow-sm text-sm font-medium bg-orange-500 text-white transition-none"
                                                                    >
                                                                        <i className={`${Icon}`}></i>
                                                                        {category.value}
                                                                        <div className="flex-shrink-0 p-1 bg-white/20 backdrop-blur-sm rounded-full">
                                                                            <i className="ri-checkbox-circle-line"></i>
                                                                        </div>
                                                                    </div>
                                                                );
                                                            })}

                                                        {selectedSubCategoryList.length > 3 && (
                                                            <span className="text-xs text-gray-500">
                                                                +{selectedSubCategoryList.length - 3} flere
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>



                                    </div>
                                </div>

                            </>}

                        <div className={`sub-category-container sub-category-container2 activityloader2 `}>
                            {/*this is data <div><pre>{JSON.stringify(recommendedAppData2, null, 2)}</pre></div>*/}

                            {recommendedOpenModals && recommendedAppData2 && recommendedAppData2.length > 0 && (
                                <div className={`row row_custom `}>
                                    {(recommendedOpenModals).map((activity, index) => (
                                        (
                                            <OrderPlanSearchResultCard
                                                key={activity.id} // Ensure unique keys
                                                isType={"recommend-2"}
                                                CategoryDetails={CategoryObjecy(activity?.subCategoryId)}
                                                isEditButton={true}
                                                isVelgDisable={((one === true && widget.length < 1) || (two === true && widget.length < 2) || (four === true && widget.length < 4) || (six === true && widget.length < 6) || (twelve === true && widget.length < 12))}
                                                clickFire={(e) => {
                                                    setIsLoading(true); // Start loading

                                                    activity.isVelgClick = true;

                                                    simulateDragging(activity);

                                                    setTimeout(() => {
                                                        setIsLoading(false); // Stop loading after 1 second
                                                        const updatedModals = [...recommendedOpenModals];
                                                        setRecommendedOpenModals(updatedModals);
                                                    }, 1000);
                                                }}
                                                handleDrag={(e) => handleDrag(e, activity)}
                                                handleActivityEditClick={(e) => {

                                                    setRecommendedOpenModalsSingleIndex(index);
                                                    setSelectedDateVELG(recommendedOpenModals[index]?.addDate);
                                                    setFromTime(recommendedOpenModals[index]?.fromTime);
                                                    setToTime(recommendedOpenModals[index]?.toTime);
                                                    setTotalPersons(recommendedOpenModals[index]?.totPersons);
                                                    setComments(recommendedOpenModals[index]?.reason);
                                                }}
                                                handleDeleteActivity={(e) => handleDltActivityforMultipleRecommended(activity)}
                                                CardImg={
                                                    activity.images
                                                        ? JSON.parse(activity.images)?.[0].imageURL
                                                        : 'bookingImg'
                                                }
                                                CardRabat={activity.discountPercent}
                                                CardHeading={activity.name}
                                                CardDesc={
                                                    activity.price > 0
                                                        ? activity.price + " NOK"
                                                        : "Gratis"
                                                }
                                                Data={activity}
                                                source="customer"
                                                peopleNumber={peopleNumber}
                                                city={city}
                                                activityType={type}
                                                price={budget}
                                                onDateChange={handleDateChangeForModal}
                                                onShowCustomActivityDetails={handleShowCustomActivityDetails}

                                            />
                                        )
                                    ))}
                                    <div className={`shuffle-left-section `} style={{ top: "25%" }}>
                                        <div className="tooltip-wrapper">
                                            <button
                                                className={`shuffle-left ${isDisabledVelg ? 'disabled' : ''}`}
                                                disabled={isDisabledVelg} // 👈 Native HTML disabled attribute
                                                tabIndex="-1"
                                                role="button"
                                                aria-label="Next slide"
                                                onClick={() => shuffleItems2(true)}
                                            >
                                                <i className="ri-shuffle-line"></i>

                                            </button>
                                            <span className="tooltip-text">HENT NYE FORSLAG</span>
                                        </div>
                                    </div>

                                    <div className="shuffle-left-section" style={{ top: "49%" }}>
                                        <div className="tooltip-wrapper tooltip-wrapper2">
                                            <button
                                                className={`shuffle-left-2 ${isDisabledVelg ? 'disabled' : ''}`}
                                                disabled={isDisabledVelg}
                                                tabIndex="-1"
                                                role="button"
                                                aria-label="Next slide"
                                                onClick={() => handleCustomActivityAdd()}
                                            >
                                                <i className="ri-add-fill"></i>
                                            </button>
                                            <span className="tooltip-text">Legg til din egen aktivitet</span>
                                        </div>
                                    </div>

                                </div>
                            )}
                        </div>
                    </div>



                </>} </>

            }


            {
                EditData?.Mode === "isEditAdminRequest" && 
                <> {action && (action === "rec1") && <div className="edit-row-back">
                    {/*<div className="sub-category-container-recommend2">*/}
                    {/*    <h4 class="text-center admin_heading fw-bold">VELG BY:</h4>*/}
                    {/*    <div className="row d-flex align-items-center justify-content-center">*/}
                    {/*        {cities.map((cityl, idx) => (*/}
                    {/*            <div className="col-2 uppercase" key={cityl.value}>*/}
                    {/*                <button*/}
                    {/*                    onClick={() => {*/}
                    {/*                        setCity(cityl.value);*/}
                    {/*                        ChangeSubCategory();*/}
                    {/*                        setSelectedSubCategory(null);*/}
                    {/*                    }}*/}
                    {/*                    className={`w-100 my-2 uppercase ${city == cityl.value ? "btnOrder-orange " : "btnOrder3 "}`}*/}
                    {/*                >*/}
                    {/*                    {cityl.label}*/}
                    {/*                </button>*/}
                    {/*            </div>*/}
                    {/*        ))}*/}
                    {/*    </div>*/}


                    {/*</div>*/}
                    {/*<div className="sub-category-container sub-category-container2 ">*/}
                    {/*    {subCategories.map((option) => (*/}
                    {/*        <label key={option.id} className={`sub-box ${selectedSubCategory === option.id ? "selected" : ""} ${!city ? " disabled" : ""}`}>*/}
                    {/*            <input*/}
                    {/*                type="radio"*/}
                    {/*                name="subCategory"*/}
                    {/*                value={option.id}*/}
                    {/*                checked={selectedSubCategory === option.id}*/}
                    {/*                onChange={() => { setSelectedSubCategory(option.id); ChangeSubCategory(); }}*/}
                    {/*                className={`hidden-radio ${!city ? " disabled-container" : ""}`}*/}
                    {/*            />*/}
                    {/*            < i class={`sub-category-box ${option.icon}`}></i>*/}

                    {/*            &nbsp;&nbsp;{option.value}*/}
                    {/*        </label>*/}
                    {/*    ))}*/}
                    {/*</div>*/}

                    <div className={`edit-box`}>

                        {recommendedOpenModals && recommendedOpenModals.length >= 0 && (
                            <div className={` row_custom `}>
                                {(() => {
                                    const cancelledActivities = mappedBookedActivity?.filter((activity) => {

                                        activity.isCanceled = false;
                                        if (EditData?.BookingDataParent?.activities?.length) {
                                            // Find the matching bookingActivity by activityId
                                            let bookingActivity = EditData.BookingDataParent.activities.find(
                                                (x) => x.activityId === activity.id
                                            );

                                            if (bookingActivity) {
                                                activity.isCanceled = bookingActivity.isCanceled ?? activity.isCanceled;
                                                activity.isDeleted = bookingActivity.Deleted ?? activity.isDeleted;
                                                activity.reason = bookingActivity.reason ?? activity.reason;


                                            }
                                        }

                                        return activity.isCanceled;

                                    });



                                    const activeActivities = recommendedOpenModals.map((x, index) => {
                                        debugger;

                                        x.index = index;
                                        return x;

                                    }).filter(
                                        (activity) => activity.isVelgClick == true
                                    );

                                    return (
                                        <div class="bg-gray">
                                            {cancelledActivities.length > 0 && (
                                                <div class="cancelled-activities">
                                                    <h3 className="title mb-3 w-100 items-center justify-center align-middle"> Avlyste aktiviteter:</h3>
                                                    {cancelledActivities.map((activity, index) => {
                                                        const isLast = index === cancelledActivities.length - 1;
                                                        return (
                                                            <React.Fragment key={activity.id}>
                                                                <OrderPlanSearchResultCard
                                                                    isType="recommend-2"
                                                                    CategoryDetails={CategoryObjecy(activity?.subCategoryId)}
                                                                    isEditButton={true}
                                                                    mode={EditData?.Mode}
                                                                    BookingDataParent={EditData?.BookingDataParent}
                                                                    isVelgDisable={
                                                                        ((one === true && widget.length < 1) ||
                                                                            (two === true && widget.length < 2) ||
                                                                            (four === true && widget.length < 4) ||
                                                                            (six === true && widget.length < 6) ||
                                                                            (twelve === true && widget.length < 12))
                                                                    }
                                                                    clickFire={(e) => {
                                                                        setIsLoading(true);
                                                                        activity.isVelgClick = true;
                                                                        simulateDragging(activity);

                                                                        setTimeout(() => {
                                                                            setIsLoading(false);
                                                                            const updatedModals = [...recommendedOpenModals];
                                                                            setRecommendedOpenModals(updatedModals);
                                                                        }, 1000);
                                                                    }}
                                                                    handleDrag={(e) => handleDrag(e, activity)}
                                                                    handleActivityEditClick={() => {
                                                                        setRecommendedOpenModalsSingleIndex(index);
                                                                        setSelectedDateVELG(activity.addDate);
                                                                        setFromTime(activity.fromTime);
                                                                        setToTime(activity.toTime);
                                                                        setTotalPersons(activity.totPersons);
                                                                        setComments(activity?.reason);
                                                                    }}
                                                                    handleDeleteActivity={() =>
                                                                        handleDltActivityforMultipleRecommended(activity)
                                                                    }
                                                                    CardImg={
                                                                        activity.images
                                                                            ? JSON.parse(activity.images)?.[0].imageURL
                                                                            : "bookingImg"
                                                                    }
                                                                    CardRabat={activity.discountPercent}
                                                                    CardHeading={activity.name}
                                                                    CardDesc={
                                                                        activity.price > 0 ? activity.price + " NOK" : "Gratis"
                                                                    }
                                                                    Data={activity}
                                                                    source="customer"
                                                                    peopleNumber={peopleNumber}
                                                                    city={city}
                                                                    activityType={type}
                                                                    price={budget}
                                                                    onDateChange={handleDateChangeForModal}
                                                                    onShowCustomActivityDetails={handleShowCustomActivityDetails}
                                                                />

                                                                {/* {isLast && fixBookingEditCardHeight()}*/}
                                                            </React.Fragment>
                                                        );
                                                    })}
                                                </div>
                                            )}

                                            {activeActivities.length > 0 && (
                                                <div class="active-activities">
                                                    <h3 className="title mb-3 items-center justify-center align-middle">Aktive aktiviteter:</h3>
                                                    <div class="row row_custom">
                                                        {activeActivities.map((activity, index) => {
                                                            const isLast = index === activeActivities.length - 1;
                                                            return (
                                                                <React.Fragment key={activity.id}>
                                                                    <OrderPlanSearchResultCard
                                                                        isType="recommend-2"
                                                                        CategoryDetails={CategoryObjecy(activity?.subCategoryId)}
                                                                        isEditButton={true}
                                                                        mode={EditData?.Mode}
                                                                        BookingDataParent={EditData?.BookingDataParent}
                                                                        isVelgDisable={
                                                                            ((one === true && widget.length < 1) ||
                                                                                (two === true && widget.length < 2) ||
                                                                                (four === true && widget.length < 4) ||
                                                                                (six === true && widget.length < 6) ||
                                                                                (twelve === true && widget.length < 12))
                                                                        }
                                                                        clickFire={(e) => {
                                                                            setIsLoading(true);
                                                                            activity.isVelgClick = true;
                                                                            simulateDragging(activity);

                                                                            setTimeout(() => {
                                                                                setIsLoading(false);
                                                                                const updatedModals = [...recommendedOpenModals];
                                                                                setRecommendedOpenModals(updatedModals);
                                                                            }, 1000);
                                                                        }}
                                                                        handleDrag={(e) => handleDrag(e, activity)}
                                                                        handleActivityEditClick={() => {
                                                                            setRecommendedOpenModalsSingleIndex(activity.index);
                                                                            setSelectedDateVELG(activity.addDate);
                                                                            setFromTime(activity.fromTime);
                                                                            setToTime(activity.toTime);
                                                                            setTotalPersons(activity.totPersons);
                                                                            setComments(activity?.reason);
                                                                        }}
                                                                        handleDeleteActivity={() => handleDltActivityforSingleRecommended(activity)}

                                                                        CardImg={
                                                                            activity.images
                                                                                ? JSON.parse(activity.images)?.[0].imageURL
                                                                                : "bookingImg"
                                                                        }
                                                                        CardRabat={activity.discountPercent}
                                                                        CardHeading={activity.name}
                                                                        CardDesc={
                                                                            activity.price > 0 ? activity.price + " NOK" : "Gratis"
                                                                        }
                                                                        Data={activity}
                                                                        source="customer"
                                                                        peopleNumber={peopleNumber}
                                                                        city={city}
                                                                        activityType={type}
                                                                        price={budget}
                                                                        onDateChange={handleDateChangeForModal}
                                                                        onShowCustomActivityDetails={handleShowCustomActivityDetails}
                                                                    />

                                                                    {/*    {isLast && fixBookingEditCardHeight()}*/}
                                                                </React.Fragment>
                                                            );
                                                        })}
                                                    </div>
                                                 
                                                </div>
                                             
                                            )}
                                        </div>


                                    );
                                })()}

                                {checkIsRemainActivities() === 1 && <><br/>< button
                                    onClick={() => setAddSingleCustomModal(true)}
                                    class="w-100 flex-1 bg-orange-500 px-4 py-2 text-white hover:bg-orange-600 transition disabled:opacity-50"
                                >
                                    <i className="ri-add-line text-lg"></i>
                                    LEGG TIL NY
                                </button></>
                                }


                                {/*<div className={`shuffle-left-section `} style={{ top: "25%" }}>*/}
                                {/*    <div className="tooltip-wrapper">*/}
                                {/*        <button*/}
                                {/*            className={`shuffle-left ${isDisabledVelg ? 'disabled' : ''}`}*/}
                                {/*            disabled={isDisabledVelg} // 👈 Native HTML disabled attribute*/}
                                {/*            tabIndex="-1"*/}
                                {/*            role="button"*/}
                                {/*            aria-label="Next slide"*/}
                                {/*            onClick={() => shuffleItems2(true)}*/}
                                {/*        >*/}
                                {/*            <i className="ri-shuffle-line"></i>*/}

                                {/*        </button>*/}
                                {/*        <span className="tooltip-text">HENT NYE FORSLAG</span>*/}
                                {/*    </div>*/}
                                {/*</div>*/}

                                {/*<div className="shuffle-left-section" style={{ top: "49%" }}>*/}
                                {/*    <div className="tooltip-wrapper tooltip-wrapper2">*/}
                                {/*        <button*/}
                                {/*            className={`shuffle-left-2 ${isDisabledVelg ? 'disabled' : ''}`}*/}
                                {/*            disabled={isDisabledVelg}*/}
                                {/*            tabIndex="-1"*/}
                                {/*            role="button"*/}
                                {/*            aria-label="Next slide"*/}
                                {/*            onClick={() => handleCustomActivityAdd()}*/}
                                {/*        >*/}
                                {/*            <i className="ri-add-fill"></i>*/}
                                {/*        </button>*/}
                                {/*        <span className="tooltip-text">Legg til din egen aktivitet</span>*/}
                                {/*    </div>*/}
                                {/*</div>*/}

                            </div>
                        )}


                    </div>




                </div>}
                    {action && (action === 'rec2' ) && <>


                    <div class="edit-row-back">
                        {/*<div className="sub-category-container-recommend2">*/}
                        {/*    <h4 class="text-center admin_heading fw-bold">VELG BY:</h4>*/}
                        {/*    <div className="row d-flex align-items-center justify-content-center">*/}
                        {/*        {cities.map((cityl, idx) => (*/}
                        {/*            <div className="col-2 uppercase" key={cityl.value}>*/}
                        {/*                <button*/}
                        {/*                    onClick={() => {*/}
                        {/*                        setCity(cityl.value);*/}
                        {/*                        setOne(true);*/}
                        {/*                        setTwo(false);*/}
                        {/*                        setFour(false);*/}
                        {/*                        setSix(false);*/}
                        {/*                        setTwelve(false);*/}
                        {/*                        handleActivityCountChange(0);*/}
                        {/*                    }}*/}
                        {/*                    className={`w-100 my-2 uppercase ${city == cityl.value ? "btnOrder-orange" : "btnOrder3"}`}*/}
                        {/*                >*/}
                        {/*                    {cityl.label}*/}
                        {/*                </button>*/}
                        {/*            </div>*/}
                        {/*        ))}*/}
                        {/*    </div>*/}


                        {/*</div>*/}
                        {/*<div className="sub-category-container-recommend2">*/}
                        {/*    <h4 class="text-center admin_heading fw-bold">VELG ØNSKET ANTALL:</h4>*/}
                        {/*    <div className="row d-flex align-items-center justify-content-center ">*/}
                        {/*        <div className="col-3">*/}
                        {/*            <button*/}
                        {/*                onClick={() => {*/}
                        {/*                    let chkd = checkdowngrade(2);*/}
                        {/*                    if (chkd && widget.length > 2) {*/}
                        {/*                        setShowModalRmv(widget.length - 2);*/}
                        {/*                    }*/}
                        {/*                    setOne(false);*/}
                        {/*                    setTwo(true);*/}
                        {/*                    setFour(false);*/}
                        {/*                    setSix(false);*/}
                        {/*                    setTwelve(false);*/}
                        {/*                    handleActivityCountChange(2);*/}
                        {/*                }}*/}
                        {/*                className={`w-100 my-2 ${two ? "btnOrder-orange" : "btnOrder3"}  ${!city ? " disabled" : ""}`}*/}
                        {/*            >*/}
                        {/*                2 AKTIVITETER*/}
                        {/*            </button>*/}
                        {/*        </div>*/}
                        {/*        <div className="col-3">*/}
                        {/*            <button*/}
                        {/*                onClick={() => {*/}
                        {/*                    let chkd = checkdowngrade(4);*/}
                        {/*                    if (chkd && widget.length > 4) {*/}
                        {/*                        setShowModalRmv(widget.length - 4);*/}
                        {/*                    }*/}
                        {/*                    setOne(false);*/}
                        {/*                    setTwo(false);*/}
                        {/*                    setFour(true);*/}
                        {/*                    setSix(false);*/}
                        {/*                    setTwelve(false);*/}
                        {/*                    handleActivityCountChange(4);*/}
                        {/*                }}*/}
                        {/*                className={`w-100 my-2 ${four ? "btnOrder-orange" : "btnOrder3"} ${!city ? " disabled" : ""}`}*/}
                        {/*            >*/}
                        {/*                4 AKTIVITETER*/}
                        {/*            </button>*/}
                        {/*        </div>*/}
                        {/*        <div className="col-3">*/}
                        {/*            <button*/}
                        {/*                onClick={() => {*/}
                        {/*                    let chkd = checkdowngrade(6);*/}
                        {/*                    if (chkd && widget.length > 6) {*/}
                        {/*                        setShowModalRmv(widget.length - 6);*/}
                        {/*                    }*/}
                        {/*                    setOne(false);*/}
                        {/*                    setTwo(false);*/}
                        {/*                    setFour(false);*/}
                        {/*                    setSix(true);*/}
                        {/*                    setTwelve(false);*/}
                        {/*                    handleActivityCountChange(6);*/}
                        {/*                }}*/}
                        {/*                className={`w-100 my-2 ${six ? "btnOrder-orange" : "btnOrder3"} ${!city ? " disabled" : ""}`}*/}
                        {/*            >*/}
                        {/*                6 AKTIVITETER*/}
                        {/*            </button>*/}
                        {/*        </div>*/}
                        {/*        <div className="col-3">*/}
                        {/*            <button*/}
                        {/*                onClick={() => {*/}
                        {/*                    let chkd = checkdowngrade(12);*/}
                        {/*                    if (chkd && widget.length > 12) {*/}
                        {/*                        setShowModalRmv(widget.length - 12);*/}
                        {/*                    }*/}
                        {/*                    setOne(false);*/}
                        {/*                    setTwo(false);*/}
                        {/*                    setFour(false);*/}
                        {/*                    setSix(false);*/}
                        {/*                    setTwelve(true);*/}
                        {/*                    handleActivityCountChange(12);*/}

                        {/*                }}*/}
                        {/*                className={`w-100 my-2 ${twelve ? "btnOrder-orange" : "btnOrder3"} ${!city ? " disabled" : ""}`}*/}
                        {/*            >*/}
                        {/*                12 AKTIVITETER*/}
                        {/*            </button>*/}
                        {/*        </div>*/}
                        {/*    </div>*/}


                        {/*</div>*/}
                        {/*{RenderRecommendation2Subox()}*/}
                            <div className={`edit-box`}>
                            {/*this is data <div><pre>{JSON.stringify(recommendedAppData2, null, 2)}</pre></div>*/}

                            {recommendedOpenModals && recommendedAppData2 && recommendedAppData2.length > 0 && (
                                <div className={` row_custom `}>
                                        {(() => {
                                            const cancelledActivities = mappedBookedActivity?.filter((activity) => {

                                                activity.isCanceled = false;
                                                if (EditData?.BookingDataParent?.activities?.length) {
                                                    // Find the matching bookingActivity by activityId
                                                    let bookingActivity = EditData.BookingDataParent.activities.find(
                                                        (x) => x.activityId === activity.id
                                                    );

                                                    if (bookingActivity) {
                                                        activity.isCanceled = bookingActivity.isCanceled ?? activity.isCanceled;
                                                        activity.isDeleted = bookingActivity.Deleted ?? activity.isDeleted;
                                                        activity.reason = bookingActivity.reason ?? activity.reason;


                                                    }
                                                }

                                                return activity.isCanceled;
                                                
                                            });

                                            

                                            const activeActivities = (recommendedOpenModals).map((x,index) => {

                                                x.index = index;
                                                return x;

                                            }).filter(
                                                (activity) => activity.isVelgClick==true
                                            );

                                            return (
                                                <div class ="bg-gray">
                                                    {cancelledActivities.length > 0 && (
                                                        <div class ="cancelled-activities">
                                                            <h3 className="title mb-3 w-100 items-center justify-center align-middle"> Avlyste aktiviteter:</h3>
                                                            {cancelledActivities.map((activity, index) => {
                                                                const isLast = index === cancelledActivities.length - 1;
                                                                return (
                                                                    <React.Fragment key={activity.id}>
                                                                        <OrderPlanSearchResultCard
                                                                            isType="recommend-2"
                                                                            CategoryDetails={CategoryObjecy(activity?.subCategoryId)}
                                                                            isEditButton={true}
                                                                            mode={EditData?.Mode}
                                                                            BookingDataParent={EditData?.BookingDataParent}
                                                                            isVelgDisable={
                                                                                ((one === true && widget.length < 1) ||
                                                                                    (two === true && widget.length < 2) ||
                                                                                    (four === true && widget.length < 4) ||
                                                                                    (six === true && widget.length < 6) ||
                                                                                    (twelve === true && widget.length < 12))
                                                                            }
                                                                            clickFire={(e) => {
                                                                                setIsLoading(true);
                                                                                activity.isVelgClick = true;
                                                                                simulateDragging(activity);

                                                                                setTimeout(() => {
                                                                                    setIsLoading(false);
                                                                                    const updatedModals = [...recommendedOpenModals];
                                                                                    setRecommendedOpenModals(updatedModals);
                                                                                }, 1000);
                                                                            }}
                                                                            handleDrag={(e) => handleDrag(e, activity)}
                                                                            handleActivityEditClick={() => {
                                                                                setRecommendedOpenModalsSingleIndex(activity.index);
                                                                                setSelectedDateVELG(activity.addDate);
                                                                                setFromTime(activity.fromTime);
                                                                                setToTime(activity.toTime);
                                                                                setTotalPersons(activity.totPersons);
                                                                                setComments(activity?.reason);

                                                                            }}
                                                                            handleDeleteActivity={() =>
                                                                                handleDltActivityforMultipleRecommended(activity)
                                                                            }
                                                                            CardImg={
                                                                                activity.images
                                                                                    ? JSON.parse(activity.images)?.[0].imageURL
                                                                                    : "bookingImg"
                                                                            }
                                                                            CardRabat={activity.discountPercent}
                                                                            CardHeading={activity.name}
                                                                            CardDesc={
                                                                                activity.price > 0 ? activity.price + " NOK" : "Gratis"
                                                                            }
                                                                            Data={activity}
                                                                            source="customer"
                                                                            peopleNumber={peopleNumber}
                                                                            city={city}
                                                                            activityType={type}
                                                                            price={budget}
                                                                            onDateChange={handleDateChangeForModal}
                                                                            onShowCustomActivityDetails={handleShowCustomActivityDetails}
                                                                        />

                                                                       {/* {isLast && fixBookingEditCardHeight()}*/}
                                                                    </React.Fragment>
                                                                );
                                                            })}
                                                        </div>
                                                    )}

                                                    {activeActivities.length > 0 && (
                                                        <div class="active-activities">
                                                            <h3 className="title mb-3 items-center justify-center align-middle">Aktive aktiviteter:</h3>
                                                            <div class="row row_custom">
                                                                {activeActivities.map((activity, index) => {
                                                                const isLast = index === activeActivities.length - 1;
                                                                return (
                                                                    <React.Fragment key={activity.id}>
                                                                        <OrderPlanSearchResultCard
                                                                            isType="recommend-2"
                                                                            CategoryDetails={CategoryObjecy(activity?.subCategoryId)}
                                                                            isEditButton={true}
                                                                            mode={EditData?.Mode}
                                                                            BookingDataParent={EditData?.BookingDataParent}
                                                                            isVelgDisable={
                                                                                ((one === true && widget.length < 1) ||
                                                                                    (two === true && widget.length < 2) ||
                                                                                    (four === true && widget.length < 4) ||
                                                                                    (six === true && widget.length < 6) ||
                                                                                    (twelve === true && widget.length < 12))
                                                                            }
                                                                            clickFire={(e) => {
                                                                                setIsLoading(true);
                                                                                activity.isVelgClick = true;
                                                                                simulateDragging(activity);

                                                                                setTimeout(() => {
                                                                                    setIsLoading(false);
                                                                                    const updatedModals = [...recommendedOpenModals];
                                                                                    setRecommendedOpenModals(updatedModals);
                                                                                }, 1000);
                                                                            }}
                                                                            handleDrag={(e) => handleDrag(e, activity)}
                                                                            handleActivityEditClick={() => {
                                                                                setRecommendedOpenModalsSingleIndex(activity.index);
                                                                                setSelectedDateVELG(activity.addDate);
                                                                                setFromTime(activity.fromTime);
                                                                                setToTime(activity.toTime);
                                                                                setTotalPersons(activity.totPersons);
                                                                                setComments(activity?.reason);

                                                                            }}
                                                                            handleDeleteActivity={() =>
                                                                                handleDltActivityforMultipleRecommended(activity)
                                                                            }
                                                                            CardImg={
                                                                                activity.images
                                                                                    ? JSON.parse(activity.images)?.[0].imageURL
                                                                                    : "bookingImg"
                                                                            }
                                                                            CardRabat={activity.discountPercent}
                                                                            CardHeading={activity.name}
                                                                            CardDesc={
                                                                                activity.price > 0 ? activity.price + " NOK" : "Gratis"
                                                                            }
                                                                            Data={activity}
                                                                            source="customer"
                                                                            peopleNumber={peopleNumber}
                                                                            city={city}
                                                                            activityType={type}
                                                                            price={budget}
                                                                            onDateChange={handleDateChangeForModal}
                                                                            onShowCustomActivityDetails={handleShowCustomActivityDetails}
                                                                        />

                                                                    {/*    {isLast && fixBookingEditCardHeight()}*/}
                                                                    </React.Fragment>
                                                                );
                                                            })}
                                                            </div>
                                                            {checkIsRemainActivities()>0 && < button
                                                                onClick={() => setAddSingleCustomModal(true)}
                                                                class="w-100 flex-1 bg-orange-500 px-4 py-2 text-white hover:bg-orange-600 transition disabled:opacity-50"
                                                            >
                                                                <i className="ri-add-line text-lg"></i>
                                                                LEGG TIL NY
                                                            </button>
                                                            }
                                                        </div>
                                                    )}
                                                </div>
                                            );
                                        })()}


                                    {/*<div className={`shuffle-left-section `} style={{ top: "25%" }}>*/}
                                    {/*    <div className="tooltip-wrapper">*/}
                                    {/*        <button*/}
                                    {/*            className={`shuffle-left ${isDisabledVelg ? 'disabled' : ''}`}*/}
                                    {/*            disabled={isDisabledVelg} // 👈 Native HTML disabled attribute*/}
                                    {/*            tabIndex="-1"*/}
                                    {/*            role="button"*/}
                                    {/*            aria-label="Next slide"*/}
                                    {/*            onClick={() => shuffleItems2(true)}*/}
                                    {/*        >*/}
                                    {/*            <i className="ri-shuffle-line"></i>*/}

                                    {/*        </button>*/}
                                    {/*        <span className="tooltip-text">HENT NYE FORSLAG</span>*/}
                                    {/*    </div>*/}
                                    {/*</div>*/}

                                    {/*<div className="shuffle-left-section" style={{ top: "49%" }}>*/}
                                    {/*    <div className="tooltip-wrapper tooltip-wrapper2">*/}
                                    {/*        <button*/}
                                    {/*            className={`shuffle-left-2 ${isDisabledVelg ? 'disabled' : ''}`}*/}
                                    {/*            disabled={isDisabledVelg}*/}
                                    {/*            tabIndex="-1"*/}
                                    {/*            role="button"*/}
                                    {/*            aria-label="Next slide"*/}
                                    {/*            onClick={() => handleCustomActivityAdd()}*/}
                                    {/*        >*/}
                                    {/*            <i className="ri-add-fill"></i>*/}
                                    {/*        </button>*/}
                                    {/*        <span className="tooltip-text">Legg til din egen aktivitet</span>*/}
                                    {/*    </div>*/}
                                    {/*</div>*/}

                                </div>
                            )}
                        </div>
                    </div>



                </>} </>
            }

            { customActivityDetails && (
                    <Modal show={true} onHide={handleCloseCustomActivityDetails} centered>
                        <Modal.Header closeButton>
                            <Modal.Title>Egendefinert aktivitetsdetaljer</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="flex modal-body">
                                <div className="col_searchCard_inr left-section-crd" style={{ width: "170%" }}>
                                    <div className="position-relative img_otr">
                                        <img
                                            className="card_imgS card_imgS-modal"
                                            src={
                                                customActivityDetails.images
                                                    ? JSON.parse(customActivityDetails.images)[0].imageURL.replace("{baseApiURL}", "https://funtlers.com/")
                                                    : "https://funtlers.com/booking-confirmation-img.8df3502e7365d6433146.png"
                                            }
                                            alt="img"
                                        />
                                    </div>
                                    <p className="heading-lb card_heading card_heading-model">{customActivityDetails.name}</p>
                                </div>
                                <div className="col_searchCard_inr right-section-crd">
                                    <div className="d-flex flex-row justify-content-between p-2 mid">
                                        <div className="d-flex flex-column align-left">
                                            <medium className="text-muted mt-1"><b>Antall personer:</b></medium>
                                            <div className="d-flex flex-row">
                                                <div className="d-flex flex-column ml-1">
                                                    <large className="ghj">{customActivityDetails.minPerson + customActivityDetails.totPersons}</large>
                                                </div>
                                            </div>
                                            <medium className="text-muted mt-1"><b>Pris per person:</b></medium>
                                            <div className="d-flex flex-row">
                                                <div className="d-flex flex-column ml-1">
                                                    <large className="ghj">{customActivityDetails.price} NOK</large>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="d-flex flex-column">
                                            <medium className="text-muted mt-1"><b>Total aktivitetspris:</b></medium>
                                            <div className="d-flex flex-column">
                                                <div className="d-flex flex-column ml-1">
                                                    <large className="ghj">{customActivityDetails.price * (customActivityDetails.minPerson + customActivityDetails.totPersons)} NOK</large>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="my-f ">
                                        <div style={{ padding: '10px', width: '78px' }}><strong>Dato:</strong></div>
                                        <div style={{ padding: '10px', width: '100%' }}>
                                            <span>
                                                {customActivityDetails.addDate
                                                    ? dayjs(customActivityDetails.addDate).locale('nb').format('DD. MMM YYYY').toUpperCase()
                                                    : "Velg dato"}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="my-f ">
                                        <div style={{ padding: '10px', width: '78px' }}><strong>Tid:</strong></div>
                                        <div style={{ padding: '10px', width: '100%' }}>
                                            <span>
                                                {customActivityDetails?.fromTime ? customActivityDetails.fromTime : "N/A"} - {customActivityDetails?.toTime ? customActivityDetails.toTime : "N/A"}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="my-f ">
                                        <div style={{ padding: '10px', width: '78px' }}><strong>Kategori: </strong></div>
                                        <div style={{ padding: '10px', width: '100%' }}>
                                            <span>
                                                <i className="ri-store-3-line"></i> {customActivity_Default.kategori}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="my-f ">
                                        <div style={{ padding: '10px', width: '108px' }}><strong>Beskrivelse: </strong></div>
                                        <div style={{ padding: '10px', width: '100%' }}>
                                            <span>{customActivityDetails.description}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <button className="btnOrder" onClick={handleCloseCustomActivityDetails}>Lukk</button>
                        </Modal.Footer>
                    </Modal>
                )}


            {CustomActivityModal && (
                <Modal
                    centered
                    key="custom-model-add"
                    backdrop="static"
                    keyboard={false}
                    show={true}
                    onHide={() => setCustomActivityModal(null)}
                >
                    <Modal.Header closeButton>
                        <Modal.Title>
                            AKTIVITETSDETALJER 

                        </Modal.Title>

                    </Modal.Header>
                    <Modal.Body >
                        <h6 className="modal-subheading mb-3">For å legge til en ny valgfri aktivitet, må du velge bort en av de foreslåtte aktivitetene. Under kan du velge bort den du ikke ønsker å inkludere.</h6>
                        <div className="flex">
                            <div className="col_searchCard_inr left-section-crd">
                                <div className="position-relative img_otr">
                                    <img
                                        className="card_imgS card_imgS-modal"
                                        src={fallbackImage}
                                        alt="img"
                                    />
                                </div>
                            </div>
                            <div className="col_searchCard_inr">

                                {/* Dropdown for recommendedOpenModals */}
                                <div className="mb-3">
                                    <label className="mb-1 text-muted"><b>Velg bort følgende aktivitet:</b></label>
                                    <select
                                        className="form-control"
                                        value={
                                            typeof CustomActivityModal.selectedActivityIndex === "number"
                                                ? CustomActivityModal.selectedActivityIndex
                                                : ""
                                        }
                                        onChange={e => {
                                            const selectedIndex = e.target.value;
                                            if (selectedIndex === "" || isNaN(selectedIndex)) {
                                                setCustomActivityModal({ ...CustomActivityModal, selectedActivityIndex: undefined });
                                                return;
                                            }
                                            const selected = recommendedOpenModals[selectedIndex];
                                            if (selected) {
                                                setCustomActivityModal({
                                                    ...CustomActivityModal,
                                                    selectedActivityIndex: Number(selectedIndex),
                                                    title: CustomActivityModal.name || "",
                                                    price: CustomActivityModal.price || "",
                                                    antall: (selected.minPerson || 0) + (selected.totPersons || 0),
                                                    date: selected.addDate || "",
                                                    kategori: CustomActivityModal.kategori || "EGEN PLANLAGT AKTIVITET"
                                                });
                                            }
                                        }}
                                    >
                                        <option value="">-- Velg aktivitet --</option>
                                        {recommendedOpenModals.map((a, index) => (
                                            <option key={a.id} value={index}>
                                                {(index + 1) + ". " + a.name} | {a.price} NOK | {a.addDate ? dayjs(a.addDate).format("YY/M/D").toUpperCase() : ""}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                {/* Show the form only if an activity is selected */}
                                {typeof CustomActivityModal.selectedActivityIndex === "number" && (
                                    <div>
                                        <div className="flex">
                                            <div>
                                                <div className="d-flex flex-column align-left" style={{ padding: "0px 15px" }}>
                                                    <medium className="text-muted mt-2"><b>Egen planlagt aktivitet:</b></medium>
                                                    <div className="d-flex flex-row">
                                                        <div className="d-flex flex-column ml-1 w-100">
                                                            <input
                                                                className="form-control"
                                                                type="text"
                                                                value={CustomActivityModal.title}
                                                                onChange={e => setCustomActivityModal({ ...CustomActivityModal, title: e.target.value })}
                                                                placeholder="Skriv inn tittel"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="p-3">
                                                    <div className="d-flex flex-row justify-content-between mid g-22">
                                                        <div className="d-flex flex-column align-left">
                                                            <medium className="text-muted mt-2"><b>Pris per person:</b></medium>
                                                            <div className="d-flex flex-row">
                                                                <div className="d-flex flex-column ml-1">
                                                                    <input
                                                                        className="form-control"
                                                                        type="number"
                                                                        min="0"
                                                                        value={CustomActivityModal.price}
                                                                        onChange={e => setCustomActivityModal({ ...CustomActivityModal, price: e.target.value })}
                                                                        onKeyDown={(e) => {
                                                                            if (e.key === '-') {
                                                                                e.preventDefault(); // Block minus sign when typing
                                                                            }
                                                                        }}
                                                                        onPaste={(e) => {
                                                                            const pastedText = e.clipboardData.getData('Text');
                                                                            if (pastedText.includes('-')) {
                                                                                e.preventDefault(); // Block pasting minus sign
                                                                            }
                                                                        }}
                                                                        placeholder="Pris"
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="d-flex flex-column">
                                                            <medium className="text-muted mt-2"><b>Antall personer:</b></medium>
                                                            <div className="d-flex flex-column ml-1">
                                                                <input
                                                                    className="form-control"
                                                                    type="number"
                                                                    min="1"
                                                                    value={CustomActivityModal.antall}
                                                                    placeholder="Antall"
                                                                    onChange={e => {
                                                                        const val = e.target.value;
                                                                        // Only allow positive integers, fallback to 1 if empty
                                                                        if (/^[1-9]\d*$/.test(val)) {
                                                                            setCustomActivityModal({ ...CustomActivityModal, antall: Number(val) })
                                                                        } else if (val === "") {
                                                                            setTotalPersons("");
                                                                            setCustomActivityModal({ ...CustomActivityModal, antall: "" })

                                                                        }
                                                                    }}
                                                                    onBlur={e => {
                                                                        const val = e.target.value;
                                                                        // Default to 1 if empty or 0
                                                                        if (val === "" || val === "0") {
                                                                            setCustomActivityModal({ ...CustomActivityModal, antall: 1 })
                                                                        }
                                                                    }}
                                                                    onKeyDown={(e) => {
                                                                        if (e.key === '-') {
                                                                            e.preventDefault(); // Block minus sign when typing
                                                                        }
                                                                    }}
                                                                    onPaste={(e) => {
                                                                        const pastedText = e.clipboardData.getData('Text');
                                                                        if (pastedText.includes('-')) {
                                                                            e.preventDefault(); // Block pasting minus sign
                                                                        }
                                                                    }}

                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="mid d-flex flex-column align-left">
                                                        <medium className="text-muted mt-2"><b>Total aktivitetspris:</b></medium>
                                                        <div className="d-flex flex-column ml-1">
                                                            <p>
                                                                {CustomActivityModal.price && CustomActivityModal.antall
                                                                    ? Number(CustomActivityModal.price) * Number(CustomActivityModal.antall)
                                                                    : 0} NOK
                                                            </p>
                                                        </div>
                                                        <div class="VELG-sec d-flex" >
                                                            <medium className="text-muted mt-2" style={{ padding: "2px 7px 7px 9px" }}><b>Dato:</b></medium>
                                                            <div className="ml-1" style={{ width: "100%" }}>
                                                                <div className="ml-1">
                                                                    <div
                                                                        style={{
                                                                            cursor: "pointer",
                                                                            padding: "8px 12px",
                                                                            border: "1px solid #ced4da",
                                                                            borderRadius: 4,
                                                                            background: "#fff",
                                                                            minWidth: 160,
                                                                            color: CustomActivityModal.date ? "#212529" : "#888"
                                                                        }}
                                                                        onClick={() => setShowCalenderVELG(!showCalenderVELG)}
                                                                        className="dropdownCal Theme_select"
                                                                    >
                                                                        <span>
                                                                            {CustomActivityModal.date
                                                                                ? dayjs(CustomActivityModal.date).format("YY/M/D").toUpperCase()
                                                                                : "Velg dato"}
                                                                        </span>
                                                                        <i className="ri-arrow-down-s-line" style={{ float: "right" }}></i>
                                                                    </div>
                                                                    {showCalenderVELG && (
                                                                        <div className="dropdown-contentCal" style={{ zIndex: 10, top: 0 }}>
                                                                            <CalenderComponent
                                                                                setSelectedDate={date => setCustomActivityModal({ ...CustomActivityModal, date })}
                                                                                selectedDate={CustomActivityModal.date}
                                                                                setShowCalender={setShowCalenderVELG}
                                                                            />
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="VELG-sec" style={{ alignItems: "center", width: "97.5%" }}>
                                                            <TimeRangeSelector
                                                                labelFrom="TID"
                                                                labelTo="TIL"
                                                                fromTime={fromTime}
                                                                toTime={toTime}
                                                                setFromTime={setFromTime}
                                                                setToTime={setToTime}
                                                            />
                                                        </div>

                                                        <medium className="text-muted mt-2"><b>Kategori:</b></medium>
                                                        <div className="d-flex flex-column ml-1">
                                                            <div>
                                                                <i className="ri-store-3-line"></i> {CustomActivityModal.kategori || "EGEN PLANLAGT AKTIVITET"}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="d-flex justify-content-center w-100">
                            <button
                                onClick={() => {
                                    // Only proceed if a valid index is selected
                                    if (typeof CustomActivityModal.selectedActivityIndex === "number") {
                                        // Prepare the updated activity object
                                        const updatedActivity = {
                                            ...recommendedOpenModals[CustomActivityModal.selectedActivityIndex],
                                            id: Date.now(),
                                            previousid: recommendedOpenModals[CustomActivityModal.selectedActivityIndex].id,
                                            name: CustomActivityModal.title,
                                            price: Number(CustomActivityModal.price),
                                            minPerson: 1,
                                            totPersons: Number(CustomActivityModal.antall) - (recommendedOpenModals[CustomActivityModal.selectedActivityIndex]?.minPerson || 0),
                                            addDate: CustomActivityModal.date,
                                            kategori: CustomActivityModal.kategori || "EGEN PLANLAGT AKTIVITET",
                                            isCustomActivity: true,
                                            images: "[{\"imageURL\":\"{baseApiURL}/static/media/booking-confirmation-img.8df3502e7365d6433146.png\"}]",
                                            date: CustomActivityModal.date,
                                            validPeriodStart: CustomActivityModal.date,
                                            validPeriodEnd: CustomActivityModal.date,
                                            description: "DENNE AKTIVITETEN OG ALLE DETALJENE RUNDT AKTIVITETEN ER LAGT TIL AV BRUKEREN SELV. DEN ER IKKE PLANLAGT ELLER ANSVARLIGGJORT AV FUNTLERS",
                                            fromTime: recommendedOpenModals[CustomActivityModal.selectedActivityIndex].fromTime,
                                            toTime: recommendedOpenModals[CustomActivityModal.selectedActivityIndex].toTime,

                                        };


                                        handleCustomActivityEmail(updatedActivity);




                                        // Update recommendedOpenModals
                                        setRecommendedOpenModals(prev => {
                                            const arr = [...prev];
                                            arr[CustomActivityModal.selectedActivityIndex] = updatedActivity;
                                            return arr;
                                        });

                                        // Update recommendedAppData2 (recommended2)
                                        setRecommendedAppData2(prev => {
                                            // Find which page/activity this index belongs to
                                            let found = false;
                                            const arr = prev.map(page => {
                                                if (page.activities && !found) {
                                                    const idx = page.activities.findIndex(a => a.id === updatedActivity.previousid);
                                                    if (idx !== -1) {
                                                        found = true;
                                                        const acts = [...page.activities];
                                                        acts[idx] = updatedActivity;
                                                        return { ...page, activities: acts };
                                                    }
                                                }
                                                return page;
                                            });
                                            return arr;
                                        });
                                    }
                                    setCustomActivityModal(undefined);
                                }}
                                className={`btnOrder w-100 ${!canProceedCustomActivityModel(CustomActivityModal) ? "disabled" : ""}`}
                            >
                                INKLUDER <i className="ri-arrow-right-line"></i>
                            </button>
                        </div>
                    </Modal.Footer>
                </Modal>
            )}

            {
                (recommend2fixedstack && recommend2fixedstack.length > 0 && (recommend2fixedstackIndex >= 0 && recommend2fixedstackIndex != recommend2fixedstack.length) &&
                    <Modal
                        centered
                        backdrop="static" // Prevent closing when clicking outside
                        show={true}
                        onHide={() => {
                            setrecommend2fixedstackIndex(-1);

                            //if (!(recommend2fixedstackIndex > 0 && recommend2fixedstackIndex == recommend2fixedstack?.length)) {
                            //    setOne(false);
                            //    setOne(false);
                            //    setTwo(false);
                            //    setFour(false);
                            //    setSix(false);
                            //    setTwelve(false);
                            //    handleActivityCountChange(0);
                            //}

                        }}
                        animation={true} // Enables fade transition
                        shouldCloseOnOverlayClick={false} // Disable click outside
                        className={`recommend2-modal custom-modal-width-${recommend2fixedstack.length}`}
                    >
                        <Modal.Header closeButton>
                            <Modal.Title>
                                AKTIVITETSDETALJER
                                {recommend2fixedstack.length > 1
                                    ? ` (${recommend2fixedstackIndex + 1} av ${recommend2fixedstack.length})`
                                    : ""}
                            </Modal.Title>
                        </Modal.Header>

                        {recommend2fixedstack.length > 1 && <div class="progressbar">
                            <div class="progress" id="progress"
                                style={{ width: ((recommend2fixedstackIndex / (recommend2fixedstack.length - 1)) * 100) + "%" }}

                            ></div>
                            {recommend2fixedstack.map((activity, activityIndex) => (
                                <><div
                                    key={activity.id || activityIndex}
                                    className={`progress-step ${activityIndex <= recommend2fixedstackIndex ? 'progress-step-active' : ''}`}
                                >{activityIndex + 1}
                                    <br />
                                    <div class="progress-step-desc">AKTIVITET</div>
                                    <div className="after">
                                        {/*<medium><b>{activity.name}</b></medium>*/}
                                        {activityIndex < recommend2fixedstackIndex && (
                                            <div>
                                                <small className="ghj f-12"><b>ANTALL</b>: {(activity?.count)}</small><br />
                                                <small className="ghj f-12"><b>DATO</b>: {dayjs(activity?.date).locale('nb').format('DD MMM').toUpperCase()}</small>
                                            </div>
                                        )}
                                    </div>
                                </div>





                                </>
                            ))}
                        </div>}

                        <Modal.Body className="">

                            <div className="flex" style={{ gap: "35px", paddingBottom: "13px" }}>
                                <label className="fw-bold ">LEGG TIL EGEN AKTIVITET</label>
                                <div>
                                    <label style={{ marginRight: 16 }}>
                                        <input
                                            type="radio"
                                            name="customActivity"
                                            value="nei"
                                            checked={!showCustomActivity}
                                            onChange={() => setShowCustomActivity(false)}
                                            style={{ marginRight: 4 }}
                                        />
                                        NEI
                                    </label>
                                    <label>
                                        <input
                                            type="radio"
                                            name="customActivity"
                                            value="ja"
                                            checked={showCustomActivity}
                                            onChange={() => setShowCustomActivity(true)}
                                            style={{ marginRight: 4 }}
                                        />
                                        JA
                                    </label>
                                </div>
                            </div>

                            {showCustomActivity && (
                                <div className="custom-activity-form border p-3 mb-4" style={{ background: "#f9f9f9", borderRadius: 8 }}>

                                    <div className="flex">
                                        <div className="left-section-crd-custom">                                                    <div className="position-relative img_otr">
                                            <img
                                                className="card_imgS card_imgS-modal"
                                                src={fallbackImage}
                                                alt="img"
                                            />
                                        </div>
                                        </div>

                                        <div class="">
                                            <div className="">
                                                <div className="d-flex flex-column align-left" style={{ padding: "0px 15px" }}>
                                                    <medium className="text-muted mt-2"><b>Tittel:</b></medium>
                                                    <div className="d-flex flex-row">
                                                        <div className="d-flex flex-column ml-1 w-100">
                                                            <input
                                                                className="form-control"
                                                                type="text"
                                                                value={customActivity.title}
                                                                onChange={e => handleCustomActivityChange("title", e.target.value)}
                                                                placeholder="Skriv inn tittel"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="p-3 ">
                                                    <div className="d-flex flex-row justify-content-between  mid g-22">
                                                        <div className="d-flex flex-column align-left">
                                                            <medium className="text-muted mt-2"><b>Pris per person:</b></medium>
                                                            <div className="d-flex flex-row">
                                                                <div className="d-flex flex-column ml-1">
                                                                    <input
                                                                        className="form-control"
                                                                        type="number"
                                                                        min="0"
                                                                        value={customActivity.price}
                                                                        onChange={e => handleCustomActivityChange("price", e.target.value)}
                                                                        onKeyDown={(e) => {
                                                                            if (e.key === '-') {
                                                                                e.preventDefault(); // Block minus sign when typing
                                                                            }
                                                                        }}
                                                                        onPaste={(e) => {
                                                                            const pastedText = e.clipboardData.getData('Text');
                                                                            if (pastedText.includes('-')) {
                                                                                e.preventDefault(); // Block pasting minus sign
                                                                            }
                                                                        }}
                                                                        placeholder="Pris"
                                                                    />
                                                                </div>
                                                            </div>

                                                        </div>
                                                        <div className="d-flex flex-column">
                                                            <medium className="text-muted mt-2"><b>Antall personer:</b></medium>
                                                            <div className="d-flex flex-column ml-1">
                                                                <input
                                                                    className="form-control"
                                                                    type="number"
                                                                    min="1"
                                                                    value={totalPersons}
                                                                    onChange={e => {
                                                                        const val = e.target.value;
                                                                        // Only allow positive integers, fallback to 1 if empty
                                                                        if (/^[1-9]\d*$/.test(val)) {
                                                                            setTotalPersons(Number(val));
                                                                        } else if (val === "") {
                                                                            setTotalPersons("");
                                                                        }
                                                                    }}
                                                                    onBlur={e => {
                                                                        const val = e.target.value;
                                                                        // Default to 1 if empty or 0
                                                                        if (val === "" || val === "0") {
                                                                            setTotalPersons(1);
                                                                        }
                                                                    }}
                                                                    onKeyDown={(e) => {
                                                                        if (e.key === '-') {
                                                                            e.preventDefault(); // Block minus sign when typing
                                                                        }
                                                                    }}
                                                                    onPaste={(e) => {
                                                                        const pastedText = e.clipboardData.getData('Text');
                                                                        if (pastedText.includes('-')) {
                                                                            e.preventDefault(); // Block pasting minus sign
                                                                        }
                                                                    }}
                                                                    placeholder="Antall"
                                                                />
                                                            </div>

                                                        </div>
                                                    </div>
                                                    <div className="mid d-flex flex-column align-left">
                                                        <medium className="text-muted mt-2"><b>Total aktivitetspris:</b></medium>
                                                        <div className="d-flex flex-column ml-1">
                                                            <p
                                                                className=""

                                                            >{
                                                                    customActivity.price && totalPersons
                                                                        ? Number(customActivity.price) * Number(totalPersons)
                                                                        : 0
                                                                }</p>
                                                        </div>

                                                        <div className="VELG-sec d-flex" style={{ alignItems: "center" }}>

                                                            <medium className="text-muted mt-2" style={{ padding: "2px 7px 7px 9px" }}><b>Dato:</b></medium>
                                                            <div className="w-100">
                                                                <div className="ml-1">
                                                                    <div
                                                                        style={{
                                                                            cursor: "pointer",
                                                                            padding: "8px 12px",
                                                                            border: "1px solid #ced4da",
                                                                            borderRadius: 4,
                                                                            background: "#fff",
                                                                            Width: "100%",
                                                                            color: recommend2fixedstack[recommend2fixedstackIndex]?.date ? "#212529" : "#888"
                                                                        }}
                                                                        onClick={() => setShowCalenderVELG(!showCalenderVELG)}
                                                                        className="dropdownCal Theme_select"
                                                                    >
                                                                        <span>{recommend2fixedstack[recommend2fixedstackIndex]?.date ? dayjs(recommend2fixedstack[recommend2fixedstackIndex]?.date).format("YY/M/D") : (selectedDateVELG ? dayjs(selectedDateVELG).format("YY/M/D") : "Velg dato")}</span>

                                                                        <i className="ri-arrow-down-s-line" style={{ float: "right" }}></i>
                                                                    </div>
                                                                    {showCalenderVELG && (
                                                                        <div className="dropdown-contentCal" style={{ zIndex: 10, top: 0 }}>
                                                                            <CalenderComponent
                                                                                setSelectedDate={setSelectedDateVELG}
                                                                                selectedDate={selectedDateVELG}
                                                                                setShowCalender={setShowCalenderVELG}
                                                                                {...(recommend2fixedstackIndex > 0 && recommend2fixedstack[recommend2fixedstackIndex - 1]?.date
                                                                                    ? { monthIndex: new Date(recommend2fixedstack[recommend2fixedstackIndex - 1].date).getMonth() }
                                                                                    : {})}
                                                                            />

                                                                        </div>
                                                                    )}


                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="VELG-sec" style={{ alignItems: "center" }}>
                                                            <TimeRangeSelector
                                                                labelFrom="TID"
                                                                labelTo="TIL"
                                                                fromTime={fromTime}
                                                                toTime={toTime}
                                                                setFromTime={setFromTime}
                                                                setToTime={setToTime}
                                                            />
                                                        </div>
                                                        <medium className="text-muted mt-2"><b>Kategori:</b></medium>
                                                        <div className="d-flex flex-column ml-1">
                                                            <div
                                                                className=""

                                                            >

                                                                <i class="ri-store-3-line"></i> {customActivity.kategori}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>



                                </div>
                            )}


                            {!showCustomActivity && <div className="custom-activity-form border p-3 mb-4" style={{ background: "#f9f9f9", borderRadius: 8 }}>

                                <div className="my-f mt-3">
                                    <div style={{ padding: "10px 56px 7px 12px", width: "96px" }}>
                                        <strong>Dato</strong>
                                    </div>

                                    <div
                                        style={{
                                            cursor: "pointer",
                                            paddingRight: "7px",
                                            width: "83%",
                                            minWidth: "83%", // 👈 Sets the minimum width
                                            maxWidth: "83%" // 👈 Sets the minimum width

                                        }}
                                        onClick={() => setShowCalenderVELG(!showCalenderVELG)}
                                        className="dropdownCal Theme_select"
                                    >
                                        <span>{recommend2fixedstack[recommend2fixedstackIndex]?.date ? dayjs(recommend2fixedstack[recommend2fixedstackIndex]?.date).format("YY/M/D") : (selectedDateVELG ? dayjs(selectedDateVELG).format("YY/M/D") : "Velg dato")}</span>
                                        <i className="ri-arrow-down-s-line"></i>
                                    </div>

                                    {showCalenderVELG && (
                                        <div className="dropdown-contentCal">
                                            <CalenderComponent
                                                setSelectedDate={setSelectedDateVELG}
                                                selectedDate={selectedDateVELG}
                                                setShowCalender={setShowCalenderVELG}
                                                {...(recommend2fixedstackIndex > 0 && recommend2fixedstack[recommend2fixedstackIndex - 1]?.date
                                                    ? { monthIndex: new Date(recommend2fixedstack[recommend2fixedstackIndex - 1].date).getMonth() }
                                                    : {})}
                                            />



                                            {/* monthIndex={recommend2fixedstackIndex}*/}

                                        </div>
                                    )}

                                </div>
                                <div className="VELG-sec timepicker-main" style={{ alignItems: "center", width: "97.5%" }}>
                                    <TimeRangeSelector
                                        labelFrom="TID"
                                        labelTo="TIL"
                                        fromTime={fromTime}
                                        toTime={toTime}
                                        setFromTime={setFromTime}
                                        setToTime={setToTime}
                                    />
                                </div>
                                <div className="VELG-sec" style={{ display: "inline-flex", alignItems: "center", width: "97.5%" }}>

                                    <div style={{ padding: "10px 56px 7px 12px", width: "93px" }}>
                                        <strong>Antall</strong>
                                    </div>
                                    <div className="text input-block" style={{ width: "85%" }}>
                                        <div className="input-group" >
                                            <button
                                                className="btn"
                                                type="button"
                                                onClick={() =>
                                                    totalPersons > 0
                                                        ? setTotalPersons(totalPersons - 1)
                                                        : setTotalPersons(totalPersons)
                                                }
                                            >
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="2" viewBox="0 0 24 2">
                                                    <g fill="#fff" stroke="#707070" strokeWidth="1" opacity="0.45">
                                                        <rect width="24" height="2" stroke="none"></rect>
                                                        <rect x="0.5" y="0.5" width="23" height="1" fill="none"></rect>
                                                    </g>
                                                </svg>
                                            </button>
                                            <input

                                                className="form-control bg-transparent"
                                                aria-describedby="button-addon"
                                                value={totalPersons}
                                                type="text"
                                                min="1"
                                                inputMode="numeric"
                                                pattern="[0-9]*"
                                                onChange={e => {

                                                    const val = e.target.value;

                                                    // Allow empty input to reset to 1
                                                    if (val === "") {
                                                        setTotalPersons("");
                                                        return;
                                                    }

                                                    // Allow only valid positive integers
                                                    if (/^[1-9]\d*$/.test(val)) {
                                                        setTotalPersons(Number(val)); // Store as a number
                                                    }
                                                }}
                                                onBlur={e => {
                                                    const val = e.target.value;
                                                    // Default to 1 if empty or 0
                                                    if (val === "" || val === "0") {
                                                        setTotalPersons(1);
                                                    }
                                                }}
                                                onKeyDown={e => {
                                                    if (e.key === '-') {
                                                        e.preventDefault(); // Block minus sign when typing
                                                    }
                                                    // Prevent invalid characters
                                                    if (["e", "E", "+", "-", "."].includes(e.key)) {
                                                        e.preventDefault();
                                                    }

                                                    // Handle ArrowUp key
                                                    if (e.key === "ArrowUp") {
                                                        setTotalPersons(prev => {
                                                            const current = Number(prev || 1); // Start from 1 if prev is empty
                                                            return current + 1; // Increment by 1
                                                        });
                                                        e.preventDefault();
                                                    }

                                                    // Handle ArrowDown key
                                                    if (e.key === "ArrowDown") {
                                                        setTotalPersons(prev => {
                                                            const current = Number(prev || 1); // Start from 1 if prev is empty
                                                            return current > 1 ? current - 1 : 1; // Prevent going below 1
                                                        });
                                                        e.preventDefault();
                                                    }
                                                }}

                                                onPaste={(e) => {
                                                    const pastedText = e.clipboardData.getData('Text');
                                                    if (pastedText.includes('-')) {
                                                        e.preventDefault(); // Block pasting minus sign
                                                    }
                                                }}
                                            />

                                            {/*done*/}
                                            <button
                                                className="btn"
                                                type="button"
                                                onClick={() =>
                                                    setTotalPersons(totalPersons + 1)
                                                }
                                            >
                                                <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17">
                                                    <g transform="translate(-1475.5 -614.077)">
                                                        <rect width="17" height="2" transform="translate(1475.5 621.077)" fill="#707070" opacity="0.45"></rect>
                                                        <rect width="17" height="2" transform="translate(1485.5 614.077) rotate(90)" fill="#707070" opacity="0.45"></rect>
                                                    </g>
                                                </svg>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>}
                        </Modal.Body>

                        <Modal.Footer>

                            <div className={`d-flex ${recommend2fixedstack.length > 1 ? "justify-content-space-between" : "justify-content-end"} w-100`}>

                                {recommend2fixedstack.length > 1 && (
                                    <button
                                        onClick={() => {

                                            if (recommend2fixedstackIndex > 0) { // Prevent negative index


                                                setFromTime(recommend2fixedstack[recommend2fixedstackIndex - 1]?.fromTime ? recommend2fixedstack[recommend2fixedstackIndex - 1]?.fromTime : null);
                                                setToTime(recommend2fixedstack[recommend2fixedstackIndex - 1]?.toTime ? recommend2fixedstack[recommend2fixedstackIndex - 1]?.toTime : null);

                                                setTotalPersons(recommend2fixedstack[recommend2fixedstackIndex - 1]?.count ? recommend2fixedstack[recommend2fixedstackIndex - 1]?.count : null);
                                                setSelectedDateVELG(recommend2fixedstack[recommend2fixedstackIndex - 1]?.date ? recommend2fixedstack[recommend2fixedstackIndex - 1]?.date : null);
                                                setrecommend2fixedstackIndex(recommend2fixedstackIndex - 1);

                                                if (recommend2fixedstack[recommend2fixedstackIndex - 1]?.isCustomActivity) {
                                                    let previous_data = customActivity_Default;
                                                    previous_data.antall = recommend2fixedstack[recommend2fixedstackIndex - 1]?.count ? recommend2fixedstack[recommend2fixedstackIndex - 1]?.count : totalPersons;
                                                    previous_data.date = recommend2fixedstack[recommend2fixedstackIndex - 1]?.date ? recommend2fixedstack[recommend2fixedstackIndex - 1]?.date : selectedDateVELG;
                                                    previous_data.price = recommend2fixedstack[recommend2fixedstackIndex - 1]?.price;
                                                    previous_data.fromTime = recommend2fixedstack[recommend2fixedstackIndex - 1]?.fromTime;
                                                    previous_data.toTime = recommend2fixedstack[recommend2fixedstackIndex - 1]?.toTime;

                                                    setCustomActivity(previous_data);
                                                    setShowCustomActivity(true);
                                                }
                                                else {
                                                    let previous_data = customActivity_Default;
                                                    setCustomActivity(customActivity_Default);
                                                    setShowCustomActivity(false);
                                                }
                                                //    setrecommend2fixedstackIndex(recommend2fixedstackIndex - 1);
                                                //    setSelectedDateVELG(null);
                                            }
                                        }}
                                        className={`btnOrder ${recommend2fixedstackIndex === 0 ? "disabled" : ""}`}
                                        disabled={recommend2fixedstackIndex === 0} // Properly disable button
                                    >
                                        <i className="ri-arrow-left-line"></i> FORRIGE
                                    </button>
                                )}


                                <button
                                    onClick={() => {


                                        recommend2fixedstack[recommend2fixedstackIndex].index = recommend2fixedstackIndex;


                                        recommend2fixedstack[recommend2fixedstackIndex].isCustomActivity = showCustomActivity;
                                        if (showCustomActivity) {
                                            recommend2fixedstack[recommend2fixedstackIndex].name = customActivity.title;
                                            recommend2fixedstack[recommend2fixedstackIndex].price = customActivity.price;


                                        }
                                        recommend2fixedstack[recommend2fixedstackIndex].count = totalPersons;
                                        recommend2fixedstack[recommend2fixedstackIndex].date = selectedDateVELG;
                                        recommend2fixedstack[recommend2fixedstackIndex].fromTime = fromTime;
                                        recommend2fixedstack[recommend2fixedstackIndex].toTime = toTime;

                                        setrecommend2fixedstackIndex(recommend2fixedstackIndex + 1);
                                        setTotalPersons(recommend2fixedstack[recommend2fixedstackIndex + 1]?.count ? recommend2fixedstack[recommend2fixedstackIndex + 1]?.count : totalPersons);
                                        setSelectedDateVELG(recommend2fixedstack[recommend2fixedstackIndex + 1]?.date ? recommend2fixedstack[recommend2fixedstackIndex + 1]?.date : null);
                                        setFromTime('');
                                        setToTime('');
                                        if (recommend2fixedstack[recommend2fixedstackIndex + 1]?.isCustomActivity) {
                                            let previous_data = customActivity_Default;
                                            previous_data.antall = recommend2fixedstack[recommend2fixedstackIndex + 1]?.count ? recommend2fixedstack[recommend2fixedstackIndex + 1]?.count : totalPersons;
                                            previous_data.date = recommend2fixedstack[recommend2fixedstackIndex + 1]?.date ? recommend2fixedstack[recommend2fixedstackIndex + 1]?.date : selectedDateVELG;
                                            previous_data.price = recommend2fixedstack[recommend2fixedstackIndex + 1]?.price;
                                            previous_data.fromTime = recommend2fixedstack[recommend2fixedstackIndex + 1]?.fromTime;
                                            previous_data.toTime = recommend2fixedstack[recommend2fixedstackIndex + 1]?.toTime;

                                            setCustomActivity(previous_data);
                                            setShowCustomActivity(true);
                                        }
                                        else {
                                            let previous_data = customActivity_Default;
                                            setCustomActivity(customActivity_Default);
                                            setShowCustomActivity(false);
                                        }
                                        //setTotalPersons(1)


                                    }}
                                    className={`btnOrder ${!canProceedCustomActivity({
                                        showCustomActivity,
                                        selectedDateVELG,
                                        recommend2fixedstack,
                                        recommend2fixedstackIndex,
                                        customActivity
                                    }) ? "disabled" : ""}`}     >
                                    {(currentModalIndex == recommendedOpenModalsPopup.length - 1) ? "SEND inn" : "NESTE"}  <i class="ri-arrow-right-line"></i>
                                </button>
                            </div>
                        </Modal.Footer>
                    </Modal>
                )
            }



            {recommendedOpenModals &&
                recommendedOpenModals.length > 0 &&
                recommendedOpenModalsSingleIndex !== null &&
                recommendedOpenModalsSingleIndex >= 0 &&
                // Render only the single specified modal
                <Modal
                    centered
                    key={recommendedOpenModalsSingleIndex}
                    backdrop="static" // Prevent closing when clicking outside
                    keyboard={false}   // Prevent closing when pressing ESC
                    show={true}
                    onHide={() => { setRecommendedOpenModalsSingleIndex(-1); }}
                >
                    <Modal.Header closeButton>
                        <Modal.Title>AKTIVITETSDETALJER </Modal.Title>
                    </Modal.Header>

                    <Modal.Body className="flex">
                        <div className="col_searchCard_inr left-section-crd">
                            <div className="position-relative img_otr">
                                <img
                                    className="card_imgS card_imgS-modal"
                                    src={
                                        recommendedOpenModals[recommendedOpenModalsSingleIndex].images
                                            ? JSON.parse(recommendedOpenModals[recommendedOpenModalsSingleIndex].images)?.[0]?.imageURL.replace("{baseApiURL}", "https://funtlers.com/")
                                            : recommendedOpenModals[recommendedOpenModalsSingleIndex].imageURL?.replace("{baseApiURL}", "https://funtlers.com/") || "bookingImg"
                                    }
                                    alt="img"
                                />
                            </div>
                            <p className="heading-lb card_heading card_heading-model">{recommendedOpenModals[recommendedOpenModalsSingleIndex]?.name}</p>
                        </div>

                        <div className="col_searchCard_inr">


                            {recommendedOpenModals[recommendedOpenModalsSingleIndex]?.isCustomActivity ? (
                                <div>
                                    <div className="flex">

                                        <div>
                                            <div className="d-flex flex-column align-left" style={{ padding: "0px 15px" }}>
                                                <medium className="text-muted mt-2"><b>Tittel:</b></medium>
                                                <div className="d-flex flex-row">
                                                    <div className="d-flex flex-column ml-1 w-100">
                                                        <input
                                                            className="form-control"
                                                            type="text"
                                                            value={recommendedOpenModals[recommendedOpenModalsSingleIndex]?.name || ""}
                                                            onChange={e => {
                                                                const updated = [...recommendedOpenModals];
                                                                updated[recommendedOpenModalsSingleIndex].name = e.target.value;
                                                                setRecommendedOpenModals(updated);
                                                            }}
                                                            placeholder="Skriv inn tittel"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="p-3">
                                                <div className="d-flex flex-row justify-content-between mid g-22">
                                                    <div className="d-flex flex-column align-left">
                                                        <medium className="text-muted mt-2"><b>Pris per person:</b></medium>
                                                        <div className="d-flex flex-row">
                                                            <div className="d-flex flex-column ml-1">
                                                                <input
                                                                    className="form-control"
                                                                    type="number"
                                                                    min="0"
                                                                    value={recommendedOpenModals[recommendedOpenModalsSingleIndex]?.price || 0}
                                                                    onChange={e => {
                                                                        const updated = [...recommendedOpenModals];
                                                                        updated[recommendedOpenModalsSingleIndex].price = e.target.value;
                                                                        setRecommendedOpenModals(updated);
                                                                    }}
                                                                    onKeyDown={(e) => {
                                                                        if (e.key === '-') {
                                                                            e.preventDefault(); // Block minus sign when typing
                                                                        }
                                                                    }}
                                                                    onPaste={(e) => {
                                                                        const pastedText = e.clipboardData.getData('Text');
                                                                        if (pastedText.includes('-')) {
                                                                            e.preventDefault(); // Block pasting minus sign
                                                                        }
                                                                    }}
                                                                    placeholder="Pris"
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="d-flex flex-column">
                                                        <medium className="text-muted mt-2"><b>Antall personer:</b></medium>
                                                        <div className="d-flex flex-column ml-1">
                                                            <input
                                                                className="form-control"
                                                                type="number"
                                                                min="1"
                                                                value={
                                                                    (recommendedOpenModals[recommendedOpenModalsSingleIndex]?.minPerson || 0) + Number(totalPersons || 0)
                                                                }
                                                                onChange={e => {
                                                                    const min = recommendedOpenModals[recommendedOpenModalsSingleIndex]?.minPerson || 0;
                                                                    const val = e.target.value;
                                                                    if (val === "") {
                                                                        setTotalPersons("");
                                                                    } else if (/^[0-9]*$/.test(val)) {
                                                                        const typed = Number(val) - min;
                                                                        if (typed >= 0) {
                                                                            setTotalPersons(typed);
                                                                        }
                                                                    }
                                                                }}
                                                                onKeyDown={(e) => {
                                                                    if (e.key === '-') {
                                                                        e.preventDefault(); // Block minus sign when typing
                                                                    }
                                                                }}
                                                                onPaste={(e) => {
                                                                    const pastedText = e.clipboardData.getData('Text');
                                                                    if (pastedText.includes('-')) {
                                                                        e.preventDefault(); // Block pasting minus sign
                                                                    }
                                                                }}
                                                                placeholder="Antall"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="mid d-flex flex-column align-left">
                                                    <medium className="text-muted mt-2"><b>Total aktivitetspris:</b></medium>
                                                    <div className="d-flex flex-column ml-1">
                                                        <p>
                                                            {
                                                                (recommendedOpenModals[recommendedOpenModalsSingleIndex]?.price || 0) *
                                                                ((recommendedOpenModals[recommendedOpenModalsSingleIndex]?.minPerson || 0) + Number(totalPersons || 0))
                                                            } NOK
                                                        </p>
                                                    </div>
                                                    <div class="VELG-sec d-flex" >
                                                        <medium className="text-muted mt-2" style={{ padding: "2px 7px 7px 9px", width: "93px" }}><b>Dato:</b></medium>
                                                        <div className="ml-1" style={{ width: "100%" }}>
                                                            <div
                                                                style={{
                                                                    cursor: "pointer",
                                                                    padding: "8px 12px",
                                                                    border: "1px solid #ced4da",
                                                                    borderRadius: 4,
                                                                    background: "#fff",
                                                                    minWidth: 160,
                                                                    color: recommendedOpenModals[recommendedOpenModalsSingleIndex]?.addDate ? "#212529" : "#888"
                                                                }}
                                                                onClick={() => setShowCalenderVELG(!showCalenderVELG)}
                                                                className="dropdownCal Theme_select"
                                                            >
                                                                <span>
                                                                    {recommendedOpenModals[recommendedOpenModalsSingleIndex]?.addDate
                                                                        ? dayjs(recommendedOpenModals[recommendedOpenModalsSingleIndex]?.addDate).format("YY/M/D")
                                                                        : (selectedDateVELG ? dayjs(selectedDateVELG).format("YY/M/D") : "Velg dato")}
                                                                </span>
                                                                <i className="ri-arrow-down-s-line" style={{ float: "right" }}></i>
                                                            </div>
                                                            {showCalenderVELG && (
                                                                <div className="dropdown-contentCal" style={{ zIndex: 10 }}>
                                                                    <CalenderComponent
                                                                        setSelectedDate={setSelectedDateVELG}
                                                                        selectedDate={selectedDateVELG}
                                                                        setShowCalender={setShowCalenderVELG}
                                                                    />
                                                                </div>
                                                            )}

                                                        </div>
                                                    </div>
                                                    <div className="VELG-sec " style={{ alignItems: "center", width: "97.5%" }}>
                                                        <TimeRangeSelector
                                                            labelFrom="TID"
                                                            labelTo="TIL"
                                                            fromTime={fromTime}
                                                            toTime={toTime}
                                                            setFromTime={setFromTime}
                                                            setToTime={setToTime}
                                                        />
                                                    </div>

                                                    <medium className="text-muted mt-2"><b>Kategori:</b></medium>
                                                    <div className="d-flex flex-column ml-1">
                                                        <div>
                                                            <i className="ri-store-3-line"></i> {recommendedOpenModals[recommendedOpenModalsSingleIndex]?.kategori || "EGEN PLANLAGT AKTIVITET"}
                                                        </div>
                                                    </div>
                                                </div>

                                                {isEditMode && (EditData?.Mode === "isEditAdminRequest" || EditData?.Mode === "isEditBooking") && EditData?.Action !== "EditPending"
                                                    && (<div className="d-flex flex-column my-f mt-3 p-2">
                                                    <label className=" mt-2">
                                                        <strong>Brukerkommentarer:</strong>
                                                    </label>

                                                    <div className="d-flex flex-column ml-1">
                                                        <textarea
                                                            className="form-control"
                                                            rows={3}
                                                            value={comments}
                                                            onChange={(e) => {
                                                               
                                                                setComments(e.target.value || "");

                                                            }}
                                                            placeholder="Skriv en kommentar eller årsak her..."
                                                        />
                                                    </div>
                                                </div>)}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <>
                                    <div className="d-flex flex-row justify-content-between p-3 mid">
                                        <div className="d-flex flex-column align-left">
                                            <medium className="text-muted mt-1"><b>Antall personer:</b></medium>
                                            <div className="d-flex flex-row">
                                                <div className="d-flex flex-column ml-1">
                                                    <large className="ghj">
                                                        {(recommendedOpenModals[recommendedOpenModalsSingleIndex]?.minPerson + totalPersons)}
                                                    </large>
                                                </div>
                                            </div>
                                            <medium className="text-muted mt-3"><b>Pris per person:</b></medium>
                                            <div className="d-flex flex-row">
                                                <div className="d-flex flex-column ml-1">
                                                    <large className="ghj">
                                                        {recommendedOpenModals[recommendedOpenModalsSingleIndex]?.price || 0} NOK
                                                    </large>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="d-flex flex-column">
                                            <medium className="text-muted mb-t"><b>Total aktivitetspris:</b></medium>
                                            <div className="d-flex flex-column">
                                                <div className="d-flex flex-column ml-1">
                                                    <large className="ghj">
                                                        {(recommendedOpenModals[recommendedOpenModalsSingleIndex]?.price || 0) *
                                                            (recommendedOpenModals[recommendedOpenModalsSingleIndex]?.minPerson + totalPersons)} NOK
                                                    </large>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="my-f mt-3">
                                        <div style={{ padding: "10px", width: "65px" }}>
                                            <strong>Dato</strong>
                                        </div>
                                        <div
                                            style={{ cursor: "pointer", padding: "0px", width: "81%", marginLeft: "6px" }}
                                            onClick={() => setShowCalenderVELG(!showCalenderVELG)}
                                            className="dropdownCal Theme_select"
                                        >
                                            <span>{selectedDateVELG ? dayjs(selectedDateVELG).format("YY/M/D") : "Velg dato"}</span>
                                            <i className="ri-arrow-down-s-line"></i>
                                        </div>
                                        {showCalenderVELG && (
                                            <div className="dropdown-contentCal">
                                                <CalenderComponent
                                                    setSelectedDate={setSelectedDateVELG}
                                                    selectedDate={selectedDateVELG}
                                                    setShowCalender={setShowCalenderVELG}
                                                />
                                            </div>
                                        )}
                                    </div>

                                    <div className="VELG-sec " style={{ alignItems: "center", width: "97.5%" }}>
                                        <TimeRangeSelector
                                            labelFrom="TID"
                                            labelTo="TIL"
                                            fromTime={fromTime}
                                            toTime={toTime}
                                            setFromTime={setFromTime}
                                            setToTime={setToTime}
                                        />
                                    </div>


                                    <div className="VELG-sec" style={{ display: "inline-flex", alignItems: "center" }}>

                                        <div style={{ padding: "10px" }}>
                                            <strong>Antall</strong>
                                        </div>
                                        <div className="text input-block">
                                            <div className="input-group">
                                                <button
                                                    className="btn"
                                                    type="button"
                                                    onClick={() =>
                                                        totalPersons > recommendedOpenModals[recommendedOpenModalsSingleIndex]?.minPerson
                                                            ? setTotalPersons(totalPersons - 1)
                                                            : setTotalPersons(totalPersons)
                                                    }
                                                >
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="2" viewBox="0 0 24 2">
                                                        <g fill="#fff" stroke="#707070" strokeWidth="1" opacity="0.45">
                                                            <rect width="24" height="2" stroke="none"></rect>
                                                            <rect x="0.5" y="0.5" width="23" height="1" fill="none"></rect>
                                                        </g>
                                                    </svg>
                                                </button>
                                                <input
                                                    type="text"
                                                    inputMode="numeric"
                                                    pattern="[0-9]*"
                                                    className="form-control bg-transparent"
                                                    aria-describedby="button-addon"
                                                    value={
                                                        (recommendedOpenModals[recommendedOpenModalsSingleIndex]?.minPerson || 0) + Number(totalPersons || 0)
                                                    }
                                                    onChange={e => {
                                                        const val = e.target.value;
                                                        const min = recommendedOpenModals[recommendedOpenModalsSingleIndex]?.minPerson || 0;

                                                        if (val === "") {
                                                            setTotalPersons("");
                                                        } else if (/^[0-9]*$/.test(val)) {
                                                            const typed = Number(val) - min;
                                                            if (typed >= 0) {
                                                                setTotalPersons(typed);
                                                            }
                                                        }
                                                    }}
                                                    onBlur={e => {
                                                        const val = e.target.value;
                                                        // Default to 1 if empty or 0
                                                        if (val === "" || val === "0") {
                                                            setTotalPersons(1);
                                                        }
                                                    }}
                                                    onKeyDown={e => {
                                                        if (e.key === '-') {
                                                            e.preventDefault(); // Block minus sign when typing
                                                        }
                                                        if (["e", "E", "+", "-", "."].includes(e.key)) {
                                                            e.preventDefault();
                                                        }

                                                        if (e.key === "ArrowUp") {
                                                            setTotalPersons(prev => {
                                                                const current = Number(prev || 0);
                                                                return current + 1;
                                                            });
                                                            e.preventDefault();
                                                        }
                                                        if (e.key === "ArrowDown") {
                                                            setTotalPersons(prev => {
                                                                const current = Number(prev || 0);
                                                                return current > 0 ? current - 1 : 0;
                                                            });
                                                            e.preventDefault();
                                                        }
                                                    }}

                                                    onPaste={(e) => {
                                                        const pastedText = e.clipboardData.getData('Text');
                                                        if (pastedText.includes('-')) {
                                                            e.preventDefault(); // Block pasting minus sign
                                                        }
                                                    }}
                                                />
                                                <button
                                                    className="btn"
                                                    type="button"
                                                    onClick={() =>
                                                        totalPersons <= recommendedOpenModals[recommendedOpenModalsSingleIndex]?.maxPerson
                                                            ? setTotalPersons(totalPersons + 1)
                                                            : setTotalPersons(totalPersons)
                                                    }
                                                >
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17">
                                                        <g transform="translate(-1475.5 -614.077)">
                                                            <rect width="17" height="2" transform="translate(1475.5 621.077)" fill="#707070" opacity="0.45"></rect>
                                                            <rect width="17" height="2" transform="translate(1485.5 614.077) rotate(90)" fill="#707070" opacity="0.45"></rect>
                                                        </g>
                                                    </svg>
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                        {isEditMode && (EditData?.Mode === "isEditAdminRequest" || EditData?.Mode === "isEditBooking")
                                            && (<div className="d-flex flex-column my-f mt-3 p-2">
                                            <label className=" mt-2">
                                                <strong>Brukerkommentarer:</strong>
                                            </label>

                                            <div className="d-flex flex-column ml-1">
                                                <textarea
                                                    className="form-control"
                                                    rows={3}
                                                    value={comments}
                                                    onChange={(e) => {
                                                        setComments(e.target.value || "");

                                                    }}
                                                    placeholder="Skriv en kommentar eller årsak her..."
                                                />
                                            </div>
                                        </div>)}

                                </>
                            )}



                        </div>
                    </Modal.Body>

                    <Modal.Footer>
                        <div className="d-flex justify-content-center">
                            <button
                                onClick={() => {

                                    handleSave(recommendedOpenModals[recommendedOpenModalsSingleIndex], recommendedOpenModalsSingleIndex, false);
                                    setSelectedDateVELG(null);
                                }}
                                className={`btnOrder w-100 ${!selectedDateVELG ? "disabled" : ""}`}
                            >
                                INKLUDER  <i class="ri-arrow-right-line"></i>
                            </button>
                        </div>
                    </Modal.Footer>
                </Modal>


            }



            {recommendedOpenModals && recommendedOpenModals.length < 0 &&
                <>


                    {recommendedOpenModalsSingleIndex !== null && recommendedOpenModalsSingleIndex >= 0 ? (
                        // Render only the single specified modal
                        <Modal
                            centered
                            key={recommendedOpenModalsSingleIndex}
                            backdrop="static" // Prevent closing when clicking outside
                            keyboard={false}   // Prevent closing when pressing ESC
                            show={true}
                            onHide={() => resetToPreviousState()}
                        >
                            <Modal.Header >
                                <Modal.Title>AKTIVITETSDETALJER</Modal.Title>
                            </Modal.Header>

                            <Modal.Body className="flex">
                                <div className="col_searchCard_inr left-section-crd">
                                    <div className="position-relative img_otr">
                                        <img
                                            className="card_imgS card_imgS-modal"
                                            src={
                                                recommendedOpenModals[recommendedOpenModalsSingleIndex].images
                                                    ? JSON.parse(recommendedOpenModals[recommendedOpenModalsSingleIndex].images)?.[0]?.imageURL.replace("{baseApiURL}", "https://funtlers.com/")
                                                    : recommendedOpenModals[recommendedOpenModalsSingleIndex].imageURL?.replace("{baseApiURL}", "https://funtlers.com/") || "bookingImg"
                                            }
                                            alt="img"
                                        />
                                    </div>
                                    <p className="heading-lb card_heading card_heading-model">{recommendedOpenModals[recommendedOpenModalsSingleIndex]?.name}</p>
                                </div>

                                <div className="col_searchCard_inr">
                                    <div className="d-flex flex-row justify-content-between p-3 mid">
                                        <div className="d-flex flex-column align-left">
                                            <medium className="text-muted mt-1"><b>Antall personer:</b></medium>
                                            <div className="d-flex flex-row">
                                                <div className="d-flex flex-column ml-1">
                                                    <large className="ghj">{(recommendedOpenModals[recommendedOpenModalsSingleIndex]?.minPerson + totalPersons)}</large>
                                                </div>
                                            </div>
                                            <medium className="text-muted mt-3"><b>Pris per person:</b></medium>
                                            <div className="d-flex flex-row">
                                                <div className="d-flex flex-column ml-1">
                                                    <large className="ghj">{recommendedOpenModals[recommendedOpenModalsSingleIndex]?.price || 0} NOK</large>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="d-flex flex-column">
                                            <medium className="text-muted mb-t"><b>Total aktivitetspris:</b></medium>
                                            <div className="d-flex flex-column">
                                                <div className="d-flex flex-column ml-1">
                                                    <large className="ghj">{(recommendedOpenModals[recommendedOpenModalsSingleIndex]?.price || 0) * (recommendedOpenModals[recommendedOpenModalsSingleIndex]?.minPerson + totalPersons)} NOK</large>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="my-f mt-3">
                                        <div style={{ padding: "10px", width: "64px" }}>
                                            <strong>Dato</strong>
                                        </div>

                                        <div
                                            style={{ cursor: "pointer", paddingRight: "10px", width: "100%" }}
                                            onClick={() => setShowCalenderVELG(!showCalenderVELG)}
                                            className="dropdownCal Theme_select"
                                        >
                                            <span>{selectedDateVELG ? dayjs(selectedDateVELG).format("YY/M/D") : "Velg dato"}</span>
                                            <i className="ri-arrow-down-s-line"></i>
                                        </div>

                                        {showCalenderVELG && (
                                            <div className="dropdown-contentCal">
                                                <CalenderComponent
                                                    setSelectedDate={setSelectedDateVELG}
                                                    selectedDate={selectedDateVELG}
                                                    setShowCalender={setShowCalenderVELG}
                                                />
                                            </div>
                                        )}

                                    </div>

                                    <div className="VELG-sec" style={{ display: "inline-flex", alignItems: "center" }}>
                                        <div style={{ padding: "10px" }}>
                                            <strong>Antall</strong>
                                        </div>
                                        <div className="text input-block">
                                            <div className="input-group">
                                                <button
                                                    className="btn"
                                                    type="button"
                                                    onClick={() =>
                                                        totalPersons > recommendedOpenModals[recommendedOpenModalsSingleIndex]?.minPerson
                                                            ? setTotalPersons(totalPersons - 1)
                                                            : setTotalPersons(totalPersons)
                                                    }
                                                >
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="2" viewBox="0 0 24 2">
                                                        <g fill="#fff" stroke="#707070" strokeWidth="1" opacity="0.45">
                                                            <rect width="24" height="2" stroke="none"></rect>
                                                            <rect x="0.5" y="0.5" width="23" height="1" fill="none"></rect>
                                                        </g>
                                                    </svg>
                                                </button>
                                                <input
                                                    type="text"
                                                    className="form-control bg-transparent"
                                                    aria-describedby="button-addon"
                                                    value={totalPersons + (recommendedOpenModals[recommendedOpenModalsSingleIndex]?.minPerson || 0)}
                                                    min="1"
                                                    inputMode="numeric"
                                                    pattern="[0-9]*"
                                                    onChange={e => {
                                                        const val = e.target.value;
                                                        const min = recommendedOpenModals[recommendedOpenModalsSingleIndex]?.minPerson || 0;

                                                        if (val === "") {
                                                            // Allow clearing, set totalPersons to 1
                                                            setTotalPersons("");
                                                        } else if (/^[0-9]*$/.test(val)) { // Allow empty string and digits
                                                            const typed = Number(val) - min;
                                                            if (typed >= 0) {
                                                                setTotalPersons(typed);
                                                            }
                                                        }
                                                    }}
                                                    onBlur={e => {
                                                        const val = e.target.value;
                                                        // Default to 1 if empty or 0
                                                        if (val === "" || val === "0") {
                                                            setTotalPersons(1);
                                                        }
                                                    }}
                                                    onKeyDown={e => {
                                                        if (e.key === '-') {
                                                            e.preventDefault(); // Block minus sign when typing
                                                        }
                                                        if (["e", "E", "+", "-", "."].includes(e.key)) {
                                                            e.preventDefault(); // block invalid keys
                                                        }

                                                        if (e.key === "ArrowUp") {
                                                            setTotalPersons(prev => {
                                                                const current = Number(prev || 0); // Start from 0 if prev is empty
                                                                return current + 1; // Increment by 1
                                                            });
                                                            e.preventDefault();
                                                        }

                                                        if (e.key === "ArrowDown") {
                                                            setTotalPersons(prev => {
                                                                const current = Number(prev || 1); // Start from 1 if prev is empty
                                                                return current > 1 ? current - 1 : 1; // Prevent going below 1
                                                            });
                                                            e.preventDefault();
                                                        }
                                                    }}


                                                    onPaste={(e) => {
                                                        const pastedText = e.clipboardData.getData('Text');
                                                        if (pastedText.includes('-')) {
                                                            e.preventDefault(); // Block pasting minus sign
                                                        }
                                                    }}
                                                />
                                                {/* done*/}
                                                <button
                                                    className="btn"
                                                    type="button"
                                                    onClick={() =>
                                                        totalPersons <= recommendedOpenModals[recommendedOpenModalsSingleIndex]?.maxPerson
                                                            ? setTotalPersons(totalPersons + 1)
                                                            : setTotalPersons(totalPersons)
                                                    }
                                                >
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17">
                                                        <g transform="translate(-1475.5 -614.077)">
                                                            <rect width="17" height="2" transform="translate(1475.5 621.077)" fill="#707070" opacity="0.45"></rect>
                                                            <rect width="17" height="2" transform="translate(1485.5 614.077) rotate(90)" fill="#707070" opacity="0.45"></rect>
                                                        </g>
                                                    </svg>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Modal.Body>

                            <Modal.Footer>
                                <div className="d-flex justify-content-center">
                                    <button
                                        onClick={() => {

                                            handleSave(recommendedOpenModals[recommendedOpenModalsSingleIndex], recommendedOpenModalsSingleIndex, false);
                                            setSelectedDateVELG(null);
                                        }}
                                        className={`btnOrder w-100 ${!selectedDateVELG ? "disabled" : ""}`}
                                    >
                                        INKLUDER  <i class="ri-arrow-right-line"></i>
                                    </button>
                                </div>
                            </Modal.Footer>
                        </Modal>
                    )
                        : (<p></p>)
                    }
                </>
            }

            

            {isEditMode && (
                <>
                    <div
                        className={`${EditData?.Mode !== "isEditAdminRequest" ? "bg-total" : "bg-total-2"
                            } ${action || ""}`}
                    >
                        <hr />
                        <h5 className="mb-4">
                            <b>Total kostnad:</b>{" "}
                            {parseInt(
                                widget.reduce((sum, val) => {
                                    const total =
                                        (val?.price || 0) *
                                        ((val?.minPerson || 0) + (val?.totPersons || 0));
                                    return sum + total;
                                }, 0),
                                10
                            )}{" "}
                            NOK
                        </h5>
                    </div>

                    <br />

                
                </>
            )}

            {isEditMode && EditData?.Mode === "isEditAdminRequest" && checkIsRemainActivities() >0 && false && (
                <p className="text-muted mb-4">
                    <strong>
                        Bestillingen din har en original bestilling som krever flere aktiviteter ({checkIsRemainActivities()}). Du kan legge til en annen aktivitet for å erstatte den kansellerte og sende den inn på nytt.                    </strong>
                </p>
            )}

            {isEditMode && EditData?.Mode === "isEditBooking" &&

                <div>
                    {EditData?.View === "admin" && < p className="text-center my-3" >Ved å klikke på knappen under, vil B2B Kunden motta en kopi av den forespurte endringen til Funtlers. Merk at bestillingen ikke blir godkjent før kunden aksepterer endringene. </p>}
                    {EditData?.View !== "admin" &&
                        < p className="text-center my-3" >
                    Ved å klikke på knappen under, vil teamet til Funtlers motta en kopi av den forespurte bestillingen din.<br />Merk at bestillingen ikke er godkjent før du får en bestillingsbekreftelse på din e-post.
                    <br />
                    Ved å sende inn denne forespørselen godkjenner du våre{' '}
                    <Link
                        to="/vilkar"
                        style={{
                            cursor: 'pointer', display: 'contents'
                        }}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        vilkår
                    </Link>.                        </p>
                }

                    {EditData?.View !== "admin" && <>

                        <h4 className="mx-4 text-center fw-bold m-2" >TILLEGGSINFORMASJON</h4>
                        <textarea
                            tabindex="1"
                            value={text}
                            onChange={handleChange}
                            name="text"
                            className="text-box"
                            placeholder="Fyll inn eventuelle forespørsler, allergier eller kommentarer ..."
                            rows={4} // Adjust the number of rows as needed
                            cols={50} // Adjust the number of columns as needed
                        />


                        <hr />

                        <h4 className="mx-4 text-center fw-bold m-2" >FAKTURA INFORMASJON</h4>
                        <div className="form-group">
                            <div className="row d-flex justify-content-center align-items-end">
                                <div className="my-3 col-md-6">
                                    <div>
                                        <h6 className="fw-bold required">Bedriftsnavn:</h6>
                                        <input
                                            tabIndex="2"
                                            required
                                            type="text"
                                            name="companyName"
                                            value={companyName}
                                            onChange={handleChange}
                                            className="form-control"
                                            readOnly={EditData?.View === "b2b"}
                                        />

                                        <h6 className="fw-bold required">Org nr:</h6>
                                        <input
                                            tabIndex="4"
                                            required
                                            type="text"
                                            name="organizationNumber"
                                            value={organizationNumber}
                                            onChange={handleChange}
                                            className="form-control"
                                            readOnly={EditData?.View === "b2b"}
                                        />

                                        <h6 className="fw-bold">Faktura adresse:</h6>
                                        <input
                                            tabIndex="6"
                                            required
                                            type="text"
                                            name="invoiceAddress"
                                            value={invoiceAddress}
                                            onChange={handleChange}
                                            className="form-control"
                                            readOnly={EditData?.View === "b2b"}
                                        />
                                    </div>
                                </div>

                                <div className="my-3 col-md-6">
                                    <div>
                                        <h6 className="fw-bold required">Faktura sendes til:</h6>
                                        <input
                                            required
                                            tabIndex="3"
                                            type="text"
                                            name="invoiceSentTo"
                                            value={invoiceSentTo}
                                            onChange={handleChange}
                                            className="form-control"
                                            readOnly={EditData?.View === "b2b"}
                                        />

                                        <h6 className="fw-bold">Kontaktperson:</h6>
                                        <input
                                            required
                                            tabIndex="5"
                                            type="text"
                                            name="contactPerson"
                                            value={contactPerson}
                                            onChange={handleChange}
                                            className="form-control"
                                            readOnly={EditData?.View === "b2b"}
                                        />

                                        <h6 className="fw-bold">Faktura merkes med:</h6>
                                        <input
                                            required
                                            tabIndex="7"
                                            type="text"
                                            name="invoiceNote"
                                            value={invoiceNote}
                                            onChange={handleChange}
                                            className="form-control"
                                            readOnly={EditData?.View === "b2b"}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                    </>}
                </div>
            }
        </>
        );
    }


    const renderTitle = () => {
        return (
            <>
              

                {!isEditMode && EditData==null && (
                    <div>
                        {
                            action && action === "add1" && <><h1 className="text-center admin_heading fw-bold">FINN ENGANGSAKTIVITET</h1>
                                <div className="d-flex justify-content-center" >
                                    <p className="text-center my-4 text-uppercase-subheading">HER FINNER DERE OPPLEVELSER SOM PASSER TIL NESTE TEAMBUILDING, AFTER WORK, JOBBFEST ELLER EN GØY AKTIVITET INTERNT PÅ KONTORET. <br />BRUK FILTERET UNDER, OG PLANLEGG DERES NESTE SOCIAL!
                                    </p>
                                </div></>
                        }
                        {
                            action && action === "edit1" && <><h1 className="text-center admin_heading fw-bold">REDIGER ENGANGSAKTIVITET</h1>
                                <div className="d-flex justify-content-center" >
                                    <p className="text-center my-4 text-uppercase-subheading">HER FINNER MAN EN OVERSIKT OVER ALLE ENGANGSAKTIVITETENE DERE VURDERER Å BOOKE. <br />MAN KAN ENKELT JUSTERE Antall personer, BUDSJETT ELLER ENDRE SELVE AKTIVITETEN. <br />KLIKK PÅ AKTIVITETEN DU ØNSKER Å REDIGERE!
                                    </p>
                                </div></>
                        }
                        {
                            action && action === "add2" && <><h1 className="text-center admin_heading fw-bold">LAG SOSIAL KALENDER</h1>
                                <div className="d-flex justify-content-center" >
                                    <p className="text-center my-4 text-uppercase-subheading">SKREDDERSY EN SOSIAL KALENDER SOM PASSER BEDRIFTEN DERES. <br />VELG HYPPIGHET, Antall personer OG BUDSJETT - OG FYLL ÅRET MED HYGGELIGE OPPLEVELSER.<br />VÅRT TIPS ER Å LAGE EN MIX AV ULIKE OPPLEVELSER: TEAMBUILDING, AFTER WORK, JOBBFEST ELLER EN GØY AKTIVITET INTERNT PÅ KONTORET.
                                    </p>
                                </div></>
                        }
                        {
                            action && action === "edit2" && <><h1 className="text-center admin_heading fw-bold">REDIGER SOSIAL KALENDER</h1>
                                <div className="d-flex justify-content-center" >
                                    <p className="text-center my-4 text-uppercase-subheading">HER INNER MAN EN OVERSIKT OVER ALLE SOSIALE ÅRSHJUL DERE HAR SKAPT. <br />MAN KAN ENKELT JUSTERE HYPPIGHET, Antall personer, BUDSJETT ELLER ENDRE AKTIVITETER. <br />KLIKK PÅ ÅRSHJULET DU ØNSKER Å REDIGERE.
                                    </p>
                                </div></>
                        }

                        {
                            action && (action === "rec1") && <><h1 className="text-center admin_heading fw-bold">ANBEFALTE ENGANGSAKTIVITETER</h1>
                                <div className="d-flex justify-content-center" >
                                    <p className="text-center col-md-10 mb-4 text-uppercase-subheading">
                                        Oppdag spennende aktiviteter! Velg først ønsket by og kategori, så får du opp anbefalte engangsaktiviteter. Klikk på en aktivitet for å lese mer eller lik for å velge den – enkelt og gøy!
                                        <br />
                                        Ønsker du flere alternativer? Trykk på «Hent nye forslag» og få friske, inspirerende ideer!                    </p>
                                </div></>
                        }
                        {
                            action && (action === "rec2") && <><h1 className="text-center admin_heading fw-bold">ANBEFALT ÅRSKALENDER</h1>
                                <div className="d-flex justify-content-center" >
                                    <p className="text-center col-md-10 mb-4 text-uppercase-subheading" >
                                        Bygg sterkere fellesskap året rundt – få inspirasjon til deres sosiale årskalender. Velg først ønsket by, antall aktiviteter og kategori. Vis forslag - og klikk på en aktivitet for å lese mer eller lik for å velge den. Bygg en sosial kalender som de ansatte blir engasjerte i!                    </p>
                                </div></>
                        }
                    </div>
                )}
                { isEditMode && EditData!==null && <>
                    <h1 className="text-center admin_heading fw-bold text-uppercase">{EditData.heading}</h1>
                    <div className="d-flex justify-content-center" >
                        <p className="text-center col-md-10 mb-4 text-uppercase">
                            {EditData.description}
                        </p>
                    </div>
                </>}
            </>
        );
        
    }



    const renderActionButton = () => {
        return (
            <>
            { action && (action === 'rec1' || action === 'rec2') && (!isEditMode) &&
            <div className="row d-flex align-items-center justify-content-center w-104 my-2" >
                <div className="col-2">
                    {updateState === -1 ? <button onClick={() => setShowModalCircle(true)} disabled={checkIsWheelNotEmpty()} className="btnOrder2 w-100">LAGRE</button> :
                        <button onClick={() => {
                            setShowModalCircle(true)
                        }} className="btnOrder2 w-100">REDIGERE</button>}

                </div>
                <div className="col-3">
                    <button className="btnOrder2 w-100" disabled={checkIsWheelNotEmpty()}
                        onClick={handlePrint} >PRINT UT/LAST NED</button>

                </div>
                <div className="col-3">
                    <button
                        disabled={checkIsWheelFilled()}
                        onClick={() => {
                            totalGetting()
                            setReqType('pending')
                            setShowModalReqBooking2(true)
                        }} className="btnOrder2 w-100">  {"Forhåndsvis".toUpperCase()}</button>

                </div>
                <div className="col-4">
                    <button
                        disabled={checkIsWheelFilled()}
                        onClick={() => {
                            totalGetting()
                            setReqType('pending')
                            setShowModalReqBooking(true)
                        }} className="btnOrder2 w-100">FORESPØR BOOKING</button>

                </div>
            </div> }

          {
             action && (action === "rec1" || action === "rec2") && isEditMode && EditData?.Mode !== "isEditAdminRequest" && (


            <div className="flex w-full gap-2">
                <button
                     disabled={checkIsWheelNotEmpty()}
                    onClick={handleSaveClick}
                    className="flex-1 flex items-center justify-center gap-2 rounded-md border-0 bg-purple-500 px-4 py-2 text-white hover:bg-purple-600 transition disabled:opacity-50"
                >
                    <i className="ri-save-line text-lg"></i>
                                {EditData?.View === "admin" ? "SEND FORESPØRSEL OM ENDRINGER" : "LAGRE ENDRINGER"}
                </button>

                {EditData?.Mode !== "isEditBooking" && <button
                    disabled={checkIsWheelNotEmpty()}
                    onClick={handlePrint}
                    className="flex-1 flex items-center justify-center gap-2 rounded-md border-0 btnOrder-orange px-4 py-2 text-white  transition disabled:opacity-50"
                >
                    <i className="ri-printer-line text-lg"></i>
                    PRINT UT/LAST NED
                </button>
                }
            </div>



            )
        }


                {
                    action && (action === "rec1" || action === "rec2") && isEditMode && EditData?.Mode === "isEditAdminRequest" && (


                        <div className="flex w-full gap-2">
                          
                            {EditData?.Mode !== "isEditBooking" && (
                                <button
                                    disabled={checkIsWheelNotEmpty()}
                                    onClick={handleConfirmClick} // <— your new accept handler
                                    className="w-50 flex-1 bg-green-600 px-4 py-2 text-white 
                                           hover:bg-green-700 transition disabled:opacity-50 
                                           flex items-center justify-center gap-2 rounded-lg"
                                >
                                    <i className="ri-check-line text-lg"></i>
                                    JEG GODTAR ENDRINGEN
                                </button>
                            )}


                            { <button
                                onClick={handleSaveClick}
                                disabled={checkIsWheelNotEmpty()}
                                class="w-50 flex-1 bg-purple-500 px-4 py-2 text-white hover:bg-purple-600 transition disabled:opacity-50"

                            >
                                <i className="ri-save-2-line text-lg"></i>
                                {EditData?.Mode !== "isEditBooking" ? "SEND INN MINE REDIGERTE FORSLAG " : "SEND INN PÅ NYTT"}
                            </button>
                            }

                            {EditData?.Mode !== "isEditBooking" && <button
                                disabled={checkIsWheelNotEmpty()}
                                onClick={handleCancelClick}
                                class="w-50  bg-icon flex-1 bg-red-500 px-4 py-2 text-white hover:bg-red-600 transition disabled:opacity-50"
                            >
                                <i className="ri-close-circle-line text-lg"></i>
                                OK, AVBRYT DENNE
                            </button>
                            }
                        </div>



                    )
                }


         <div className={`row   ${action == "rec1" || action == "rec2" ? "hidden" : ""}`}>
        <div className="col-lg-6 ">
            {action && (action === "add1" || action === "add2" || action === "rec1" || action == "rec2") &&
                <h3 className="text-center fw-bold">DRA AKTIVITETER INN i HJULET</h3>
            }
            <div className="d-flex flex-column align-items-center">
                {/*1 button*/}
                {action && (action === 'add1' || action == "rec1") && <div className="d-flex justify-content-center align-items-center row w-100" >
                    <div className="col-6 my-2" >
                        <button className="btnOrder my-3 w-100">ENGANGSAKTIVITET</button>
                    </div>
                </div>}
                {/*2 buttons*/}
                {action && (action === 'add2' || action === "rec2") && <>
                    <div className="row d-flex align-items-center justify-content-center mt-3 w-100">
                        <div className="col-6">
                            <button style={{ backgroundColor: twelve && "#FC9775" }} onClick={() => {
                                let chkd = checkdowngrade(12);
                                if (chkd) {

                                    if (widget.length > 12) {
                                        setShowModalRmv(widget.length - 12);
                                    }



                                }
                                setOne(false)
                                setTwo(false)
                                setFour(false)
                                setSix(false)
                                setTwelve(true)
                                let button = {
                                    "one": false,
                                    "two": false,
                                    "four": false,
                                    "six": false,
                                    "twelve": true
                                };

                                sessionStorage.setItem('button', JSON.stringify(button));


                            }}
                                className="btnOrder w-100 my-2">HVER MÅNED</button>

                        </div>
                        <div className="col-6">
                            <button style={{ backgroundColor: six && "#FC9775" }} onClick={() => {
                                let chkd = checkdowngrade(6);
                                if (chkd) {

                                    if (widget.length > 6) {
                                        setShowModalRmv(widget.length - 6);
                                    }



                                }
                                setOne(false)
                                setTwo(false)
                                setFour(false)
                                setSix(true)
                                setTwelve(false)
                                let button = {
                                    "one": false,
                                    "two": false,
                                    "four": false,
                                    "six": true,
                                    "twelve": false
                                };

                                sessionStorage.setItem('button', JSON.stringify(button));
                            }} className="btnOrder w-100 my-2">ANNENHVER MÅNED</button>

                        </div>
                        <div className="col-6">
                            <button style={{ backgroundColor: four && "#FC9775" }} onClick={() => {
                                let chkd = checkdowngrade(4);
                                if (chkd) {

                                    if (widget.length > 4) {
                                        setShowModalRmv(widget.length - 4);
                                    }



                                }
                                setOne(false)
                                setTwo(false)
                                setFour(true)
                                setSix(false)
                                setTwelve(false)
                                let button = {
                                    "one": false,
                                    "two": false,
                                    "four": true,
                                    "six": six,
                                    "twelve": false
                                };

                                sessionStorage.setItem('button', JSON.stringify(button));
                            }} className="btnOrder w-100 my-2">HVERT KVARTAL</button>
                        </div>
                        <div className="col-6">
                            <button style={{ backgroundColor: two && "#FC9775" }} onClick={() => {
                                let chkd = checkdowngrade(2);
                                if (chkd) {
                                    if (widget.length > 2) {
                                        setShowModalRmv(widget.length - 2);
                                    }



                                }
                                setOne(false)
                                setTwo(true)
                                setFour(false)
                                setSix(false)
                                setTwelve(false)
                                let button = {
                                    "one": false,
                                    "two": true,
                                    "four": false,
                                    "six": false,
                                    "twelve": false
                                };

                                sessionStorage.setItem('button', JSON.stringify(button));

                            }} className="btnOrder w-100 my-2">EN GANG I HALVÅRET</button>
                        </div>
                    </div>
                </>
                }

                {/*Circle for save */}
                {action && ((action === 'add1' || action === 'add2') || (action == "rec2" || action == "rec1")) &&
                    //Circle
                    <>
                        <div id="pdfDivMain-root" className='d-flex justify-content-center w-100 align-items-center mx-4' >
                            <div id="pdfDivMain" className="w-100">
                                <div ref={pdfRef} onDrop={handleOnDrop} onDragOver={handleDragOver} id="pdfContent" className="containerCircle my-4">
                                    <div onDrop={handleOnDrop} onDragOver={handleDragOver} className="iconCircle">
                                        {widget.map((activity, i) => {
                                            return <>

                                                <div onMouseEnter={() => handleMouseHover(activity)} onMouseLeave={handleMouseLeave} onMouseOver={() => setHoverActivity(activity)} key={i} class="imgBx" style={{
                                                    width: (one && "210px") || (two && "150px") || (four && "90px") || (six && "90px") || (twelve && "70px"),
                                                    height: (one && "210px") || (two && "150px") || (four && "90px") || (six && "90px") || (twelve && "70px"),
                                                    transform: `rotate(calc(360deg /${((one || two) && 2) || (four && 4) || (six && 6) || (twelve && 12)}* ${i}))`,
                                                    transformOrigin: two ? "260px" : "235px"
                                                }}>
                                                    <div style={{
                                                        transform: `rotate(calc(-360deg /${((one || two) && 2) || (four && 4) || (six && 6) || (twelve && 12)}* ${i}))`
                                                    }} className='iconHidden w-100  h-100    ' >

                                                        <i style={{ padding: (one && "8px 12px") || (two && "3px 6px") || ((four || six) && "1px 3px") || (twelve && "1px 2px"), fontSize: twelve && "1rem" }} onClick={() => handleDeleteActivity(activity)}
                                                            class="ri-delete-bin-7-line "></i>

                                                        <i style={{ padding: (one && "8px 12px") || (two && "3px 6px") || ((four || six) && "1px 3px") || (twelve && "1px 2px"), fontSize: twelve && "1rem" }} onClick={() => handleActivityEditClick(activity)} class="ri-edit-2-fill"></i>

                                                        {/*<i style={{ padding: (one && "8px 12px") || (two && "3px 6px") || ((four || six) && "1px 3px") || (twelve && "1px 2px"), fontSize: twelve && "1rem" }} onClick={() => handleActivityDelClick(activity.id)}  class="ri-add-line"></i>*/}
                                                        {/*<i style={{ padding: (one && "8px 12px") || (two && "3px 6px") || ((four || six) && "1px 3px") || (twelve && "1px 2px"), fontSize: twelve && "1rem" }} onClick={() => {*/}
                                                        {/*        const ad=activity.minPerson+activity.totPersons*/}
                                                        {/*        if (activity.minPerson < ad) {*/}

                                                        {/*        var xd = activity.totPersons - 1;*/}
                                                        {/*        setTotalPersons(xd)*/}
                                                        {/*        activity.totPersons = xd*/}
                                                        {/*        setHoverActivity(activity)*/}
                                                        {/*        }*/}
                                                        {/*      }} class="ri-subtract-line"></i>*/}
                                                    </div>


                                                    <img className={'hoverid' + activity.id}
                                                        style={{
                                                            transform: `rotate(calc(-360deg /${((one || two) && 2) || (four && 4) || (six && 6) || (twelve && 12)}* ${i}))`
                                                        }} src={activity.images && (activity.images
                                                            ? JSON.parse(activity.images)?.[0].imageURL
                                                            : 'bookingImg').replace("{baseApiURL}", "https://funtlers.com/") || activity.imageURL && (activity.imageURL.replace("{baseApiURL}", "https://funtlers.com/"))} alt="Pic" />


                                                </div>

                                                <h5 className={'header-circle ' + 'hoverid' + activity.id + '-header'} style={{
                                                    top: (one && "77px") || (two && "111px") || ((four) && "135px") || ((six) && "136px") || (twelve && "134px"), fontSize: twelve && "1rem"
                                                }}>
                                                    <b >{dayjs(activity.addDate).locale('nb').format('MMM')}</b>
                                                </h5>
                                            </>
                                        })}
                                    </div>
                                    <div class="contentCircle">
                                        {isHovered && <div className='searchResultContent' >
                                            <small class="circleBx"><strong>{hoverActivity.name?.slice(0, 16)}{hoverActivity.name?.length > 16 ? '...' : ''}</strong></small>
                                            <small class="circleBx"><strong>Dato:</strong>  {matchActFilter(hoverActivity.addDate)}</small>
                                            <small class="circleBx"><strong>Antall personer:</strong>  {(hoverActivity.minPerson + hoverActivity.totPersons)}</small>
                                            <small class="circleBx"><strong>TID:</strong>  {hoverActivity?.fromTime ? hoverActivity.fromTime : "N/A"} - {hoverActivity?.toTime ? hoverActivity.toTime : "N/A"}</small>
                                            <small class="circleBx"><strong>Pris per person:<br /></strong> {hoverActivity.price || 0} NOK</small>
                                            <small class="circleBx"><strong>Total pris aktivitet:<br /></strong>  {hoverActivity.price * (hoverActivity.minPerson + hoverActivity.totPersons) || 0} NOK</small>
                                        </div>}
                                    </div>
                                </div>
                            </div>
                        </div>
                        {action && action === 'edit1' && <div className="row">
                            <div className=" col-6 d-flex justify-content-center" >
                                <i class="ri-edit-box-line" style={{ fontSize: '2.4rem', cursor: 'pointer' }} ></i>
                                <i class="ri-delete-bin-6-line" style={{ fontSize: '2.4rem', cursor: 'pointer' }} ></i>
                            </div>
                            {action && action === 'edit2' &&
                                <div className="col-6 d-flex justify-content-center" >
                                    <i class="ri-delete-bin-6-line" style={{ fontSize: '2.4rem', cursor: 'pointer' }} ></i>
                                    <i class="ri-edit-box-line" style={{ fontSize: '2.4rem', cursor: 'pointer' }} ></i>
                                </div>}
                        </div>}
                        <div class="ins">
                            Hold over aktiviteten for å se valgte detaljer.<br /> Juster riktig Antall personer ved å trykke på + & - ikonet, for å se total pris.
                        </div>
                        <div className="footer-wheel row d-flex align-items-center justify-content-center w-100 my-3" style={{ width: "108%", important: true }}>
                            <div className="col-2">
                                {updateState === -1 ? <button onClick={() => setShowModalCircle(true)} className="btnOrder w-100">LAGRE</button> :
                                    <button onClick={() => {
                                        setShowModalCircle(true)
                                    }} className="btnOrder w-100">REDIGERE</button>}

                            </div>
                            <div className="col-3">
                                <button className="btnOrder w-100" disabled={checkIsWheelNotEmpty()}
                                    onClick={handlePrint} >PRINT UT/LAST NED</button>

                            </div>
                            <div className="col-3">
                                <button
                                    disabled={checkIsWheelFilled()}
                                    onClick={() => {
                                        totalGetting()
                                        setReqType('pending')
                                        setShowModalReqBooking2(true)
                                    }} className="btnOrder w-100">  {"Forhåndsvis".toUpperCase()}</button>

                            </div>
                            <div className="col-4">
                                <button
                                    disabled={checkIsWheelFilled()}
                                    onClick={() => {
                                        totalGetting()
                                        setReqType('pending')
                                        setClickBookingRequest(true);
                                        setShowModalReqBooking(true);
                                    }} className="btnOrder w-100">FORESPØR BOOKING</button>

                            </div>
                        </div>
                    </>
                }

            </div>
        </div>


        {action && ((action === 'add1' || action === 'add2') || (action == "rec2" || action == "rec1")) &&
            ///2nd part Calender
            <div className="col-lg-6">
                <div>
                    {<h3 className="text-center fw-bold">VELG AKTIVITETER ({activitiesCount})</h3>}
                    <div className="">
                        <form className="d-flex">
                            <div className="activity_main  align-items-center flex-center search-menu">
                                <ul className="activity_ul d-flex ">
                                    <li className="activity_li" >
                                        <div style={{ cursor: "pointer", paddingRight: '10px' }} onClick={() => setShowCalender(!showCalender)} className="dropdownCal Theme_select" >
                                            <span>{selectedDate ? dayjs(selectedDate).format('YY/M/D') : "Dato"}</span>
                                            <i class="ri-arrow-down-s-line"></i>
                                        </div>
                                        {showCalender && <div className='dropdown-contentCal' >
                                            <CalenderComponent setSelectedDate={setSelectedDate} selectedDate={selectedDate} setShowCalender={setShowCalender} />
                                        </div>}
                                    </li>
                                    {/*    <li className="activity_li" >*/}
                                    {/*    <Select*/}
                                    {/*        options={filters.types}*/}
                                    {/*        defaultText="Acitivity Type"*/}
                                    {/*        value={type}*/}
                                    {/*        setValue={setType}*/}
                                    {/*    />*/}
                                    {/*</li>*/}
                                    <li className="activity_li" >
                                        <Select
                                            value={city}
                                            setValue={setCity}
                                            options={filters.cities2}
                                            defaultText="Cities"
                                            disabled={type === "digital"}
                                        />
                                    </li>
                                    <li className="activity_li" >
                                        <Select
                                            value={budget}
                                            setValue={setBudget}
                                            options={filters.budgetOptions2}
                                            defaultText="Budget Options"
                                        />
                                    </li>
                                    <li className="activity_li" >
                                        <Select
                                            setValue={setPeopleNumber}
                                            value={peopleNumber}
                                            options={filters.peopleNumber2}
                                            defaultText="Number of people"
                                        />
                                    </li>
                                </ul>
                                <div className=" btnSearchIcon search_icon_otr_local">
                                    <button
                                        className=" text-white ri-search-2-line search_icon_local search-button"
                                        type="submit"
                                    ></button>
                                </div>


                                <div class="btnSearchIcon search_icon_otr_local">
                                    <button class="text-white refresh-icon search-button"
                                        onClick={(event) => { handleReset(event); handleReset(event); }}                                                ></button>
                                </div>
                            </div>
                        </form>
                        {/* todo: hide it for now */}
                        {false && (
                            <div className="filter_otr">
                                <Select defaultText="Flere filtere" />
                            </div>
                        )}
                    </div>
                    {activities && activities.length > 0 && <div className="row row_custom left-section-wheel">
                        {activities?.slice(0, visible).slice(-8).map((activity) => (
                            <OrderPlanSearchResultCard

                                isVelgDisable={((one === true && widget.length < 1) || (two === true && widget.length < 2) || (four === true && widget.length < 4) || (six === true && widget.length < 6) || (twelve === true && widget.length < 12))}
                                clickFire={(e) => handleVelgClick(e, activity)}
                                handleDrag={(e) => handleDrag(e, activity)}
                                CardImg={
                                    activity.images
                                        ? JSON.parse(activity.images)?.[0].imageURL
                                        : 'bookingImg'
                                }
                                CardRabat={activity.discountPercent}
                                CardHeading={activity.name}
                                CardDesc={
                                    activity.price > 0 ?
                                        activity.price +
                                        (activity.priceModel === "time" ? "kr per time" : activity.priceModel === "person"
                                            ? "kr per person"
                                            : "kr per aktivitet") : "Gratis"
                                }
                                Data={activity}
                                source="customer"
                                peopleNumber={peopleNumber}
                                city={city}
                                activityType={type}
                                price={budget}
                            />

                        ))}
                        {totalPages && totalPages > 1 && (
                            <div className="Theme_btn_primary custom-btn">
                                {"Side"} {pageNumber} av {totalPages}
                                <div class="funtlers-cards-container2 ">
                                    <div
                                        className={`swiper-button-prev d-sm-flex d-none ${pageNumber === 1 ? 'disabled' : ''}`}
                                        tabIndex="0"
                                        role="button"
                                        aria-label="Previous slide"
                                        onClick={pageNumber === 1 ? null : showLessItems}
                                    ></div>
                                    <div className={`swiper-button-next d-sm-flex d-none ${pageNumber === totalPages ? 'disabled' : ''}`}
                                        tabindex="-1" role="button" aria-label="Next slide" onClick={showMoreItems}></div>
                                </div>
                            </div>
                        )}

                    </div>}

                    {activities && activities.length == 0 && <div className="row row_custom left-section-wheel"><div class="d-flex justify-content-center">
                        <p class="ins">
                            <p className="ins" style={{ backgroundColor: "transparent" }}>


                                Vi hjelper dere gjerne med rabatter og booking. Ettersom dere ønsker noe spesifikt som per nå ikke dukker opp i verktøyet, ber vi deg ta kontakt med oss på <a href="mailto:contact@funtlers.com">contact@funtlers.com</a> slik at vi kan skreddersy en kjekk opplevelse for dere.

                            </p>

                        </p>
                    </div></div>}
                </div>
            </div>
        }
        {/*Single Circle for Edit */}
        <div className='row' >
            {action && action === 'edit1' && circleData.length > 0 && circleData.reverse().filter((val) => val.circleName.toLowerCase().includes(searchQuery.toLowerCase())).filter((val) => val.circleType === "single").map((val, i) =>
            //Circle
            (<div className='col-lg-6 my-2'>

                <div id="pdfDivMain-root" className='d-flex align-items-center' >
                    <div id="pdfDivMain" className='w-100 '>
                        <div className="nameDiv">
                            <h4>{val.circleName}</h4>
                        </div>

                        <div ref={pdfRef} onDrop={handleOnDrop} onDragOver={handleDragOver} id="pdfContent" className="containerCircle ">
                            <div onDrop={handleOnDrop} onDragOver={handleDragOver} className="iconCircle">
                                <div class="imgBx" style={{ width: "210px", height: "210px" }} >
                                    <img src={val.imageURL.replace("{baseApiURL}", "https://funtlers.com/")} />
                                </div>
                            </div>
                        </div>

                        <strong>SKAPT: {val.createdDate !== undefined && val.createdDate !== null && matchActFilter(val.createdDate)}</strong>
                    </div>
                </div>
                <div className="row d-flex align-items-center justify-content-center w-100 my-3">
                    <div className="col-6 my-2">
                        <button onClick={() => navigate('/orderplan/add1', { state: { cirId: val.circleId } })} className="btnOrder w-100">REDIGERE</button>

                    </div>
                    <div className="col-6 my-2">
                        <button onClick={() => handleDeleteCircle(val.circleId)} className="btnOrder w-100">SLETTE</button>

                    </div>
                    <div className="col-6 my-2">
                        <button className="btnOrder w-100" disabled={checkIsWheelNotEmpty()}
                            onClick={handlePrint} >PRINT UT/LAST NED</button>

                    </div>

                    <div className="col-6 my-2">
                        <button
                            disabled={checkIsWheelFilled()}
                            onClick={() => {
                                totalGetting()
                                setReqType('pending')
                                setShowModalReqBooking2(true)
                            }} className="btnOrder w-100">  {"Forhåndsvis".toUpperCase()}</button>

                    </div>
                    <div className="col-6 my-2">
                        <button
                            disabled={checkIsWheelFilled()}
                            onClick={() => {
                                totalGetting()
                                setReqType('pending')
                                setClickBookingRequest(true);
                                setShowModalReqBooking(true)
                            }} className="btnOrder w-100">FORESPØR BOOKING</button>

                    </div>

                </div>

            </div>
            ))
            }
        </div>
        {/*Multiple Circle for Edit */}
        {searchQuery === "" && action && action === 'edit2' && circleData.length > 0 && circleData.reverse().filter((val) => val.circleType === "multiple").map((val, i) =>
        //Circle
        {

            count++
            if (circleIdArr === 0) {
                circlesArr = []
                circlesArr = circlesArr2;
                circlesArr2 = []
                circleIdArr = val.circleId

            }
            if (circleIdArr === val.circleId) {
                circlesArr.push(val)
                var length = circleData.length
                if (count === length) {
                    return (
                        <div className='col-lg-6 my-2' key={circleData[i - 1]['cicleId']}>
                            <div id="pdfDivMain-root" className='d-flex align-items-center' >
                                <div id="pdfDivMain" className='w-100 '>
                                    <div className="nameDiv">
                                        <h4>{circleData[i - 1]['circleName']}</h4>
                                    </div>

                                    <div ref={pdfRef} onDrop={handleOnDrop} onDragOver={handleDragOver} id="pdfContent" className="containerCircle my-5"  >
                                        <div onDrop={handleOnDrop} onDragOver={handleDragOver} className="iconCircle">
                                            {circlesArr.map((data, k) => <div className="imgBx" style={{
                                                width: (circlesArr.length === 2 && "150px") || (circlesArr.length === 4 && "90px") || (circlesArr.length === 6 && "90px") || (circlesArr.length === 12 && "70px"),
                                                height: (circlesArr.length === 2 && "150px") || (circlesArr.length === 4 && "90px") || (circlesArr.length === 6 && "90px") || (circlesArr.length === 12 && "70px"),
                                                transformOrigin: circlesArr.length === 2 ? "260px" : "235px",
                                                transform: `rotate(calc(360deg /${(circlesArr.length <= 2 && 2) || (circlesArr.length === 4 && 4) || (circlesArr.length === 6 && 6) || (circlesArr.length === 12 && 12)}* ${k}))`
                                            }}>
                                                <img style={{
                                                    transform: `rotate(calc(-360deg /${(circlesArr.length <= 2 && 2) || (circlesArr.length === 4 && 4) || (circlesArr.length === 6 && 6) || (circlesArr.length === 12 && 12)}* ${k}))`
                                                }} src={data.imageURL.replace("{baseApiURL}", "https://funtlers.com/")} />
                                            </div>)}

                                        </div>
                                    </div>
                                    <strong>SKAPT: {val.createdDate !== undefined && val.createdDate !== null && matchActFilter(circleData[i - 1]['createdDate'])}</strong>

                                </div>
                            </div>
                            <div className="row d-flex align-items-center justify-content-center w-100 my-3">
                                <div className="col-6 my-2">
                                    <button onClick={() => navigate('/orderplan/add2', { state: { cirId: circleData[i - 1]['circleId'] } })} className="btnOrder w-100">REDIGERE</button>

                                </div>
                                <div className="col-6 my-2">
                                    <button className="btnOrder w-100" onClick={() => handleDeleteCircle(circleData[i - 1]['circleId'])} >SLETTE</button>

                                </div>
                                <div className="col-6 my-2">
                                    <button className="btnOrder w-100" disabled={checkIsWheelNotEmpty()}
                                        onClick={handlePrint} >PRINT UT/LAST NED</button>

                                </div>
                                <div className="col-6 my-2">
                                    <button
                                        disabled={checkIsWheelFilled()}
                                        onClick={() => {
                                            totalGetting()
                                            setReqType('pending')
                                            setShowModalReqBooking2(true)
                                        }} className="btnOrder w-100">  {"Forhåndsvis".toUpperCase()}</button>

                                </div>
                                <div className="col-6 my-2">
                                    <button
                                        disabled={checkIsWheelFilled()}
                                        onClick={() => {
                                            totalGetting()
                                            setReqType('pending')
                                            setClickBookingRequest(true);
                                            setShowModalReqBooking(true)
                                        }} className="btnOrder w-100">FORESPØR BOOKING</button>

                                </div>
                            </div>

                        </div>
                    )

                }
            }
            else {
                circlesArr2.push(val)
                circleIdArr = 0
                return (<div className='col-lg-6 my-2' key={circleData[i - 1]['cicleId']} >

                    <div id="pdfDivMain-root" className='d-flex align-items-center' >
                        <div id="pdfDivMain" className='w-100 '>
                            <div className="nameDiv">
                                <h4>{circleData[i - 1]['circleName']}</h4>
                            </div>

                            <div ref={pdfRef} onDrop={handleOnDrop} onDragOver={handleDragOver} id="pdfContent" className="containerCircle my-5">
                                <div onDrop={handleOnDrop} onDragOver={handleDragOver} className="iconCircle">
                                    {circlesArr.map((data, k) => <div className="imgBx" style={{
                                        width: (circlesArr.length === 2 && "150px") || (circlesArr.length === 4 && "90px") || (circlesArr.length === 6 && "90px") || (circlesArr.length === 12 && "70px"),
                                        height: (circlesArr.length === 2 && "150px") || (circlesArr.length === 4 && "90px") || (circlesArr.length === 6 && "90px") || (circlesArr.length === 12 && "70px"),
                                        transformOrigin: circlesArr.length === 2 ? "260px" : "235px",
                                        transform: `rotate(calc(360deg /${(circlesArr.length <= 2 && 2) || (circlesArr.length === 4 && 4) || (circlesArr.length === 6 && 6) || (circlesArr.length === 12 && 12)}* ${k}))`
                                    }}>
                                        <img style={{
                                            transform: `rotate(calc(-360deg /${(circlesArr.length <= 2 && 2) || (circlesArr.length === 4 && 4) || (circlesArr.length === 6 && 6) || (circlesArr.length === 12 && 12)}* ${k}))`
                                        }} src={data.imageURL.replace("{baseApiURL}", "https://funtlers.com/")} />
                                    </div>)}

                                </div>
                            </div>
                            <strong>SKAPT: {val.createdDate !== undefined && val.createdDate !== null && matchActFilter(circleData[i - 1]['createdDate'])}</strong>

                        </div>
                    </div>
                    <div className="row d-flex align-items-center justify-content-center w-100 my-3">
                        <div className="col-6 my-2">
                            <button onClick={() => navigate('/orderplan/add2', { state: { cirId: circleData[i - 1]['circleId'] } })} className="btnOrder w-100">REDIGERE</button>

                        </div>
                        <div className="col-6 my-2">
                            <button className="btnOrder w-100" onClick={() => handleDeleteCircle(circleData[i - 1]['circleId'])} >SLETTE</button>

                        </div>
                        <div className="col-6 my-2">
                            <button className="btnOrder w-100" disabled={checkIsWheelNotEmpty()}
                                onClick={handlePrint} >PRINT UT/LAST NED</button>

                        </div>
                        <div className="col-6 my-2">
                            <button
                                disabled={checkIsWheelFilled()}
                                onClick={() => {
                                    totalGetting()
                                    setReqType('pending')
                                    setShowModalReqBooking2(true)
                                }} className="btnOrder w-100">  {"Forhåndsvis".toUpperCase()}</button>

                        </div>
                        <div className="col-6 my-2">
                            <button
                                disabled={checkIsWheelFilled()}
                                onClick={() => {
                                    totalGetting()
                                    setReqType('pending')
                                    setClickBookingRequest(true);
                                    setShowModalReqBooking(true)
                                }} className="btnOrder w-100">FORESPØR BOOKING</button>

                        </div>
                    </div>

                </div>
                )
            }

        })
        }

        {/*Search Multiple Circle for Edit */}

        {searchQuery !== "" && action && action === 'edit2' && queryData.reverse().filter((val) => val.circleType === "multiple").map((val, i) =>
        //Circle
        {

            count++
            if (circleIdArr === 0) {
                circlesArr = []
                circlesArr = circlesArr2;
                circlesArr2 = []
                circleIdArr = val.circleId

            }
            if (circleIdArr === val.circleId) {
                circlesArr.push(val)
                var length = queryData.length
                if (count === length) {
                    return (
                        <div className='col-lg-6 my-2' key={queryData[i - 1]['cicleId']}>
                            <div id="pdfDivMain-root" className='d-flex align-items-center' >
                                <div id="pdfDivMain" className='w-100 '>
                                    <div className="nameDiv">
                                        <h4>{queryData[i - 1]['circleName']}</h4>
                                    </div>

                                    <div ref={pdfRef} onDrop={handleOnDrop} onDragOver={handleDragOver} id="pdfContent" className="containerCircle my-5"  >
                                        <div onDrop={handleOnDrop} onDragOver={handleDragOver} className="iconCircle">
                                            {circlesArr.map((data, k) => <div className="imgBx" style={{
                                                width: (circlesArr.length === 2 && "150px") || (circlesArr.length === 4 && "90px") || (circlesArr.length === 6 && "90px") || (circlesArr.length === 12 && "70px"),
                                                height: (circlesArr.length === 2 && "150px") || (circlesArr.length === 4 && "90px") || (circlesArr.length === 6 && "90px") || (circlesArr.length === 12 && "70px"),
                                                transformOrigin: circlesArr.length === 2 ? "260px" : "235px",
                                                transform: `rotate(calc(360deg /${(circlesArr.length <= 2 && 2) || (circlesArr.length === 4 && 4) || (circlesArr.length === 6 && 6) || (circlesArr.length === 12 && 12)}* ${k}))`
                                            }}>
                                                <img style={{
                                                    transform: `rotate(calc(-360deg /${(circlesArr.length <= 2 && 2) || (circlesArr.length === 4 && 4) || (circlesArr.length === 6 && 6) || (circlesArr.length === 12 && 12)}* ${k}))`
                                                }} src={data.imageURL.replace("{baseApiURL}", "https://funtlers.com/")} />
                                            </div>)}

                                        </div>
                                    </div>

                                    <strong>SKAPT: {val.createdDate !== undefined && val.createdDate !== null && matchActFilter(queryData[i - 1]['createdDate'])}</strong>

                                </div>
                            </div>
                            <div className="row w-100 my-3">
                                <div className="col-6 my-2">
                                    <button onClick={() => navigate('/orderplan/add2', { state: { cirId: queryData[i - 1]['circleId'] } })} className="btnOrder w-100">REDIGERE</button>

                                </div>
                                <div className="col-6 my-2">
                                    <button className="btnOrder w-100" onClick={() => handleDeleteCircle(queryData[i - 1]['circleId'])} >SLETTE</button>

                                </div>
                                <div className="col-6 my-2">
                                    <button className="btnOrder w-100" disabled={checkIsWheelNotEmpty()}
                                        onClick={handlePrint} >PRINT UT/LAST NED</button>

                                </div>
                                <div className="col-6 my-2">
                                    <button
                                        disabled={checkIsWheelFilled()}
                                        onClick={() => {
                                            totalGetting()
                                            setReqType('pending')
                                            setShowModalReqBooking2(true)
                                        }} className="btnOrder w-100">  {"Forhåndsvis".toUpperCase()}</button>

                                </div>
                                <div className="col-6 my-2">
                                    <button
                                        disabled={checkIsWheelFilled()}
                                        onClick={() => {
                                            totalGetting()
                                            setReqType('pening')
                                            setClickBookingRequest(true);
                                            setShowModalReqBooking(true)
                                        }} className="btnOrder w-100">FORESPØR BOOKING</button>

                                </div>
                            </div>

                        </div>
                    )

                }
            }
            else {
                circlesArr2.push(val)
                circleIdArr = 0
                return (<div className='col-lg-6 my-2' key={queryData[i - 1]['cicleId']} >

                    <div id="pdfDivMain-root" className='d-flex align-items-center' >
                        <div id="pdfDivMain" className='w-100 '>
                            <div className="nameDiv">
                                <h4>{queryData[i - 1]['circleName']}</h4>
                            </div>

                            <div ref={pdfRef} onDrop={handleOnDrop} onDragOver={handleDragOver} id="pdfContent" className="containerCircle my-5"  >
                                <div onDrop={handleOnDrop} onDragOver={handleDragOver} className="iconCircle">
                                    {circlesArr.map((data, k) => <div className="imgBx" style={{
                                        width: (circlesArr.length === 2 && "150px") || (circlesArr.length === 4 && "90px") || (circlesArr.length === 6 && "90px") || (circlesArr.length === 12 && "70px"),
                                        height: (circlesArr.length === 2 && "150px") || (circlesArr.length === 4 && "90px") || (circlesArr.length === 6 && "90px") || (circlesArr.length === 12 && "70px"),
                                        transformOrigin: circlesArr.length === 2 ? "260px" : "235px",
                                        transform: `rotate(calc(360deg /${(circlesArr.length <= 2 && 2) || (circlesArr.length === 4 && 4) || (circlesArr.length === 6 && 6) || (circlesArr.length === 12 && 12)}* ${k}))`
                                    }}>
                                        <img style={{
                                            transform: `rotate(calc(-360deg /${(circlesArr.length <= 2 && 2) || (circlesArr.length === 4 && 4) || (circlesArr.length === 6 && 6) || (circlesArr.length === 12 && 12)}* ${k}))`
                                        }} src={data.imageURL.replace("{baseApiURL}", "https://funtlers.com/")} />
                                    </div>)}
                                </div>
                            </div>
                            <strong>SKAPT: {val.createdDate !== undefined && val.createdDate !== null && matchActFilter(queryData[i - 1]['createdDate'])}</strong>

                        </div>
                    </div>
                    <div className="row w-100 my-3">
                        <div className="col-6 my-2">
                            <button onClick={() => navigate('/orderplan/add2', { state: { cirId: queryData[i - 1]['circleId'] } })} className="btnOrder w-100">REDIGERE</button>

                        </div>
                        <div className="col-6 my-2">
                            <button className="btnOrder w-100" onClick={() => handleDeleteCircle(queryData[i - 1]['circleId'])} >SLETTE</button>

                        </div>
                        <div className="col-6 my-2">
                            <button className="btnOrder w-100" disabled={checkIsWheelNotEmpty()}
                                onClick={handlePrint} >PRINT UT/LAST NED</button>

                        </div>
                        <div className="col-6 my-2">
                            <button
                                disabled={checkIsWheelFilled()}
                                onClick={() => {
                                    totalGetting()
                                    setReqType('pending')
                                    setShowModalReqBooking2(true)
                                }} className="btnOrder w-100">  {"Forhåndsvis".toUpperCase()}</button>

                        </div>
                        <div className="col-6 my-2">
                            <button
                                disabled={checkIsWheelFilled()}
                                onClick={() => {
                                    totalGetting()
                                    setReqType('pending')
                                    setClickBookingRequest(true);
                                    setShowModalReqBooking(true)
                                }} className="btnOrder w-100">FORESPØR BOOKING</button>

                        </div>
                    </div>


                </div>
                )
            }

        })
        }
                </div>
            </>
        );
    }

    return (
        <LoadingOverlay
            active={isLoading}
            spinner
            text="Behandler forespørselen din"
        >

            {bodypart &&
             <div className="body-part admin_landingpage2">
               
                {renderTitle()}
                <div>
                { renderPage() }

                {renderActionButton()}



              




                    {/*<pre>{JSON.stringify(widget, null, 2)}</pre>*/}

                </div>
            </div>}
            {modalpart &&
                <div className="modal-part">

                {addSingleCustomModal && <CreateActivityModal
                        show={addSingleCustomModal}
                        onClose={() => setAddSingleCustomModal(false)}
                        onSave={(data) => handleBookingEditSave(data)}
                        EditMode={EditData?.Mode }
                />}

                <Modal backdrop="static" // Prevent closing when clicking outside
                    keyboard={false}   // Prevent closing when pressing ESC   
                    shouldCloseOnOverlayClick={false} // Disable click outside
                    centered show={showModalRmv > -1} onHide={() => setShowModalRmv(-1)}>
                    <Modal.Header >
                        <Modal.Title> FJERN AKTIVITETER
                        </Modal.Title>

                    </Modal.Header>
                    <Modal.Body>
                        <h6>Det er for mange aktiviteter i kalenderen. Vennligst fjern {showModalRmv} aktiviteter for å fortsette</h6>
                        <br />

                        <div class="row row_custom left-section-wheel2">
                            {widget?.map((activity) => (
                                <OrderPlanSearchResultCardRemove

                                    isDelete={showModalRmv > 0}
                                    Delete={(e) => handleActivityDelClick(activity.id)}
                                    CardImg={
                                        activity.images
                                            ? JSON.parse(activity.images)?.[0].imageURL
                                            : 'bookingImg'
                                    }
                                    CardRabat={activity.discountPercent}
                                    CardHeading={activity.name}
                                    CardDesc={
                                        activity.price > 0 ?
                                            activity.price +
                                            (activity.priceModel === "time" ? "kr per time" : activity.priceModel === "person"
                                                ? "kr per person"
                                                : "kr per aktivitet") : "Gratis"
                                    }
                                    Data={activity}
                                    source="customer"
                                    peopleNumber={peopleNumber}
                                    city={city}
                                    activityType={type}
                                    price={budget}
                                />

                            ))}
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className='d-flex justify-content-center' >
                            <button
                                onClick={() => {
                                    setShowModalRmv(-1)
                                }
                                } className={`btnOrder w-100 ${showModalRmv > 0 ? 'disabled' : ''}`}>JUSTER
                            </button>
                        </div>

                    </Modal.Footer>
                </Modal>

                 
                <Modal shouldCloseOnOverlayClick={false} // Disable click outside
                    centered show={showModalVELG} onHide={() => setShowModalVELG(false)}>
                    <Modal.Header closeButton>
                        <Modal.Title> AKTIVITETSDETALJER
                        </Modal.Title>

                    </Modal.Header>
                    <Modal.Body class="flex">
                        <div class="col_searchCard_inr left-section-crd">
                            <div class="position-relative img_otr ">
                                <img
                                    class="card_imgS card_imgS-modal"
                                    src={
                                        showModalVELG.images
                                            ? JSON.parse(showModalVELG.images)?.[0]?.imageURL?.replace("{baseApiURL}", "https://funtlers.com/")
                                            : showModalVELG.imageURL
                                                ? showModalVELG.imageURL.replace("{baseApiURL}", "https://funtlers.com/")
                                                : "https://funtlers.com/bookingImg"
                                    }
                                    alt="img"
                                />
                            </div>


                            <p class="heading-lb card_heading card_heading-model" >{showModalVELG.name}</p>

                        </div>
                        <div class="col_searchCard_inr right-section-crd">
                            <div class="d-flex flex-row justify-content-between p-3 mid">
                                <div class="d-flex flex-column align-left">
                                    <medium class="text-muted mt-1">
                                        <b>Antall personer:</b>
                                    </medium>
                                    <div class="d-flex flex-row">
                                        <div class="d-flex flex-column ml-1">
                                            <large class="ghj">{totalPersons}</large>
                                        </div>
                                    </div>
                                    <medium class="text-muted mt-1">
                                        <b>Pris per person:</b>
                                    </medium>
                                    <div class="d-flex flex-row">
                                        <div class="d-flex flex-column ml-1">
                                            <large class="ghj">{showModalVELG.price} NOK</large>
                                        </div>
                                    </div>
                                </div>
                                <div class="d-flex flex-column">
                                    <medium class="text-muted mt-2">
                                        <b>Total aktivitetspris:</b>
                                    </medium>
                                    <div class="d-flex flex-column">
                                        <div class="d-flex flex-column ml-1">
                                            <large class="ghj">{showModalVELG.price * (totalPersons)} NOK </large>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='my-f mt-3' >
                                <div style={{ padding: '10px', width: '78px' }}><strong>Dato</strong></div>

                                <div style={{ cursor: "pointer", paddingRight: '10px', width: '100%' }} onClick={() => setShowCalenderVELG(!showCalenderVELG)} className="dropdownCal Theme_select" >
                                    <span>{selectedDateVELG ? dayjs(selectedDateVELG).format('YY/M/D') : "Velg dato"}</span>
                                    <i class="ri-arrow-down-s-line"></i>
                                </div>
                                {showCalenderVELG && <div className='dropdown-contentCal' >
                                    <CalenderComponent setSelectedDate={setSelectedDateVELG} selectedDate={selectedDateVELG} setShowCalender={setShowCalenderVELG} />
                                </div>}


                            </div>
                            <div className="VELG-sec" style={{ alignItems: "center" }}>
                                <TimeRangeSelector
                                    labelFrom="TID"
                                    labelTo="TIL"
                                    fromTime={fromTime}
                                    toTime={toTime}
                                    setFromTime={setFromTime}
                                    setToTime={setToTime}
                                />
                            </div>
                            <div className="VELG-sec" style={{ display: 'inline-flex', alignItems: 'center' }}>
                                <div style={{ padding: '10px' }}><strong>Antall</strong></div>
                                <div class="text input-block">
                                    <div class="input-group">
                                        <button class="btn" type="button" onClick={() =>
                                            totalPersons > showModalVELG.minPerson
                                                ? setTotalPersons(totalPersons - 1)
                                                : setTotalPersons(totalPersons)
                                        }>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="2" viewBox="0 0 24 2">
                                                <g fill="#fff" stroke="#707070" stroke-width="1" opacity="0.45">
                                                    <rect width="24" height="2" stroke="none"></rect>
                                                    <rect x="0.5" y="0.5" width="23" height="1" fill="none"></rect>
                                                </g>
                                            </svg>
                                        </button>
                                        <input
                                            type="text"
                                            className="form-control bg-transparent"
                                            aria-describedby="button-addon"
                                            value={totalPersons}
                                            inputMode="numeric"
                                            pattern="[0-9]*"
                                            onChange={e => {
                                                const val = e.target.value;

                                                // Allow empty input to reset to 1
                                                if (val === "") {
                                                    setTotalPersons(""); // Reset to 1 when cleared
                                                } else if (/^[1-9]\d*$/.test(val)) { // Only allow positive integers
                                                    setTotalPersons(Number(val)); // Store as a number
                                                }
                                            }}
                                            onBlur={e => {
                                                const val = e.target.value;
                                                // Default to 1 if empty or 0
                                                if (val === "" || val === "0") {
                                                    setTotalPersons(1);
                                                }
                                            }}
                                            onKeyDown={e => {
                                                if (e.key === '-') {
                                                    e.preventDefault(); // Block minus sign when typing
                                                }
                                                if (["e", "E", "+", "-", "."].includes(e.key)) {
                                                    e.preventDefault(); // Block invalid keys
                                                }
                                                if (e.key === "ArrowUp") {
                                                    setTotalPersons(prev => {
                                                        const current = Number(prev || 1); // Start from 1 if prev is empty
                                                        return current + 1; // Increment by 1
                                                    });
                                                    e.preventDefault();
                                                }
                                                if (e.key === "ArrowDown") {
                                                    setTotalPersons(prev => {
                                                        const current = Number(prev || 1); // Start from 1 if prev is empty
                                                        return current > 1 ? current - 1 : 1; // Prevent going below 1
                                                    });
                                                    e.preventDefault();
                                                }
                                            }}

                                            onPaste={(e) => {
                                                const pastedText = e.clipboardData.getData('Text');
                                                if (pastedText.includes('-')) {
                                                    e.preventDefault(); // Block pasting minus sign
                                                }
                                            }}
                                            />

                                        {/*done*/}

                                        <button class="btn" type="button" onClick={() =>
                                            totalPersons >= showModalVELG.minPerson
                                                ? setTotalPersons(totalPersons + 1)
                                                : setTotalPersons(totalPersons)
                                        }>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17">
                                                <g transform="translate(-1475.5 -614.077)">
                                                    <rect width="17" height="2" transform="translate(1475.5 621.077)" fill="#707070" opacity="0.45"></rect>
                                                    <rect width="17" height="2" transform="translate(1485.5 614.077) rotate(90)" fill="#707070" opacity="0.45"></rect>
                                                </g>
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                            </div>

                                {isEditMode && (EditData?.Mode === "isEditAdminRequest" || EditData?.Mode === "isEditBooking") && EditData?.Action !== "EditPending"
                                    && (<div className="d-flex flex-column my-f mt-3 p-2">
                                        <label className=" mt-2">
                                            <strong>Brukerkommentarer:</strong>
                                        </label>

                                        <div className="d-flex flex-column ml-1">
                                            <textarea
                                                className="form-control"
                                                rows={3}
                                                value={comments}
                                                onChange={(e) => {
                                                    setComments(e.target.value || "");

                                                }}
                                                placeholder="Skriv en kommentar eller årsak her..."
                                            />
                                        </div>
                                    </div>)}
                        </div>


                    </Modal.Body>
                    <Modal.Footer>
                        <div className='d-flex justify-content-center' >
                            <button
                                    onClick={() => {
                                        debugger;
                                    showModalVELG.isVelgClick = true;
                                    showModalVELG.totPersons = totalPersons - showModalVELG.minPerson;
                                    showModalVELG.addDate = selectedDateVELG;
                                    showModalVELG.fromTime = fromTime;
                                    showModalVELG.toTime = toTime;
                                    showModalVELG.reason = comments;
                                    if (
                                        comments
                                    ) {
                                        setComments(null);
                                    }


                                    setShowModalVELG(false);
                                    activities.map((obj) => {
                                        if (obj.id == showModalVELG.id) {
                                            obj.isVelgClick = true;
                                            obj.totPersons = totalPersons - showModalVELG.minPerson;
                                            obj.addDate = selectedDateVELG;
                                            obj.fromTime = showModalVELG.fromTime;
                                            obj.toTime = showModalVELG.toTime;
                                        }
                                    });



                                    widget.map((obj) => {
                                        if (obj.id == showModalVELG.id) {
                                            obj.isVelgClick = true;
                                            obj.totPersons = totalPersons - showModalVELG.minPerson;
                                            obj.addDate = selectedDateVELG;
                                            obj.fromTime = showModalVELG.fromTime;
                                            obj.toTime = showModalVELG.toTime;

                                        }
                                    });
                                    setWidget([...widget]);

                                    setActivities(activities);
                                    simulateDragging(showModalVELG);
                                    setSelectedDateVELG(null);
                                    setFromTime(null);
                                    setToTime(null);
                                    updateData();


                                }
                                } className={`btnOrder w-100 ${!(selectedDateVELG && fromTime && toTime && totalPersons) ? 'disabled' : ''}`}>INKLUDER
                            </button>
                        </div>

                    </Modal.Footer>
                </Modal>


                <Modal contentClassName="add_partner_main data-grid"
                    shouldCloseOnOverlayClick={false} // Disable click outside
                    centered show={showModalCircle} onHide={handleCloseModal} >
                    <Modal.Header closeButton>
                        <Modal.Title>
                                ØNSKER DU Å LAGRE?
                        </Modal.Title>

                    </Modal.Header>
                    <Modal.Body>
                        <div className='my-4' >
                                <strong >Velg et navn :</strong>
                            <input className="form-control mt-2" value={circleName} onChange={(e) => setCircleName(e.target.value)} />
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className='d-flex justify-content-center' >
                            {updateState === -1 ? <button
                                className={`${!(circleName) ? 'disabled' : ''}`}
                                    disabled={!circleName} onClick={() => {
                                        setClickBookingRequest(true);
                                        setShowModalCircle(false);

                                        
                                    reqType === "pending" ? handleCircle("pending") :
                                        handleCircle("saved")

                                    handleBusinessSavedRequest();
                                }
                                } className="btnOrder w-100">
                                {reqType === "pending" ? "FORESPØR BOOKING" : "LAGRE"}
                            </button> :
                                    <button onClick={() => {
                                        
                                       setShowModalCircle(false);
                                    handleCircleUpdate();
                                    handleBusinessSavedRequest();
                                }} className="btnOrder w-100">REDIGERE</button>}
                        </div>

                    </Modal.Footer>
                </Modal>

                <Modal shouldCloseOnOverlayClick={false} // Disable click outside
                    size="lg" backdropClassName="backdrop"
                    contentClassName="add_partner_main data-grid"
                    dialogClassName="custom-min-width-modal" // Option 1: CSS class
                    centered show={showModalReqBooking2} onHide={() => {
                        setTotalPrice(0)
                        setShowModalReqBooking2(false)

                    }

                    }

                >
                    <Modal.Header closeButton>
                        <Modal.Title>
                            <b>Forhåndvisning av aktivitetsdetaljer & priser</b>
                        </Modal.Title>

                    </Modal.Header>
                    <Modal.Body>
                        <div className="row sub-category-container-recommend2 d-flex justify-content-center align-items-end" >
                            {
                                widget.map((val, index) => (

                                    <div className="my-3 col-md-6 d-flex" key={index}>
                                        <div>
                                            <img style={{
                                                width: '113px',
                                                height: '101px',
                                                marginRight: '13px'
                                            }}
                                                src={val.images && (val.images
                                                    ? JSON.parse(val.images)?.[0].imageURL
                                                    : 'bookingImg').replace("{baseApiURL}", "https://funtlers.com/") || val.imageURL && (val.imageURL.replace("{baseApiURL}", "https://funtlers.com/"))} alt="Pic" />
                                        </div>
                                        <div className="searchResultContent">
                                            <small><b>{val.name?.slice(0, 28)}{val.name?.length > 28 ? '...' : ''}</b></small>
                                            <small><b>DATO:</b> {DateFormat(val.addDate)}</small>
                                            <small>  <b>TID</b>: {val?.fromTime ? val.fromTime : "N/A"} - {val?.toTime ? val.toTime : "N/A"}</small>
                                            <small><b>Antall personer:</b> {val.minPerson + val.totPersons}</small>
                                            <small><b>Pris per person:</b> {val.price || 0} NOK</small>
                                            <small><b>Total pris aktivitet:</b> {val.price * (val.minPerson + val.totPersons) || 0} NOK</small>
                                        </div>
                                    </div>
                                ))
                            }
                            <hr />
                            {/*<h3 className="mx-4 text-center fw-bold" >SUMMERT ALLE AKTIVITETER</h3>*/}
                            {
                                //widget.map((val, i) =>
                                //    <div className=" my-3 col-md-6" >
                                //        <div className='searchResultContent' >
                                //            <small>Aktivitet {i + 1}: {val.price * (val.minPerson + val.totPersons)}</small>

                                //        </div>
                                //    </div>
                                //)
                            }
                            {/*<hr />*/}
                            <h5 className="mb-4"><b>Total kostnad:</b> {totalPrice || 0} NOK</h5><br />
                        </div>

                        {/*<p className="text-center my-3" >*/}
                        {/*    Ved å klikke på knappen under, vil teamet til Funtlers motta en kopi av den forespurte bestillingen din. Merk at bestillingen ikke er godkjent før du får en bestillingsbekreftelse på din e-post.*/}
                        {/*</p>*/}
                    </Modal.Body>
                    <Modal.Footer>
                        <div className='d-flex justify-content-center' >
                            <button onClick={() => {

                                setShowModalReqBooking2(false)
                            }}
                                className="btnOrder w-100">LUKK</button>
                        </div>

                    </Modal.Footer>
                </Modal>


                <Modal shouldCloseOnOverlayClick={false} // Disable click outside
                    size="lg" centered show={showModalReqBooking}
                    contentClassName="add_partner_main data-grid"
                    backdropClassName="backdrop"
                    dialogClassName="custom-min-width-modal" // Option 1: CSS class
                    onHide={() => {
                        setTotalPrice(0)
                        setShowModalReqBooking(false)
                    }

                    }

                >
                    <Modal.Header closeButton >
                        <h3 className="mx-4 text-center fw-bold f-1">OPPSUMMERING AV AKTIVITETER</h3>

                    </Modal.Header>
                    <Modal.Body>
                        <div className="row sub-category-container-recommend2 d-flex justify-content-center align-items-end" >
                            {
                                widget.map((val, index) => <div className=" my-3 col-md-6" >
                                    <div className="d-flex">
                                        <div>
                                            <img style={{
                                                width: '113px',
                                                height: '101px',
                                                marginRight: '13px'
                                            }}
                                                src={val.images && (val.images
                                                    ? JSON.parse(val.images)?.[0].imageURL
                                                    : 'bookingImg').replace("{baseApiURL}", "https://funtlers.com/") || val.imageURL && (val.imageURL.replace("{baseApiURL}", "https://funtlers.com/"))} alt="Pic" />
                                        </div>
                                        <div className='searchResultContent' >
                                            <small><b>{val.name?.slice(0, 28)}{val.name?.length > 28 ? '...' : ''}</b></small>
                                            <small><b>DATO</b>: {DateFormat(val.addDate)}</small>
                                            <small>
                                                <b>TID</b>: {val?.fromTime ? val.fromTime : "N/A"} - {val?.toTime ? val.toTime : "N/A"}
                                            </small>
                                            <small><b>Antall personer</b>: {val.minPerson + val.totPersons}</small>
                                            <small><b>Pris per person</b>: {val.price || 0} NOK</small>
                                            <small> <b>TOTAL PRIS AKTIVITET</b>: {val.price * (val.minPerson + val.totPersons) || 0} NOK</small>
                                        </div>
                                    </div>
                                </div>)
                            }
                            <hr />

                            {/*<h3 className="mx-4 text-center fw-bold" >OPPSUMMERING AV KOSTNADER</h3>*/}
                            {/*{*/}
                            {/*    widget.map((val, i) => */}
                            {/*        <div className=" my-3 col-md-6" >*/}
                            {/*        <div className='searchResultContent' >*/}
                            {/*                <small>Aktivitet {i + 1}: {val.price * (val.minPerson + val.totPersons)}</small>*/}

                            {/*        </div>*/}
                            {/*    </div>*/}
                            {/*    )*/}
                            {/*    }*/}
                            {/*<hr />*/}
                                <h5 className="mb-4"><b>Total kostnad: </b> 
                                    {parseInt(widget.reduce((sum, val) => {
                                        const total =
                                            (val?.price || 0) * ((val?.minPerson || 0) + (val?.totPersons || 0));
                                        return sum + total;
                                    }, 0), 10)}
                                 &nbsp;NOK</h5><br />
                        </div>

                        <p className="text-center my-3" >
                            Ved å klikke på knappen under, vil teamet til Funtlers motta en kopi av den forespurte bestillingen din.<br />Merk at bestillingen ikke er godkjent før du får en bestillingsbekreftelse på din e-post.
                            <br />
                            Ved å sende inn denne forespørselen godkjenner du våre{' '}
                            <Link
                                to="/vilkar"
                                style={{
                                    cursor: 'pointer', display: 'contents'
                                }}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                vilkår
                            </Link>.                        </p>

                        <hr />

                        <h4 className="mx-4 text-center fw-bold m-2" >TILLEGGSINFORMASJON</h4>
                        <textarea
                            tabindex="1"
                            value={text}
                            onChange={handleChange}
                            name="text"
                            className="text-box"
                            placeholder="Fyll inn eventuelle forespørsler, allergier eller kommentarer ..."
                            rows={4} // Adjust the number of rows as needed
                            cols={50} // Adjust the number of columns as needed
                        />


                        <hr />

                        <h4 className="mx-4 text-center fw-bold m-2" >FAKTURA INFORMASJON</h4>
                        <div className="form-group">
                            <div class="row  d-flex justify-content-center align-items-end" >
                                <div class=" my-3 col-md-6">
                                    <div >

                                        <h6 class="fw-bold required">Bedriftsnavn:</h6>
                                        <input
                                            tabindex="2"
                                            required
                                            type="text"
                                            name="companyName"
                                            value={companyName}
                                            onChange={handleChange}
                                            className="form-control"
                                        />

                                        <h6 class="fw-bold required">Org nr:</h6>
                                        <input
                                            tabindex="4"
                                            required
                                            type="text"
                                            name="organizationNumber"
                                            value={organizationNumber}
                                            onChange={handleChange}
                                            className="form-control"
                                        />

                                        <h6 class="fw-bold">Faktura adresse:</h6>
                                        <input
                                            tabindex="6"
                                            required
                                            type="text"
                                            name="invoiceAddress"
                                            value={invoiceAddress}
                                            onChange={handleChange}
                                            className="form-control"
                                        />
                                    </div>
                                </div>

                                <div class=" my-3 col-md-6">
                                    <div >
                                        <h6 class="fw-bold required">Faktura sendes til:</h6>
                                        <input
                                            required
                                            tabindex="3"
                                            type="text"
                                            name="invoiceSentTo"
                                            value={invoiceSentTo}
                                            onChange={handleChange}
                                            className="form-control"
                                        />

                                        <h6 class="fw-bold">Kontaktperson:</h6>
                                        <input
                                            required
                                            tabindex="5"
                                            type="text"
                                            name="contactPerson"
                                            value={contactPerson}
                                            onChange={handleChange}
                                            className="form-control"
                                        />

                                        <h6 class="fw-bold">Faktura merkes med:</h6>
                                        <input
                                            required
                                            tabindex="7"
                                            type="text"
                                            name="invoiceNote"
                                            value={invoiceNote}
                                            onChange={handleChange}
                                            className="form-control"
                                            rows="4"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>




                    </Modal.Body>
                    <Modal.Footer>
                        <div className='d-flex justify-content-center' >
                            <button
                                tabindex="8"
                                disabled={isDisableCheckBooking()}
                                onClick={() => {
                                    
                                    //reqType === "pending" ? handleCircle("pending") :
                                    //    handleCircle("saved");
                                    handleCircle("pending");
                                    setClickBookingRequest(true);
                                    setShowModalReqBooking(false)
                                }}
                                className="btnOrder w-100">FORESPØR BOOKING</button>
                        </div>

                    </Modal.Footer>


                </Modal>



                    {showModalDone && !onBookingUpdate && <div className="fade modal-backdrop show"></div>}
                <Alert className="col-md-5" style={{
                    position: "fixed",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    zIndex: 7000
                }}
                    show={showModalDone} variant="success">
                    <p className='d-flex' >
                            { showModalText || 'Takk for din booking forespørsel. Funtlers teamet vil besvare din henvendelse Ila 3-5 arbeidsdager. Dersom du trenger raskere svar, vennligst send en e-post til contact@funtlers.com direkte.'}
                    </p>
                    <hr />
                    <div className="d-flex justify-content-end">
                            <button className="btnOrder" onClick={() => { setShowModalDone(false) }} variant="outline-success">
                            LUKK
                        </button>
                    </div>
                </Alert>
                <div
                    aria-live="polite"
                    aria-atomic="true"
                    className="d-flex justify-content-end"
                    style={{ position: "fixed", top: "65px", maxWidth: '100vw' }}
                >
                    <ToastContainer position="top-end" className="p-3" style={{ zIndex: 1 }}>
                    </ToastContainer>
                </div>

                </div>
            }



            

        </LoadingOverlay>

            );
}

export default OrderPlan;